// This file is auto-generated. Do not edit!

export default [
  {
    id: "0x1791920d6bab15c5f529d278b72aecb79c52ceed412ded44526d7198227e652e",
    name: "wUSDM / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x4Eb7916682F59E25F824d8CE2a8F2318319296F6",
    loanToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xabba004839c8ed6bd6f9b7ba61c7e6c4ae970530a6c4852d8f1f3aeed50888cb",
    name: "wUSDM / cbETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x308b4C07e4FD4677F8d710660027d6D03845Cb83",
    loanToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
    collateralToken: {
      address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
      symbol: "cbETH",
    },
  },
  {
    id: "0x7fbf113321c898cbcff456160fe8f32b5507df1eaa611ab0b3330fc90d7f18ce",
    name: "USDC / wUSDM",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "965000000000000000",
    oracle: "0x8255593A4d01623BCA9CD882ddFeb723586f412D",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
  },
  {
    id: "0xe4977cda642989eb903f219d8fd6168d2f8d8211e3d8617dca45bc5e66993fda",
    name: "wUSDM / steakUSDC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "965000000000000000",
    oracle: "0x8E04B06dF8B891fAe61B00CdB26CDe028442AE09",
    loanToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
    collateralToken: {
      address: "0xbeeF010f9cb27031ad51e3333f9aF9C6B1228183",
      symbol: "steakUSDC",
    },
  },
  {
    id: "0xaf9d03bf28fdf54be154e4f307e2e6ab8a6c182e97d6fc227c2fdf26f89dbc22",
    name: "USDC / wUSDM",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "965000000000000000",
    oracle: "0x32B923ff5C9e20dc5dF15bFA4516447D66B6D666",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
  },
  {
    id: "0xb95dd880d553f5d874534d66eb337a4811608331768c2b208440dfe0e6d901fa",
    name: "wUSDM / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x06aE266A252E2ee96A4c05cFDa8163ED94379a5a",
    loanToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0xfff517c4ca7bb55befaacc7a17633d1e95dc748df37b92304fdeb019a17214ba",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xb5f856E6978b009A75f8E5197e7cf29Bc822181f",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xffd35206a772174c04f599e4034a2f132fc3f7a462ca732affcea92136716573",
    name: "msETH / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "945000000000000000",
    oracle: "0xaE10cbdAa587646246c8253E4532A002EE4fa7A4",
    loanToken: {
      address: "0x7Ba6F01772924a82D9626c126347A28299E98c98",
      symbol: "msETH",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0xffa0eff2765183bccae9deed2431c80b14cfe6768ff57b6bf3a47ef0d56d25b3",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x429a118dda93b3b7bc5763087cE4f1fAB441C1e3",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xff70c918f0154620b3414b9c7c15af91ef08dd3fb3dae5e7b67b588c22ee776a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xCf7D5505BA934F1A0Aa803F9bcbe99Bf407cd0D8",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xff607b63cd1cc8495cecd57adf85814ef0dff34271f5967b662fe3677190a057",
    name: "USDC / RST0001-UAE-DUBAI-BAYZ BY DANUBE-01",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0xd22B48Ad1c25176cfB6A5e4aC3C0b7E898D43Be4",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xDbf9F254C365ABe4294884d1249c7a2388f70911",
      symbol: "RST0001-UAE-DUBAI-BAYZ BY DANUBE-01",
    },
  },
  {
    id: "0xff3a3e95d20556f0c6ebd42e986abe8b69a48b13ba99a5ec9d53fe2631340073",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x10A4af6Ad3b02b5c512526Ea1B8b0dfd6a276B39",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xff32ceb7ada6fda56eae4fa4302b6fd261c95943e4fae36eb79c8881e934d351",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xFe07dEb1CBcc78e86f397e03e8a2bAA6C6a7775B",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xff205c6f340030f914c9d58c50d5bb8a796ba6c30c9b23daaea4a71888bef602",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x2FD1f1AD30c81D769A3E9a123F4D5bb6939dd18A",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xff0f2bd52ca786a4f8149f96622885e880222d8bed12bbbf5950296be8d03f89",
    name: "USDC / USR",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xa40E4a5C4ff8ec8ae05648A4F34E02CeD8Ae9EFB",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x35E5dB674D8e93a03d814FA0ADa70731efe8a4b9",
      symbol: "USR",
    },
  },
  {
    id: "0xfe989bd602697d36774182c015bf16f1c55e0924d5e816729ce194555ab2f21b",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x03289F739f630c8D7c2eb581Cf378121128AEF48",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xfe74bfd1e9d758f8c4058f1bf3fdbe6d654e01a9d18aa2fe8fea86ed2d35576e",
    name: "USDC / LBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x19b1739D47774556086296037946046938805766",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xecAc9C5F704e954931349Da37F60E39f515c11c1",
      symbol: "LBTC",
    },
  },
  {
    id: "0xfe33d630bc1a47f732816e55b7998e1c9cd9ccd71bf355cf1672e7d155d4a2ed",
    name: "USDC / reUSD",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xc3D040FC3dBB16Ac400b2a469cA3f8A92b01e47c",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x7D214438D0F27AfCcC23B3d1e1a53906aCE5CFEa",
      symbol: "reUSD",
    },
  },
  {
    id: "0xfe20a28bc11785a62002746e65a2cc5690012d35daac8fca1a224575ab04bee4",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x93E3b1A6Cfeab05b6B08b1B1eaB0C814EB537527",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xfe1ebd9553e3b0fcddc32ec3aa31709d88c802e70f497a01445ef05772d2d843",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x7037bB64743790BD0Ed40E2D036631b286EA3314",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xfdfecf85a4dd90a7637ae2aaf28b35061166f0e62bfc714c565eed9f7e959783",
    name: "USDC / cbXRP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x031b2EFC8d70042Ac8d9f5c793c4149eC4b60fdE",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xcb585250f852C6c6bf90434AB21A00f02833a4af",
      symbol: "cbXRP",
    },
  },
  {
    id: "0xfdde1b6d1a2d091a7671f40e05282e0168726d9b991d30d67242f70d15bb2d69",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x0A8C46EcFa05B08F279498F98B0613AcD77FCF94",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xfd0895ba253889c243bf59bc4b96fd1e06d68631241383947b04d1c293a0cfea",
    name: "WETH / weETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "945000000000000000",
    oracle: "0xcE629400c6AEdb64f087CAC40Ae6a382AEEef490",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x04C0599Ae5A44757c0af6F9eC3b93da8976c150A",
      symbol: "weETH",
    },
  },
  {
    id: "0xfc8ffacd2054d248ad96b0ef00ec7ccf389b1da6532a7527dc2fc13d88327f3d",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x118d934cA163EED5609aD1A1f5598d623188b81E",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xfc77f828545a17e966a4c5e3fd2d8b8cd449a1c3d0941dc323e898da8facc3ad",
    name: "USDC / OSAK",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x1C7edA01201Fd2427c10F5144606777f2c5ded7b",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xbFd5206962267c7b4b4A8B3D76AC2E1b2A5c4d5e",
      symbol: "OSAK",
    },
  },
  {
    id: "0xfba818b7740e28ff107d7b1d0ec6e94f699f4eadf9ef3cbed2e723043be666fa",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x055228d00AccBf02fe90c221C255EbADce0DaA44",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xfba4338b51c9d9b00023dd66a7e62a2d58b815ca15a998b49771591a815a41b2",
    name: "USDA / cbETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x826943587FfdAA11c3BFd730644d6dc299E51278",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
      symbol: "cbETH",
    },
  },
  {
    id: "0xfb9d3c2c40a990792d6f69191aa1be7143bcd6f6c787b8115f261b9fc6f2b989",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x8447ECfC03225F76D42D06681B03d2fd9DCb4737",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xfb865bde4eceef057c08c1dd878d3676f7345cfab0b273946d44058efecc3045",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xbd88B4211f4D40B17a5a82118f3dd778608f97aE",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xfaf2ee1290e3ebc0e9d9502cf0d52f312a23c463083f418c571f1919fa97bc1c",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x7eeFe4c35C56dAb507F9823bE0d8712fcF52ede9",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xfac9258417d1e4901377c63dca0a3d3a273ace7ff046bdfb360b3e52e1197091",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xD01F20db2F2E7388e02f899F19e5d6383ca1D2d1",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf9ed1dba3b6ba1ede10e2115a9554e9c52091c9f1b1af21f9e0fecc855ee74bf",
    name: "eUSD / bsdETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xc866447b4C254E2029f1bfB700F5AA43ce27b1BE",
    loanToken: {
      address: "0xCfA3Ef56d303AE4fAabA0592388F19d7C3399FB4",
      symbol: "eUSD",
    },
    collateralToken: {
      address: "0xCb327b99fF831bF8223cCEd12B1338FF3aA322Ff",
      symbol: "bsdETH",
    },
  },
  {
    id: "0xf9cea8e3a09fab2de7ab3c7c61e55cd213295490de4d5b809b7bb8cead0432bd",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x764c5839589928C1b6679782273049E00768b416",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf9c45cc0b562d0e407b4bc3d855b040969241caaaa04bb2d97223931e151325e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x40e4456c9F7717469682A7582C04246EE4feDfF5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf9885ea4ad1aa6b89a1b6fa68bba2ca9be8b869446de3f0bd35ef764acd94f69",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xA5bfD46E1B0579DC8bd783939fb56Ea6F66DabfF",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf948bb6664a54796da4678608d22b929ae7205bcc563f237803442732f2b85ff",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xa143824D072725907905BB589d2B3e1E6294e791",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf909350a7ae5a1ccebeb563a69c8b6426f1773de9c4749098d53388cc0e859dc",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x0E56EeB12F4a87a58635305F3a9260334Ab09967",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf8e3b2b805d32a964acf65cd97b23ee7d20b551003ca56269d1bc2ce76deb0db",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x514cf0f857b721af8B3F0EbC86F064b12A08012a",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf8b9786f2f2163e7d618cd8eaf5c0380a1af22424184356dfdd1912f18cb069a",
    name: "USR / cbBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x2dD12a50b4f60e09Ab1b6B42fBcD241AEf36C78e",
    loanToken: {
      address: "0x35E5dB674D8e93a03d814FA0ADa70731efe8a4b9",
      symbol: "USR",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xf888204c18554891c8beedbc1e8543f9cd0cfc2f30d29adc30376aaa38714bdd",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x4D362027bAaA2bbf09BC86a732E56d7570591Cc8",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf8348da81c46bb116bf9b4e903a8bfb91cfd91820ca036f5014bb0bebebf96b6",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x3a047e4bC76014469e7381F4B0Cc973b5a5581E5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf818d780f42e7b72c72b6c59bd1602991aae6add3bcc5ee1f7160ac256095b86",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x7ACb841f117c81F88c2244e26D1318C17c0E450F",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf7f6f41bd78941089ee55ca80c20fe51ba987c8f6a2397a505ab912a39091a88",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x47339641bCd6Ed8E3643f1842CffB333Fc5F580e",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf7e40290f8ca1d5848b3c129502599aa0f0602eb5f5235218797a34242719561",
    name: "EURC / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xa54122f0E0766258377Ffe732e454A3248f454F4",
    loanToken: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0xf7800f47af8115bd204f74f35b6bf362354a5ca62a28f2578b6a978923acf3cf",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xB9b8616004B333493Aba3B58Add5c3a214C8b2f9",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf761e909ee2f87f118e36b7efb42c5915752a6d39263eec0c000c15d0ab7f489",
    name: "MAI / cbETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xc3Fa71D77d80f671F366DAA6812C8bD6C7749cEc",
    loanToken: {
      address: "0xbf1aeA8670D2528E08334083616dD9C5F3B087aE",
      symbol: "MAI",
    },
    collateralToken: {
      address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
      symbol: "cbETH",
    },
  },
  {
    id: "0xf75039eaf72ebd07c5f3c73de43de8ce0df0db8fe5be9cbccf1680c301552ebe",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xdF4d0F3Ba1e55d579D9cB42B7B034579AA5b26b8",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf737bf9f4897d8b00f7f54a9628bed28ec7c0d437713fced84258ae0ce33bcb6",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x73d3999abeA6abBe6B238C9821D0D1f0B626972e",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf71fa5fa642e3976c491195a5542ec2ae065ba0b741300603e779250c90e957d",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xD2FF25C13f3E5084B46ab62104379Aa7a898F90e",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf70baf4f5ddae816b7e60de46dfeedf884c3ae4a42be5d4c7369404956c135ce",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x78a5C078bbdfa2C7E147c6A870091e46D689E0e0",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf70656b4dc631f2d542513dff0fed6ec83d9277bd1ef4d77d94a1ecff1ba0039",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x15CC9e0B386c2127F88E20fC00431588d2B90344",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf68e50fdff42ca6b6eaec52739752c85b219e303e48c8413b6590b0f475c2c24",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5c82066A588D875030925078D34e9BEa26099917",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf6382fca54c82ba1420aec053c85d546cb23f40d10028ee9458f644e8babcbd2",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x824746468a4cbe8B236c4d8f6240f32257108b93",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf5ee5667190ad5e6883f3e6ab0526f1332df4d4b5b1e94d9c26d9b21a120506b",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x31DbA3e209539D5FEC740a58B1d30e0aC694Bd86",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf5e1cc5f72227ce58976657c134a2e6e7fe8ad8024ff4ca892900bece59ae55a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xcEaa35D5F3C145d5450163CFd49AAaDa94152bBd",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf5bd3fc75c580c734f2e1c3116f8dfd984e7ee43b2401aa4f55f05e2d6347821",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x1C6FD6824AE1885f6D0F03F668F09C94Ed8e8f37",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf4e2e64075e6235d855c6ea8e3656cf774409928cef717df939c634ce00ca499",
    name: "USDC / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x109A100c88096b2c00275A516A1545d67b92cD77",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x109A100c88096b2c00275A516A1545d67b92cD77",
      symbol: "MDLP",
    },
  },
  {
    id: "0xf4dc0e5b64801ad0b2dcecf742984566dc20a05d972421af20943c5f100a7925",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xAdA1128f948e5F53Ae89bAeBE73CcA8D9961388a",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf4db232da593ccc0825a7caf8618528607cc7943f0d3419ad1599c5d4b4b7c6d",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x4f5942643d40D2c11E0D1b5f3AA9DBCf039a06d6",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf4d219ed36d38634f89c992a1bc50e73324f9c5c663d29d089d3f8aa74c700f3",
    name: "USDC / aprUSR",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x53c07Aa44B68FF62C2B91fa7F9aF246B57F8b5e0",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xC484D83F667b779cc9907248101214235642258B",
      symbol: "aprUSR",
    },
  },
  {
    id: "0xf4254bb9db550a5e61302b0db6d90f29ceda324496e9783b93d7da054bb33635",
    name: "USDC / doginme",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x68a8F1f81F74F4d77e8E329C059171476a2e879a",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x6921B130D297cc43754afba22e5EAc0FBf8Db75b",
      symbol: "doginme",
    },
  },
  {
    id: "0xf41ad22e883e0b31d1a4a850633dd972685196fd62e6b68198f5ee91a0576759",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xe6f1Db916c557024fA87F5e4A79Fd81e85F38720",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf39299c278770d24b3a4efe0101b6c12e82d01fa9fffb237ef3108abce17d59c",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xeA9C01b7a9696A84B95470D3e340A355B52DFDcf",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf389611d338c0987a4c40d7ef956c12914bf9b52f1c406159237172b069005c2",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x3045AA327b38286D57524EE6fe040BDAe1456D50",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf33475746fe05d1806b108c6d1f6a0c0853424b100c535ada459e428e2a7ee6c",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x695B64c41420e547ec0625FC587075286C06C0AD",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf2be0e79756ea42a292a4862eb818f3545ce0dd83861be8958073cfa6d3dbf52",
    name: "USDC / MOCK",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0x0065801DBe91B7E2DbDE9F4d1c0073Def76663Ce",
    loanToken: {
      address: "0x5F5913aA5E21b1bE4F2F4855da708E3F8dEC1447",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x66b2b7a8532d1CaF54ac95E736e0d9034C76523D",
      symbol: "MOCK",
    },
  },
  {
    id: "0xf2a59ad1aec67664c564cb33c33538ab41372363204ce2bdcf00900b7d28c6ab",
    name: "USDC / cbADA",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x35D87a743D1F2f7CaFb42D855dC1c5Df857Ce45f",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xcbADA732173e39521CDBE8bf59a6Dc85A9fc7b8c",
      symbol: "cbADA",
    },
  },
  {
    id: "0xf2a4482a45a67072de581a6dd81adecf00625980afe28655496b524198bbc282",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xe063EbdC321a7f42985af0F23fd4435c4A198B34",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf299600a953586aade3ca502e482e6b7d276ee3fbc44270a54325323b15a62a1",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xE6254907544CF07BB1100e51743460D6502019B8",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xf26c0ccbc9b9c4e337b8ceb4dfa6f10f491d76f892796328d72cd5d89c9bc6d4",
    name: "USDC / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xD7A1abA119a236Fea5BBC5cAC6836465cbe9289A",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0xf26b06079ff283185fac4c45edc48e9cb3d088d857e5072d0805213681dd254e",
    name: "USDC / MOCK",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0xC3966ceB04F0fb3837abD50C104e09d5d52eE4fD",
    loanToken: {
      address: "0x5F5913aA5E21b1bE4F2F4855da708E3F8dEC1447",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xA2E865f655Fa8678139eB094f099Eb7f955627C4",
      symbol: "MOCK",
    },
  },
  {
    id: "0xf24417ee06adc0b0836cf0dbec3ba56c1059f62f53a55990a38356d42fa75fa2",
    name: "USDC / ezETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x1BAaB21821c6468f8aee73ee60Fd8Fdc39c0C973",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2416092f143378750bb29b79eD961ab195CcEea5",
      symbol: "ezETH",
    },
  },
  {
    id: "0xf1f744a5694089274be272d2b62f58d1384a29da7c0b247c7c07c2806b85c22b",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "945000000000000000",
    oracle: "0xFEa2D58cEfCb9fcb597723c6bAE66fFE4193aFE4",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xf130a11e2b2861059b26c64856ca5ec3419c6269a686e906c5f280e41df89f21",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xDD6Af1478Db5806279da77490D0252E308a7BbeA",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xf10437266b9dd52751bd6255e15cccd0cdf5c75b58c1a3e2621130c905cd8ed9",
    name: "USDC / cbBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x663BECd10daE6C4A3Dcd89F1d76c1174199639B9",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xf0d126574df486a280f28ecaff5ec6a86ec360d33c6ac3213f9f4333b1877c28",
    name: "USDC / WELL",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x1E0E8bcFb5FFa86749B8b89fb6e055337Ba74A39",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xA88594D404727625A9437C3f886C7643872296AE",
      symbol: "WELL",
    },
  },
  {
    id: "0xf0adbe742cbc8cf692d4c855dc2f184fd9e56bb11f8ac3467472748a03e61cd2",
    name: "USDC / PT-wcgUSD-18DEC2025",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xDed001cAf296Abc25671D7ec5b4d03Ea4650936D",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x6aB33A86B72E1d343730c6030FFdA992CD43035e",
      symbol: "PT-wcgUSD-18DEC2025",
    },
  },
  {
    id: "0xf06f2939667898f3a496887ce875ad872ffa53178c7cd9bea43702b130b27eb8",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x0Fb80A0bD2AEceF2746F0997D27f59e27e2155E5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xefffd0b3d36684f3efa1dffb8ec772459d96bdececf557b7957516ebc745dc93",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xB33C18C036262577348DF904d2F1AEE2db39A151",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xefeb340a8f1f4dda56a17fba3385a8d87911e441a307f26801fd162a8cd8be6c",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x620ea7c9099b59C68DcB890e8e51265b9aDc20eB",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xefb576606581c5ac9f731d80cb453519d06776fdc1de51d6230d180d74890c3b",
    name: "EURA / cbETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xA479f84993855b6cA54Ec1fDD65D5a82B75Ea48f",
    loanToken: {
      address: "0xA61BeB4A3d02decb01039e378237032B351125B4",
      symbol: "EURA",
    },
    collateralToken: {
      address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
      symbol: "cbETH",
    },
  },
  {
    id: "0xef5969a6c145f8fbf1cab70f8b54f3801e0a9741d06c1401fadf6ec41b6c83ed",
    name: "WETH / LevETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0x54c13915694dcEBA28231D44b8B2c671Df7ad206",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x091A5A1e3aa8B96Ab0FB0bC217F5E60Ec4C611a0",
      symbol: "LevETH",
    },
  },
  {
    id: "0xee2e837031460ddd552f208a9af9188225e4e6e5f777435e5ef992bee5ae765e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x0810426906dA871053258fbD60B0f3da2e29b2C0",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xeddf88df93a8135615e7ab86aa856a5a9373f8597f8edf7387e6e6e9fff979e0",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xE53e9A5C42B631a5eBdC9670cf53B3770A2316AA",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xedbec7828f77cd07fcf6402e93ec66022f5cf77038b23a9da4ed4869cb657bcc",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x98253995E087001988C48ebb7c72cF80987162CF",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xeda13592cc669d017a018bfb4f8c1967cef2173e81cf6a060845dc7330e1c526",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x7C1210e6b735bc2944792D33b6Dcb0Dd2F1494f3",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xed2460c6d4dfb5ee1aeb8e7dbf54c892df76206a0d1cff2d60c3d9a08920e161",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5ffB3F78Df189A06Af973f648cc2B7Ec02E49e92",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xecd7a1890c308928e52f672285191f23ecde8350443ed9b41931cf9e10e96fb5",
    name: "USDC / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xAe7738a415c7c9E05D21d3f8117273bfD839671F",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xAe7738a415c7c9E05D21d3f8117273bfD839671F",
      symbol: "MDLP",
    },
  },
  {
    id: "0xeccbd4e98b5b308b4a564b6c925c1fc6fcd1f441704e004a8363d68256c1a057",
    name: "BRZ / USDC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xAa02469Ae653BF969225796b09A56CA50384355F",
    loanToken: {
      address: "0xE9185Ee218cae427aF7B9764A011bb89FeA761B4",
      symbol: "BRZ",
    },
    collateralToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xec4f8c468338df519342d69ea1470f6407bb0caec987d44a96bf117335783487",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xfEF90B98A4250EF6CB28CBe2D6cAbf68132A0c22",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xeba7ce44325c04f67512757c8026719604d2767a4f0f6d0c766802ace7882484",
    name: "USDC / RXX",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0x23638f560FBEca07923180eff1d420Cc7adEFb1c",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xE2cB1A81A25285972b0eB34988124eDf4705F2a2",
      symbol: "RXX",
    },
  },
  {
    id: "0xeb7c6b329734bd3699ce8f6fb2afb07ac099d2e052b1c028b06469c58ba74c5d",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x340E059afe4C986752C21d4ec07ad6902bfFD6D4",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xeb6b1987bd0b1fd47d13dfe7d32367c5be914dfa1b4d8c8ed09e9d34898580be",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x7cfbC38381abC0C10af8C172369bE67E7389e1A8",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xeb24455f781d4d5961fcffad0f3ddcde02cc881ab2b5109d6622f50618a8b909",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x76915d7f508654536Dd11db16fe4186dEfC5a244",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xea494c7c660184903b4cbfadfd6d252cc68b71de244d00ccf3064e1acf9bb7cf",
    name: "USDC / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xB1B893e0b59e4539Ba814082DF62dA7D1892f075",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xB1B893e0b59e4539Ba814082DF62dA7D1892f075",
      symbol: "MDLP",
    },
  },
  {
    id: "0xea4809625c39cd3e937b72474899e301b661f64cb08fe948a0ccf6427fb38c07",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xC8bfD8aCeFb9b86460CA144Fcdb30357dE9A7647",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xea347d3be87d545dc5549fd4e45a5aabf183bb9c130ddeaec9f030f066391f4e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x8a7D07DdC6FE3A7a61CF51f9cF1ffE1B5E16e370",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xe9e3bec9b212a2d0e180140de186635f948aacb9c90249e744934bad484b888f",
    name: "USDC / wstUSR",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x17E3a630902C29Db3BE0EF300Fd6fDd48B2d41b7",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xB67675158B412D53fe6B68946483ba920b135bA1",
      symbol: "wstUSR",
    },
  },
  {
    id: "0xe915843d1b42dc337d341cd34c32bd01e725ec6d1b47357383833c4f212a9b6a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x10DB8D399FC62CB4470F0ceFc4d4e13FfbC58B1A",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xe8ca67942bb2e9cb1eb6b77e38826d0bfa22c46dbe1a60d3f99e7d526f3e93a7",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x16089F3627F596Af775825e42247b5dB9349F831",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xe89b68fbe77b6433bcf0f22fad666555fd4376ef016876c0455ea961ae48626a",
    name: "xUSDz / unknown",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "945000000000000000",
    oracle: "0x523d465710326D13b803CF1cF30Ac34e08B65b9c",
    loanToken: {
      address: "0x0A27E060C0406f8Ab7B64e3BEE036a37e5a62853",
      symbol: "xUSDz",
    },
    collateralToken: {
      address: "0x6eE1955afB64146B126162b4fF018db1eb8f08C3",
      symbol: "unknown",
    },
  },
  {
    id: "0xe862e518f0f0ef2a6d773ee47203e781407a92cfcf54c944f6176a74527e7c65",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xAeE92D263B141154Ca747475B968e1464D6Fc394",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xe85d89c09e8ba47cca75c882714f50af6253f9fcec1f57f5566d7f38376ce305",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x16c52Fd899ac258E62E6Ac0b700684Fa7E4c966a",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xe8461b945918fff320edcad5843409007e1def06fdfe2dc2963891486e168c58",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x94cfF8cEbb0544cE1eFb65307e0CaFA8a0dfD756",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xe8296f7271e0199b79d29c0e214f9c0eae334ae63e29bc09d9c76b6f0b24691e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x298c07ece387f7A660113025f3bBa7c40E9f4bf2",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xe7990d9bd9500c01a50ccee4756924abab8fdb66dfcad4ecd1767ee3a98e485a",
    name: "XSGD / cbBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x690Ac57864158Aa3Cf93F0f70d77dB9A1EE0960F",
    loanToken: {
      address: "0x0A4C9cb2778aB3302996A34BeFCF9a8Bc288C33b",
      symbol: "XSGD",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xe73d71cacb1a11ce1033966787e21b85573b8b8a3936bbd7d83b2546a1077c26",
    name: "USDC / cbETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x8370D60541403B5Cd42966D6a7d6d1239bd50ed1",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
      symbol: "cbETH",
    },
  },
  {
    id: "0xe713d18fffe741b994e37e61dab99e99fd1bd398277c20524da5daf678b1e642",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x4F73D88C7F4397E30610579640606356E3587d9f",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xe6dbb2956210e180e7afb3063f78220012e4eb68cda792bd2dafd76922ff0f28",
    name: "USDC / yUSD",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xE930D2f8cFa6b4FF39E9B728F58fD9e993164309",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4772D2e014F9fC3a820C444e3313968e9a5C8121",
      symbol: "yUSD",
    },
  },
  {
    id: "0xe6c40fc546080821ce726b65e2877af66f8fdabd42e395ace12a4f7a96351c24",
    name: "USDC / MAMO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0x800e0d168a44D864204dE811945065fc59935ab3",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x7300B37DfdfAb110d83290A29DfB31B1740219fE",
      symbol: "MAMO",
    },
  },
  {
    id: "0xe6ad45726b4e6974cc4b486c72f49f9ad0e41723875d2b567b5b6df4455e4ff4",
    name: "wUSDM / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x1816415F529E7a851674E5Ae6dB5b0C2087fbEBb",
    loanToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xe689ed4af7a0d66865028d3ee03ed55edcfce21cf1b7f5caf2fcc83bc9269bea",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x528b8586444c3f5F853F9811d3E7930Bb77A57e1",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xe63d3f30d872e49e86cf06b2ffab5aa016f26095e560cb8d6486f9a5f774631e",
    name: "USDC / AERO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x96F1485DAf396c2ab7e53DC76d7B330143Cb2269",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x940181a94A35A4569E4529A3CDfB74e38FD98631",
      symbol: "AERO",
    },
  },
  {
    id: "0xe62465bd005557cbde30ec7201fc3289bb41a18aa1a3893309d932172bea1a55",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xFE368BDb17456CDf8f34d61B43a541cB5D4221B3",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xe60bae6dfe0966cd8d859d06a2fe0568b26c639bd935aa628577d5db3d454e95",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xF4C99de2cf56764A0cEe9F2c398E01488cFE76A9",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xe5d34dba7fe385499bce7a98f96efc186831cf3d052400a4bace5125ee63f686",
    name: "jEUR / stEUR",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xEDd96B8553DaE7fF443e1aB829448d450adE5B68",
    loanToken: {
      address: "0x4154550f4Db74Dc38d1FE98e1F3F28ed6daD627d",
      symbol: "jEUR",
    },
    collateralToken: {
      address: "0x004626A008B1aCdC4c74ab51644093b155e59A23",
      symbol: "stEUR",
    },
  },
  {
    id: "0xe563d85d659dcd9b1a0fbe8dac23aea24f5e7365d73358168b0b06757685b69a",
    name: "USDC / WELL",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0xC940a4633E4443C43Adbf419339b854A70043373",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xA88594D404727625A9437C3f886C7643872296AE",
      symbol: "WELL",
    },
  },
  {
    id: "0xe55ec78b5a447297ab55ee5b595a3273b9e417715af59025e6670a6b4dcaca55",
    name: "ntUSDC / snTST",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x887FeA630Bbe8D3B6a15217ef8CEB31b98c2ac65",
    loanToken: {
      address: "0xEC7De4956A4569C2a1D171e4dD115a611c8e9eE5",
      symbol: "ntUSDC",
    },
    collateralToken: {
      address: "0xd73F8115Cac5B6817DcC143f3797a2Dc3650181b",
      symbol: "snTST",
    },
  },
  {
    id: "0xe55561ff4259455e9de9af7b217b17b07e6a1ffdbb5b738475eab61ba82b3f7e",
    name: "EURA / cbETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x8301c2F53c26DcE5de0bEE388938fAf9B7C30f42",
    loanToken: {
      address: "0xA61BeB4A3d02decb01039e378237032B351125B4",
      symbol: "EURA",
    },
    collateralToken: {
      address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
      symbol: "cbETH",
    },
  },
  {
    id: "0xe52c998282d31cb364e248251440a694c637f70fbcf16941dc55a19133b5934e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x24C3a22038F92A6abb8092E751B6c38759000F6b",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xe513497368ff77ce376b8fa7d8338511786441e1ce7dadec1ba0fe231bd9a25e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xa6aff026885e8BE6b6D1259AeecD0e7400cd3641",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xe4fbd1c70368debe3577b3c7cfe26c41732b35ffc61629cadbb02a0513adf9c6",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xC9c484698Ebb1FAe875c6c8b3aD560Dd189E27B5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xe4ef8bffe09f77d342894978b17b0f4e77b978f9140c9eb366584d3998faf1e6",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xaa062A5eEd834fD6191BE5A0b9d0c277D9ee49f7",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xe4b000e45b3ce992068be78c987f4802855a16512499d0214dfc47db91c4c5a6",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xb09ff74d959539D19E91238a198c8b07f409F6C8",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xe49d15cef89f90d7b08a80e3d1aa233a05527e1c31ee3943442db2a75a4163a9",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x0E5Ee38454707560143CA756A79FB453baeB947D",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xe3c4d4d0e214fdc52635d7f9b2f7b3b0081771ae2efeb3cb5aae26009f34f7a7",
    name: "WETH / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "945000000000000000",
    oracle: "0xaE10cbdAa587646246c8253E4532A002EE4fa7A4",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0xe3c46063cbec0b9eefe679ed528ab70135fa7ef0761ca99d3e2e3563a543bf0f",
    name: "wUSDM / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xA2E749c3190B3afe593A259EA61D4aFDCCC40b07",
    loanToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xe3b5935e1f965f0667ff749008b3a8dc73ebab75082ced1a7b5a6dbcda966da0",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x75E6Ae07C995B3cF7FB5Ff03B2ffbd8C962780EA",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xe33caf9e2234b13d3f83a748be2bd2b68798d49562720078546b7280ce07a792",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x215A60eAC17a798A27CF32837b2Ca74244baf0f1",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xe32a48ea5de78c24c05ace4c7d847e687c586232b566138546dcd2a25da0ce46",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x7FE41Cd5b1c5D4200C31227b8f8a7DB9bA2bec39",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xe2f44a13e2cf023d842c2835cc7e3ba1e4bd0affb085de28309b988b27577aaa",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xa47Ed794e5C25621540076063e677cDe4277007F",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xe2c135d41e5770112de02609b6554cb809869c7a4291869c0072883afc5ad868",
    name: "wUSDM / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x0CdBc717Bc4Fdec3b59019cDFef2B85e2512eD1F",
    loanToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xe1faae513c1782c584c36fb024fdde6f1e45bddbfd3958fb2efe44fe6c5169cc",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x2d6573eEf0F4bba44f9995C92b5b6dD367bFD668",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xe1e2f0ebb1c869e6af8e27d36b8d02c4a461853ace9ed592eb41a4ec40a2239b",
    name: "USDC / WXRWA1",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x96F43B8b9051C6F0D334d9128F1fA58bc1C0678E",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xce827d203dC317CB8823098DCbE88fD3aE447482",
      symbol: "WXRWA1",
    },
  },
  {
    id: "0xe173007c038b66fcde359a1ea0dc09159e9546b21a11027b6b072b3be3ed7bb8",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x88586c0B6eE2C3d3998935cb163773A3a7f9dC36",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xe136cf43acd2ffd839ab9b4ff28725afeae6afcab17b57feeea54e8d906392a6",
    name: "wUSDM / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x6c607Fa9457dcf07B7F4Ca8f95254Cc973C321a0",
    loanToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xe10506c78843d946a4e36c0ba50d3c01ffc4f2ed4cfb0b85bcbbe7293fb76fb0",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xC03D195859549AE1F84DCf84e2F366D8ED657aad",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xe0a6ea61ee79c0ea05268064525538b8290139b60b972fc83c5d5d26cec7cc89",
    name: "USDC / uAPT",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x5110A038F9995ccd12a75871095Ca47Cd4b6e9E9",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9c0e042d65a2e1fF31aC83f404E5Cb79F452c337",
      symbol: "uAPT",
    },
  },
  {
    id: "0xe0528a76075971649e98c5900b748317d0792333bcd94ffd936e06a6be8a2d59",
    name: "USR / cbBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x2dD12a50b4f60e09Ab1b6B42fBcD241AEf36C78e",
    loanToken: {
      address: "0x35E5dB674D8e93a03d814FA0ADa70731efe8a4b9",
      symbol: "USR",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xe026bdde9462fb572f9ea9f40f22feb12b1045853e7c295a94f226fb96558eb7",
    name: "WETH / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x87b881EF276a2e7FecB65ad75568aab78a52f2d4",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x87b881EF276a2e7FecB65ad75568aab78a52f2d4",
      symbol: "MDLP",
    },
  },
  {
    id: "0xe0211ea0604a2ff633fe645ba971413acfb3727d4729de45906a628cabb9909c",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x87572bde8565e8F9A8f80bE28C4Aa5687E4816a0",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xdfd701f0e53c7281432a11743408cc52a6cf27761e7c70829318a0213a61b1b2",
    name: "USDA / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xFd00101be2ac98Af7AB795646a57E7B2372E8F29",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0xdf6aa0df4eb647966018f324db97aea09d2a7dde0d3c0a72115e8b20d58ea81f",
    name: "WETH / bsdETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x237a202192Ea0fDBC272198115ddf09cA33AebE2",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xCb327b99fF831bF8223cCEd12B1338FF3aA322Ff",
      symbol: "bsdETH",
    },
  },
  {
    id: "0xdf38296dc41c7805354cef95c9b29527e7871ecb689617534dfc67596ef638de",
    name: "verUSDC / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x957e76d8f2D3ab0B4f342cd5f4b03A6f6eF2ce5F",
    loanToken: {
      address: "0x59aaF835D34b1E3dF2170e4872B785f11E2a964b",
      symbol: "verUSDC",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0xdf13c46bf7bd41597f27e32ae9c306eb63859c134073cb81c796ff20b520c7cf",
    name: "WETH / ezETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x09ECeE1Ab6f37a3D8D01f93A622b7A3021A5D91F",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x2416092f143378750bb29b79eD961ab195CcEea5",
      symbol: "ezETH",
    },
  },
  {
    id: "0xdf13b2d71456ed5fc1b90a58c281b78423b4af952cbc7a63a3ba16dad62d93eb",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x8f275681768FA5232FB53e9AF8D975912d07F569",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xdf061750986561bca73adc899bd13079bb342d3792adc72768ad02b362d17973",
    name: "sAMM-USDC/cUSDO / cUSDO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xa0C1316196189DfcD2fFa412936e1d07c18B8881",
    loanToken: {
      address: "0x5feDe9d65714907381A76AA9bF949219dD1c5023",
      symbol: "sAMM-USDC/cUSDO",
    },
    collateralToken: {
      address: "0x83dB73EF5192de4B6a4c92bD0141Ba1a0Dc87c65",
      symbol: "cUSDO",
    },
  },
  {
    id: "0xdef1771124c74bec00e5c11ebfdb582964aa58f9f3dd3e88cd8fc2cc2c918f60",
    name: "USDC / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x5DE9812b2E34cdF9411ad6056B8F60f39E6C72aE",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5DE9812b2E34cdF9411ad6056B8F60f39E6C72aE",
      symbol: "MDLP",
    },
  },
  {
    id: "0xdeadce53823f102b85e2129fb45ca16c7ef48442c9fc01df89aa0724ea22b87b",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x7ed7c3C316e789A4a44075051ac36324dC64425D",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xde5369c8a180b1eb010ae6582ebf22eeb7b795e8ddb3328c58f9298c968fdd65",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xe09a08EdEc72540b398Bd47E58C51c97eDC026Ea",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xde2d68854129d434d372eacd0a2704ca67bb596c6a1487ba45b9f90fda123469",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x6e582a943a3545FEB709aE615E8b98C39Ed5399c",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xde2bfa764e5b9d86333df0d70ed1f50cdfab4a2bb659bbdd9291b55c3fbbdcdc",
    name: "WETH / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xFede1E8A7013384b099E9829Af8995CD7cf84717",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xFede1E8A7013384b099E9829Af8995CD7cf84717",
      symbol: "MDLP",
    },
  },
  {
    id: "0xde1979b67c815863afd1105cae097ecb71b05b0978bc1605d0a58a25231d924f",
    name: "USDA / cbETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x1F83f671b5d4eD169985EAbb01E27A89C49cFB73",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
      symbol: "cbETH",
    },
  },
  {
    id: "0xdda1d78cc8615174b177d92b32cf39745c90725a69a2b772e7b0b73b9a51b5b8",
    name: "WETH / yoUSD",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x77f59C5C09e7ABEF6991B456170930324FE36222",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x0000000f2eB9f69274678c76222B35eEc7588a65",
      symbol: "yoUSD",
    },
  },
  {
    id: "0xdd9415f29eab230a833b21be9ff593f51f34d72b29d12cb66d64614b7e2be1a9",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x41F344e2bEd788CA88bfb177066060dF3129a72d",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xdd588fee7a1cb97135d56355781a131a85182487f066d085ca008f86a35c0a82",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x6cf948966aC9D86fFCCfEBf4B6793E81c29ac1b3",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xdd0545cee8493af16a0455c9b3e0cd8d0c5f5befdb0dbec4f21497b864ffde3a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xB701F6f824eC31aFD1e23d07f98BAa9FA455755E",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xdcd98a2b054515d0bf76a613a6acc692b127ef611e057995720f0f97f08c6108",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xcEf3A0AE7ccc01FBdda1dBf136398026eFaD9f4A",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xdcbfeec87b1e672cf64c2922c32874f80ec89ee4664308d193f41bcb13cca1fc",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x7EcbD6495e4ca8f855E1A812C70Ba2c51a7d81ee",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xdc69cf2caae7b7d1783fb5a9576dc875888afad17ab3d1a3fc102f741441c165",
    name: "WETH / rETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "945000000000000000",
    oracle: "0x05f73c9910806EedE92C83DEb3f805b71C6098f2",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xB6fe221Fe9EeF5aBa221c348bA20A1Bf5e73624c",
      symbol: "rETH",
    },
  },
  {
    id: "0xdc538f096db3b39c318cd4f9e42b02d84776152d6b46d40c2c5d756ce8ad0bb4",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xC8F7E380e838336e6b02F016B2791af81fFe591A",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xdbc7f3568f5c7ec4cd9aaabc70cd42746d06695761075775450b2fce5a050a91",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x41E465398a9580Bf42cA8B9016B23BE318BA6574",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xdbb85609185bdac2c1ebd6e423118a5b840817c3bd926ced982104167516fc52",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x1c0aA3E4Ebe0580A6c2FC88CbDaEace633df9680",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xdba352d93a64b17c71104cbddc6aef85cd432322a1446b5b65163cbbc615cd0c",
    name: "USDC / cbETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x4756c26E01E61c7c2F86b10f4316e179db8F9425",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
      symbol: "cbETH",
    },
  },
  {
    id: "0xdb8da42a3cf1103b0791c1f4649208ee4756db766d9a6573e33ce8f59cf593cc",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x3196Ee2Cafe21297E927640297229601848Ad35F",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xdb87c1fe866b10f56a8b2a320dca9632281d7563b9089641806dc750d71386b4",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xE305790B87D91a84094e9176df4E1599B03Cf9E5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xdb7a6b09dff08aa363af9df4986c18c1123b5a9a39c6e86a12d173d78a3e318f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x686478963ac8656cccAb8f880AeE469AfC4a63E5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xdb4c4d13b4e57aad3a917c810982f4d5fafb03d807b238da09669e208bf82ff8",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x3eCe43AC3e4f54f22615E503C1DAa92aDEE278fc",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xdb0bc9f10a174f29a345c5f30a719933f71ccea7a2a75a632a281929bba1b535",
    name: "USDC / rETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x7E1136C04372874cca9C3C9a2DbC461E3858b228",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xB6fe221Fe9EeF5aBa221c348bA20A1Bf5e73624c",
      symbol: "rETH",
    },
  },
  {
    id: "0xdaa04f6819210b11fe4e3b65300c725c32e55755e3598671559b9ae3bac453d7",
    name: "USDC / AERO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0x96F1485DAf396c2ab7e53DC76d7B330143Cb2269",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x940181a94A35A4569E4529A3CDfB74e38FD98631",
      symbol: "AERO",
    },
  },
  {
    id: "0xda4493ffe559552373c36293ae49c6f6d0b13f1e25aabe51ae49922d2bb109cf",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x8d5A85a2B43C5a1f1A710df2A06dBAf896F47D45",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xda428db5dc4dea8f7af62236c08fffaa1fbb178931a34284da4940cbfff4b8af",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xA58De708bBafBEAe27bFD0B1933CEB8e9ab1C176",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xda01cd5d85d6ee9334f8109f2dcd429bc138414eeff72343c0f7321473c948be",
    name: "USDC / USDz",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x424a586E4033dA6C7A4F1bFbb02CcFD965F7FBcB",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x04D5ddf5f3a8939889F11E97f8c4BB48317F1938",
      symbol: "USDz",
    },
  },
  {
    id: "0xd9ea0c02af29bededfd7d98ead32ba8027e671b75cfe6b8db7b949d068af3c85",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x27fab29A28EAb461d20a349EE27d94c251E99cb7",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xd9c4426d3905bb9b672159d50f3d1fc8f4f77bcc611d24560328ae1225989239",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x69e965C8d5BcBE5390025e2830B7259E0c4dA4eb",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xd9b46a9d5f317d9c90c1096b4be6777ff8bc5061dfc3807e66ac24109db89bc6",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x55CA18a351441450A877E9f9BEa1B748231040E1",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xd9a2dfece0c107ca93dc399b3b957e8c27f3f733b94dcf439cee4c1f53aaebdd",
    name: "wUSDM / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x899fC141fE78a2eF45D19CA2E1a3B7990473971e",
    loanToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xd996fbbdd018256dbc80d779d64935bd639227d9ded7965c467a09a94230a4d6",
    name: "USDC / ZRO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0x8E135aeB0424F5039D8Ab9b6Ab12597CD8356039",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x6985884C4392D348587B19cb9eAAf157F13271cd",
      symbol: "ZRO",
    },
  },
  {
    id: "0xd94dbaf247ff2be4cb9f7a83b535d78c3f07443da1684c6bcd34a66c22b66efb",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x93DabC39968D8236daf52c17C085993264a29683",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xd912325cc794cb90f44e879b1e6bca438d4f77751c0351015d2b5b10b8068e28",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xe62684982187C706606390C3Ea2b3010fDe9cd67",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xd7e20f997213de1b2e2181f921b413cc78736d14dc63022cad6a302bc44786c6",
    name: "USDC / VVV",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0xEBB9dF05F5F3f9b7Ca85067CB95023C8Cc0C5736",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xacfE6019Ed1A7Dc6f7B508C02d1b04ec88cC21bf",
      symbol: "VVV",
    },
  },
  {
    id: "0xd786c49700f472114320e47f6f5e65def38e6cf0430e35e3484f19accad5b205",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x8d7E03977e38a872f6F6cBF1BA85f44B72D601B5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xd7746cb1ce24f11256004bfcbaaddc400fb2087866a02529df0a0f6fe4a33e99",
    name: "USDC / CLAWNCH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "385000000000000000",
    oracle: "0x81DD756b6de7908b998b4f9E4Ca44Ee0d230ee5e",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xa1F72459dfA10BAD200Ac160eCd78C6b77a747be",
      symbol: "CLAWNCH",
    },
  },
  {
    id: "0xd75387f30c983be0aec58b03b51cca52337b496e38cf4effbe995531bf34901c",
    name: "WETH / cbETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "945000000000000000",
    oracle: "0xD7E2307BaFb6e8Ee916C54A50D938161C0C9ceC3",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
      symbol: "cbETH",
    },
  },
  {
    id: "0xd7520ad198b497b6eb75bc690268f4597630dbc12e305e9d4105843bab36e41d",
    name: "USDC / cbADA",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0x35D87a743D1F2f7CaFb42D855dC1c5Df857Ce45f",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xcbADA732173e39521CDBE8bf59a6Dc85A9fc7b8c",
      symbol: "cbADA",
    },
  },
  {
    id: "0xd73dbe8dbb5f0bbdeaca3a13fbbc0b7b90406f64408a822c4e4902561d51c498",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x9c65f6E142E5545870A4bb07bde0Af94c28891A6",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xd73a46c951994407f6a5ba9cf270c4e3b314475eaaeec8d7c1f1c71fdeb8736b",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x710821E2076B84BE64BB4Aa462DE1B760426fdAB",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xd71def83ed9b8325204defd71ee0c5bae506002bf3df0a1f2c494942296a1dc2",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x94654493bA76b73e03a018186f684dfd95C865AA",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xd6ed75b8669cdb1d0f3e755ff0929718296c3b0e532642fde80296b843a0d0e9",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x50566E3518CD10c0D29Bd1828e9C576422F99865",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xd6e982e4b6fe7cf58ff70cf982453cc4a025bdade623327c6945ae7b61541b61",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x9F3eE643a6d1b3a3Be6aEa6cff47C5b50c3EA988",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xd604d0480464ca2e940ef834993c099db65df55b041150cc4c50346fd467e670",
    name: "USDC / KTA",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0xA65c4AA00958957c8944A1Fa940184eAb1FAE387",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xc0634090F2Fe6c6d75e61Be2b949464aBB498973",
      symbol: "KTA",
    },
  },
  {
    id: "0xd5da632a330bc721f7bd65eca060895db5200d314958fed1c841c20551f47c62",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x7f7cC08beCd6D25CeAD4CE7c0f7232864CfeaEAd",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xd5d7156a4dabe0e49ea638f4daa2fecfe90204c99099d417744134c8488d3b27",
    name: "XSGD / cbBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x14a816839B69b38C91Ddf918A00BFD9E3F09292d",
    loanToken: {
      address: "0x0A4C9cb2778aB3302996A34BeFCF9a8Bc288C33b",
      symbol: "XSGD",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xd5800a5613257b9619c6fba724157da07bd2ed8b36e7c08ed494ee58798757c3",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5B02699E0Bd34c7028ce1Cc996Cd10279a9A5fF5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xd57716715479c3180d6a413d13f430615b8eaaec64fcea22566e5e46d6f11c5f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x7198DCbAB20269f7b4b7bE25Fc2f07ff3622191d",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xd54bb060509146d60871b86403b05fa9767557b1fbe52781f5d86aa9d357b227",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5EE9E415e2Fe69cAD95E6F5F7EC865f8fE944A62",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xd5377c0595cdaa67b6086e09445133f09e2a077e77e99aa6b1e474529e5909bc",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x0d2c3887De0A20dCB35EC6C738CB0256020e7A08",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xd4f054148e3a77453a4bdfdadd804c9eb244eb2640117914c7491d3d6394a484",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xa5960cd02CD67D6C094a11DA958a2b7b7429eEF1",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xd4c82dff3aa86569907f71c05d017da6773f1103dbdb51c98d17b8246a014c6a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xbb769e5261d228c1CA8aFa689b07D1244D0b3436",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xd4a903dc6d949519060c7707f9604fdc9772c046e05c2e3a8fce0bd7196e4109",
    name: "USDC / cbXRP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0x031b2EFC8d70042Ac8d9f5c793c4149eC4b60fdE",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xcb585250f852C6c6bf90434AB21A00f02833a4af",
      symbol: "cbXRP",
    },
  },
  {
    id: "0xd46f23644ea07f417453e9def7a97b3bcc1c6c34b7c7d4542a3bc7ba88ac6e0b",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xcD19Bf377596dE44aF1eecD2eA81b3702379FfBa",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xd424af31cded12a44174d7d2a36ec4a157e69520e7cbef2ac4f68458dc00a331",
    name: "USDC / wstUSR",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x31bC0C56297D77ad51aa8da9A9a8cf8cC03A4Efc",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xB67675158B412D53fe6B68946483ba920b135bA1",
      symbol: "wstUSR",
    },
  },
  {
    id: "0xd381cbd66435415598d9db96e7c28e871099014e400a716e5838c1d25a6ca5ab",
    name: "USDC / PENDLE-LPT",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xD5AFa2bb4f8C15aEBF44eDA7bEA6aB8460105479",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x715509Bde846104cF2cCeBF6fdF7eF1BB874Bc45",
      symbol: "PENDLE-LPT",
    },
  },
  {
    id: "0xd37a650db4b6e19fb8964a548b2d16f204250217cdcb1da37d50f8604d0da882",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x1376552ebebd8a1182cBf56128E8d747343AF5D9",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xd32f2bd0b5a6a2f4409e11a774280941bf0a1d470d2a8309c70770da733e4a93",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xDBeD63b2C4ec0b428295cD6E01f39702E5F7Ac0D",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xd328131ec1e30dd8868e8203bfbd98afab7cbb4816c8b68c298ab4a1342827c6",
    name: "mWETH / mUSDC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xD09048c8B568Dbf5f189302beA26c9edABFC4858",
    loanToken: {
      address: "0x004c027Dd605121582EAF0f382C7Cf073EC27D3c",
      symbol: "mWETH",
    },
    collateralToken: {
      address: "0xe8a5B3c5f8500fe0372cdECfE569c15417253932",
      symbol: "mUSDC",
    },
  },
  {
    id: "0xd2f1b4fd701aa5b6723a356f6fc1c401fd1d8037d1466ae42d20244e2da59f4a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x833a8c41dD536F18bE933EBA5ca9EE8134212995",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xd29c1371a91978ecc23abd1f30a69303a5092d0b64e4eacb0f35073715b52e59",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xeFe593cAF665609587073ADe03eD1D2168Ea91C5",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xd1c63ee4c06f96a407b7514bb93035292172741af11f226c254e5b25b253e8eb",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xF89Cd7c506681B95f05BdC9ffaB0F033227110a9",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xd1892032c68f94d2650238b363195c6c3c142ba80c0c71269d14f8ea42c0abdf",
    name: "USDC / wBLT",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xf690D869c625Df526dEf5818793109511c451A55",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4E74D4Db6c0726ccded4656d0BCE448876BB4C7A",
      symbol: "wBLT",
    },
  },
  {
    id: "0xd143b60978e92b2696eb2c8dd24949240e3de0791ef90f1f2e2afb42b961a641",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xD6f3A44544eace791bBF1F6bb6193ba3aEfF59Df",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xd128fa9f4d2525f7fd934267b4515dfaf9e301356765d233640c3cee3da80d27",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x93a63d984D979185689a7771936F76c46F7F53E5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xd0af0c404898cc1fd3c68c0b9dd3f0d2437caeaab84e0db40f8bb2153339d2b7",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x8583944AD970D78a58EB8eF0e59F187E6bAbc4Bb",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xd09b2997b40a9b3297648b71ee30a5d2d912edbb98568c45625f4367d4296ca9",
    name: "USDC / USR",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x8A58891979C4aF300d77574d45511cC2AfB84118",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x35E5dB674D8e93a03d814FA0ADa70731efe8a4b9",
      symbol: "USR",
    },
  },
  {
    id: "0xd09677f8178b76d9cb4b2138c89f60dcb019e6b2c2d5a58b3bcd4bf554dc40dd",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xabFbaf5703876Dcd1e2EE629382c108C0C516399",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xd07e787912b777ed3b038b438f4046a48adf181516baeff99f1db0fc44357312",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x970cEd643C13aa983668fCb62FbA7Fa1DFb28228",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xcff9c0071483c876f4ddcd9286af85a82649e8e4bc0b353e83c38b9b779302fa",
    name: "USDC / wstUSR",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x31fB76310E7AA59f4994af8cb6a420c39669604A",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xC33dCb063E3D9Da00C3fa0a7Cbf9f6670cd7C132",
      symbol: "wstUSR",
    },
  },
  {
    id: "0xcfb74f95ff3b5b28e483d2a95837b9aa1c9ee5f0bdbde5ad8484d6e3ffcd509b",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xd0693AbCE019CC604c77F835cbD3722bb30d7E1C",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xcf5643451910c09d638088ab4e3ac84a932113fd15571eee615e2d93955116c1",
    name: "VCHF / cbBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x71C8b2a2811eA292717BaDFF9a3053248E398Aed",
    loanToken: {
      address: "0x1fcA74D9ef54a6AC80ffE7D3b14e76c4330Fd5D8",
      symbol: "VCHF",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xcf21c3ca9434959fbf882f7d977f90fe22b7a79e6f39cada5702b56b25e58613",
    name: "USDC / PT-USR-24APR2025",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x1Eea5F3049e05e9cb85c2d6a2D47677765B70d31",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xec443e7E0e745348E500084892C89218B3ba4683",
      symbol: "PT-USR-24APR2025",
    },
  },
  {
    id: "0xcecda31f0a639040a5fad845d0974275081e50f087fada4fa8808bcc7928d18d",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x7209B5c76adB2C3d437F1d9CC5e208f73Ca26cBd",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xce89aeb081d719cd35cb1aafb31239c4dfd9c017b2fec26fc2e9a443461e9aea",
    name: "eUSD / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xa79e9EC3458fEd729E7A0A1A1573e6a29E875d5E",
    loanToken: {
      address: "0xCfA3Ef56d303AE4fAabA0592388F19d7C3399FB4",
      symbol: "eUSD",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0xce3b8aeddb9448074caa44fb9e35530b364c70aaab3e80bd19415669aa97a7d3",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xd93d618DC92d401564E4B872284AEDe8B0Fe57A8",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xcd9b0058147cd163e99df67d67bd7298a99cd70e157e6a5e48d86db27f04c3bd",
    name: "xUSDz / wsUSDZUSDC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "945000000000000000",
    oracle: "0xC200927E5265C94B55Ab9f39cAEEf7236E49403F",
    loanToken: {
      address: "0x0A27E060C0406f8Ab7B64e3BEE036a37e5a62853",
      symbol: "xUSDz",
    },
    collateralToken: {
      address: "0x9A52FCd13Fb9927d884B7EaE826697c0aa0659Cc",
      symbol: "wsUSDZUSDC",
    },
  },
  {
    id: "0xcd49673eeaec51eb060e073e75582c3b2e752061177cf9bd4e7f7f501438a462",
    name: "wUSDM / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xb9dCBcAb86422acC21292389241d2C6aBaEC9453",
    loanToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xcd3e0bed75d2272cd2a11bc5314fec633d4c9159df55b468534e7150c105c482",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x39b1183BB93280C81A2BcE3a55ccbEF6Ef269AEa",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xccc2fef1310eada4b06cc0893ee24bd5a2a0c6e6eb2823d5755e908cd20f400e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x0E0ed6aA4c88B7252927dcfF3220103a384D239E",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xcc81a1782c0f82f60fd86d0d46119bc7032f25a470d129f87debd92561c531ce",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xc84eC906d06c260E7029f6A3CDDE3D72Ab996950",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xcc6659e49ca5136ab5e375c6569099bafb73e10b0c485a8ed3a6d44b68cb1c09",
    name: "USDC / TSLA",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0xbd713f6ab3d2cCeC94cdEde42298F7ceC8Ad3C77",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x842f275eb7Fb49678c0fE46e92477F28Ffa1E12A",
      symbol: "TSLA",
    },
  },
  {
    id: "0xcc18ca91aacc055b6e9c40c8655c0bf15d3b6efc729021c47b690e8ae5322ead",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x226Fe19a40d69d24285E4B1952b8C5b813cEA399",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xcc18600754a5a56bdfe83e847494f135a853db67656f9566961782cb13ea8b76",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x9278898cB1261dF8500bea5834CFA78aD7083578",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xcb9a7d418257870396ec94b0424ab2bcd66bc9b62831ad09d06d5854cc9b27dd",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x1A6D486B16829576A884BCce934143678A14Beb9",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xcb8639e6a834fa517601f27199c408797d2574a49754d5183aac2c69eaf7b265",
    name: "USDA / weETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xf13C74a2663f81090e9E5256D4D7dbC9Fc655b59",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0x04C0599Ae5A44757c0af6F9eC3b93da8976c150A",
      symbol: "weETH",
    },
  },
  {
    id: "0xcb5d8b539c95e9e7b912e564d48abd0408c8ceda799f2e0648de0053986b0072",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x4A165Fc37e4a7f017B1d953CF3E49a1c7C09e89f",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xcb2ea202e6cf92d697a4fbd8a9035b12cd532791e270d9509264ed995aa15209",
    name: "WETH / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x25D4f3F8DFeB5261110EfF6dA8584aDDcC21dd26",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x25D4f3F8DFeB5261110EfF6dA8584aDDcC21dd26",
      symbol: "MDLP",
    },
  },
  {
    id: "0xcb242dd5541756f322d6e10544f0bc85f2fe446753d06240874e544c1a7b1064",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xfEB812DE207b00277Fe0D8A63360841d320Fc138",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xca30ef2b892fd6d0aef964273e2d5f1214b10717d7118749077cdbc78d30e0fa",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x93C3Bb3ef76eDCceF434Da0744Ba60148091aC7C",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xca2e6f878e273f6587276b44470467f94175e92840ad0d7231e9deb64c190591",
    name: "verUSDC / mTBILL",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "965000000000000000",
    oracle: "0xbd8F0F1ae3448d9dE2706afc1f7B474f28F542eA",
    loanToken: {
      address: "0x59aaF835D34b1E3dF2170e4872B785f11E2a964b",
      symbol: "verUSDC",
    },
    collateralToken: {
      address: "0xDD629E5241CbC5919847783e6C96B2De4754e438",
      symbol: "mTBILL",
    },
  },
  {
    id: "0xc9dd19f675a2a62688ec80097026d5e71451cb23c6376e8587841d8393b4bd50",
    name: "USDC / NVDA",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0x4EE155947E3704784bb095740Bb2e3791A236D7C",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x3993Ab33E5aE1C081DF87913ab5c845EE2813B72",
      symbol: "NVDA",
    },
  },
  {
    id: "0xc9b8565edd0d17bc7bd7624a89516ea6236bcc705e523b28ac042d841e747abf",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x645BDfA0b00D9F33Ee1eb1b4e0A728336a3cc91c",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc96ceb8d20c72ae213c918d07e765befc5bf64163c4ff39e3eb2bf71dae6e638",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x9c4362058f9bD2A8ee33aBF434042f87b65e8Fc3",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc9658cac13a9b9b5c1ebaa8ce19c735283cc761ff528d149a7221047bb7fab45",
    name: "eUSD / cbBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x2dD12a50b4f60e09Ab1b6B42fBcD241AEf36C78e",
    loanToken: {
      address: "0xCfA3Ef56d303AE4fAabA0592388F19d7C3399FB4",
      symbol: "eUSD",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xc902feba9feac6cbcf7a48b82ccef178a6bdc4a49a474f6ac0c785461ef18e66",
    name: "USDC / RLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x63bffC991E990a6151782f67EFa994d92CBd78fb",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xC31389794Ffac23331E0D9F611b7953f90AA5fDC",
      symbol: "RLP",
    },
  },
  {
    id: "0xc902ec9d2dabbdc5ac59f9c1b6c0bc64b56d7f7d7c1b33cafb30ced00995adff",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x7Bda5eF45d7554Ae0069E1D85F5F348C9d402a33",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc8fcb300cf3f5916b1fa84de38e9a221eb8f857ac760f77cb15710ebabc3941a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xb73d5288070747dF66E821ba659EF784E9287077",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc8cc5bd0fcfcedae5e4f27b5ddb36546e94adff25532f61bd5a3eed71641d546",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x71eeC9FdD3CFf355d39787297EFD2Ba563744219",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc830cf75d21e157821ad49278a9074a7f537ce760674f9b0d69dbfe293127090",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xE25e785b74d1aBB3a8e8aabc3013EcB0Bb64317B",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc802f47aee2c4836307da5b3808a62180d9d235b335eb0fa26a579ad0e4130e1",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x80b3AFec445df5dB8e32A8396BcF2C1B3878c502",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc7e52ea32a7bd7816255267f1b536e05b4ff8cf93442f84856926a1d79aef184",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xa7b6Ff9cd3a1E6A44915D68277BFd7A98D9C5957",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc7cfab94cc117b09d1c66e82a7183892e27d0da15ae1a2777a9f72bf4034e496",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xac4D8F224C52f2Fd401bC65c4Fc706544b41370f",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc7b758d9e25eb5f78ab6555425e27f8919005cb802b40b6aa7d3fe5597543b3b",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xC7112F0a37A812c5AE2017B18836fdC267996738",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc7808d3196105d57edbfc9d16ff97a55f2a283140a500d42dcb8d10beae9acd4",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xE047d44a4b4693b77F81313AFAE950c39CB93779",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc76d70567e8b331ba67ef6a6e8a321cdfd382a5d8529da5f38a73c5ea935b0ab",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xb2e6102C5147634ae4df35fa1C3C346CeBA21a3D",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc756a8073c9b98daf70a9208ccca27624d3f115e95b1a3df9caf819347f45feb",
    name: "WETH / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xF03B31a68A5c3F40b913Be80870114e7A9144CCb",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xF03B31a68A5c3F40b913Be80870114e7A9144CCb",
      symbol: "MDLP",
    },
  },
  {
    id: "0xc74e4a192a104cbd7c5a439d3b0152065ca1ae32d4e8144d9f6dc640995898db",
    name: "XSGD / cbETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xd5eB6fb4C09b997a3f1CadfCC089398285071eB8",
    loanToken: {
      address: "0x0A4C9cb2778aB3302996A34BeFCF9a8Bc288C33b",
      symbol: "XSGD",
    },
    collateralToken: {
      address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
      symbol: "cbETH",
    },
  },
  {
    id: "0xc6d9f41ba462c77ac83e34ec68edfa1f760d4c7a95eba5515f336c7169464a5a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x4C2DA20cdf11FF61435f5D030541b9821A206A4B",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc6d3df30315868ba5f3e923d71bb695508d470fe3b89b6636dc45be989fab577",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xA6f5CD5FAea5901a46082E774eFCeccA57CC8813",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc688dc0dc4b4b8588cc88b817e66cb2efeda7841f75ba5ac82e5ca080757613a",
    name: "wUSDM / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x6C6D1906f08FFAF0Aec46FbC405BeD292775615a",
    loanToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xc64dba93515177256a36c4d19b27956fb1fa6849fa3ee9428f2c4347eeef02c4",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x4f253864E364b08dA42471147136299f1E8D5985",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc635043e8c73b83ea69176e627a28d89bf8be54fe902d786fde819cfbed733f8",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xF42A82b9B20c58e41155c2DEFD5f93f207D6316d",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc61a5ffd41aed2a7750181cee9a481323844579f193e9ae7b9e6f0f4e16a6cef",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xDC4CeD94ae4d63820860A5E6A1a1e02446F6cfd4",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc5f76a6323979dfa59da7ae70f3fa53b310a1e40bf82a1aeb168a2cd5f9fe125",
    name: "USDC / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xf321eFcc482F0B4CaB380e5F2a988FCADa03fE8c",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xf321eFcc482F0B4CaB380e5F2a988FCADa03fE8c",
      symbol: "MDLP",
    },
  },
  {
    id: "0xc5cd35f2dd706781e9f8f385139238c50d7c367ce05624ebe97ee89f6785effa",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x7c9Bedfc7f2aa75ae1b4E532041C8d98F358fF03",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc5b6b53cd6a3e17c44d44c3674ffeafbaeb8af3f3ab928462fa7a14291457be7",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xFF57d48Dc0239cBFa26aF32B8a68751a0C80Bcb8",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc596727bf1bb55f9e7ec94b2e0973c3e92041516621e6aca1df2de55b602ba87",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x3ad63A9c20fCCB5509bA0fC9643bE60eE82D2D88",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc57c2494e6fa95d857db108e7c0f590983552b4243982e58bd06df0b51c87e47",
    name: "USDC / MSTR",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x8F2cd7463915F0B24FeEEa24e8bBCeb9889fB1A1",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x0b1606A11F1cbAD9a929bc32038a0D2fE75789CE",
      symbol: "MSTR",
    },
  },
  {
    id: "0xc569f198c1b175350e2123c72efc8a50d399f72c2a7c4a422e5a1296b8bbf8b0",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xe95D550629d581Fb15515CB9E0cA42052EC819A4",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc569da4b2fde4192247a7c63887200cf270fd2f8b75546fd504f1eeaa6f5bb8e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x91823975F799E5e623Bc5d459cEF5F483d318a88",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc3d21882811906945c25c211c00e9cfabb3f9faa7c38501466bfdb1e10d05201",
    name: "USDC / CETES",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xcE023D22f20583E9464B1Dc5BB360d5b2Ad8890B",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x834df4C1d8f51Be24322E39e4766697BE015512F",
      symbol: "CETES",
    },
  },
  {
    id: "0xc39252e3e2d72c72aebc78eaeb1d59d90ba99f28e4d01eea0a3380dd5972335f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x935EF7612Fe0BA4dDB4264D7ca9aedFc68AC9C59",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc37b3869471d6be9ae08ba53b9f5856c00d7e72d6646ae819484b98b80477505",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x70632755135873Faa356DACb21AD1484c0C7Ee1D",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc3484b03e5fe7546b6d157e9a31be84597268ef269f5e9fb128fae4f9da733c7",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x0dF623bfA883426eCc6f95d0EBFB15d93418EBB4",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc345e6a361a417e85a0f4a2a5f73f3440fe80e0ba31b8036fcb4981e89f61918",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5A11e4979096ABEa3894a72Fa3c2535f0A808cee",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc338cc2dc3f6a25bace40a920eea39ff27f184899def6bda478e27e591e5cef2",
    name: "WETH / ezETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x451B6e60Cea6EF4614f73f9BC7e5039E8039eF20",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x2416092f143378750bb29b79eD961ab195CcEea5",
      symbol: "ezETH",
    },
  },
  {
    id: "0xc2c068620e1ae9332e9973a2058b21a5133693c449c56c1f2164fe01499e407a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xebC41D9Bf118E39d81425B8F98b1fcc16a6E4E51",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc2be602059f1218751ec6f137a8405166419ce408d191fc70f9714eeb301c32b",
    name: "USR / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xa79e9EC3458fEd729E7A0A1A1573e6a29E875d5E",
    loanToken: {
      address: "0x35E5dB674D8e93a03d814FA0ADa70731efe8a4b9",
      symbol: "USR",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0xc28f0f25a1a420a0edb3030bae0685682218f2b8723e7ceb3efb186411f6c05b",
    name: "USDC / OSAK",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x49daCa389c948D63718347B5A172F60655e049cD",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xbFd5206962267c7b4b4A8B3D76AC2E1b2A5c4d5e",
      symbol: "OSAK",
    },
  },
  {
    id: "0xc21f67eb30a8221c870f43a8935801edcc5b283e070d7987b708bd122785502c",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x27FFC906b6C60b3aa9c236D57ac2923748AD5063",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc1a85da1bacc65da9fd8db43568ccbba2ed4254e5fa523b42ea10e892a50512c",
    name: "USDC / bwPT-USR-25SEP2025",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x6AdeD60f115bD6244ff4be46f84149bA758D9085",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x3D594B792c2D62E6861a19b954ADFD2Ca3F6D3e1",
      symbol: "bwPT-USR-25SEP2025",
    },
  },
  {
    id: "0xc16891f0e127dc480587f8b6a3cb521638005814e2d9041d88b105df47627610",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x580Ad428D57469CbbFcE2253A79F5999A64Fa979",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc12fe0d258984b0460213023d8a39fe10316450ae5ded5cc19d3841d966f23ad",
    name: "WETH / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x7c76d48aE75f90156d85666c2d63B55087ea13AC",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x7c76d48aE75f90156d85666c2d63B55087ea13AC",
      symbol: "MDLP",
    },
  },
  {
    id: "0xc112611490bc9ca9324c77927fd8baafa693c503ab5103aeb23f378da52f65e5",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x9B22aB0b971791A3Cfbf8242d814b4340d4210B0",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc0deffea528e495e784fdebfc0e399b12ae52a02b8ac4f398e50f52155b8e012",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xC2f4Fc416f76D66c8243627c0BF83653D2Cc62a3",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc0d81f0ba3f8d574eec22afcbae97bedbbc1ac8502790cc2af4d444650de871e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x01681fCccCF4081Af3dFB2573C1Dfff65AF2499D",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xc013872eee4493da8c5a793703b11b83b8633506ae0d61311df4c4ebfc93a53c",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x87f261DF9ED79274A5ad01460F4C21eC2c68c514",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xbfa5dcc84dfa08540a910545683d6adcb0579c168536005481bc87ef6b578884",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5d86d28Dbc06B517cDb90f7f99F3e73F87e5ED90",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xbf7cb524ff491a1072656fae20830d051ae93e43f0ea3537a13f5a527537cdc2",
    name: "sUSDS / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x51029b9a1E192A319985cFD20D2Ff080283b0016",
    loanToken: {
      address: "0x5875eEE11Cf8398102FdAd704C9E96607675467a",
      symbol: "sUSDS",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0xbf75bc3d6ea73c1b4675b36330ab0dd9ee7433e910ca859b4d4fa6618b0792c2",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x4F5D5F31F3eB9d360F65F58943041a7b61FE58AD",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xbe8b8abdddd4673f688cfb19837482d3bdc7a046208f0b2ad45cfd4c295ca2f1",
    name: "USDC / CLAWNCH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "385000000000000000",
    oracle: "0xd0ccD14F3Bb47C90998C884422a1E828190F6842",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xa1F72459dfA10BAD200Ac160eCd78C6b77a747be",
      symbol: "CLAWNCH",
    },
  },
  {
    id: "0xbd95ec18419fac482f43fbf8c0603be0ef43e8bd89c2cdd0393cfdd09ff2629b",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x4e40f489782c3aE254e300a896bDFB209BeA47F3",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xbd83d0e72d32a566c476be787ca0b63c4c888a92c35fc2769942bd6e4af6155d",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x1e0EC5DD810719703D10AA76C8bed458d561ECd1",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xbcb7cbeef0170a423dcefaee5e4bab63c99e7a0c3d62ccc228478ad9a8bbc89c",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x5f9a685f129d20A262a9847c5410b107Af9b352B",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xbc348d8108ac6d637491d16bc22d422f5b02093fddfc4b78c7900a44d9487baa",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x0d863cd9d14fd99b2B9B9B5DD4D3e868000b3f32",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xbc238a1ab7242c101300daa6ba9708983680242f557eca9e29d47178252533d2",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x8f7E170baA37955Bc0811ACE2741a024eF35595e",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xbc234030222a4aa327ed64157457edf10a653c75bae4687969773b6cbb2005d6",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x14E92F9D49052049FE9e933e97942CcaaD9E9E75",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xbc1edc7aeb58862c0b234631c8cbec6330e8f3a35f165380d253986b80939479",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5d9F595F28649ad38b439b0A6804259408238407",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xbc10178694af0243c40563e743576fc39bdd0a0090902da27a350cd3d176c972",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x3509053790B28D14774edC2d017fb6990E9C24fD",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xbbec7f20fcf009c0008ea3ec3975b0600165f95305f57c8befb8132b1663728f",
    name: "xUSDz / wsUSDZUSDC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "945000000000000000",
    oracle: "0x523d465710326D13b803CF1cF30Ac34e08B65b9c",
    loanToken: {
      address: "0x0A27E060C0406f8Ab7B64e3BEE036a37e5a62853",
      symbol: "xUSDz",
    },
    collateralToken: {
      address: "0x9A52FCd13Fb9927d884B7EaE826697c0aa0659Cc",
      symbol: "wsUSDZUSDC",
    },
  },
  {
    id: "0xbb94921f87bfefd419dc58ff54ecb112c8835fca5ebaa3945f3edc21be51f3c2",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x21A8e12aC3A8090cc291A3019D80cDEfE99111b5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xbb846983db960a590adeb241971dbe321945b54dd62d30a9898f01cbb6447c74",
    name: "sUSDS / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xC4d6143b2C5Ae360899A158618d59A1918F393fb",
    loanToken: {
      address: "0x5875eEE11Cf8398102FdAd704C9E96607675467a",
      symbol: "sUSDS",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0xbafeafcf39fa06e19d98e2e2d106ba206886ea9129b2a59c0fc54cdb24e4c1ae",
    name: "USR / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xD63F387882A0134c300e56a3d53070DD5f2a4Cc1",
    loanToken: {
      address: "0x35E5dB674D8e93a03d814FA0ADa70731efe8a4b9",
      symbol: "USR",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xbae6323cd424647070e882fe5810a8d67922e0942438b5618c7b59f02ced4373",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x9B5ebd4E5016141719443D37CB0fCAF3FC43fbB6",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xba47dfa30293ecf74313f4c9b04a009e0b3f13bc0437083b4926ebd46c760f6a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x6DCBB279725f064f9E9238c9Ed88558521b42b2B",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xba204df30ddf0d059aa91b02bb3a3ddc3598d689cef28dc80010d9d3fbb32b58",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5403feFf3Eb10B5c233D42e9E1E9d2BA823894De",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xba085b42e771c97ce14cf776b400bf31af18e608e01f92bbceaff031d10dd354",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x0b31fe78ed030989184456C22f4AcDa6540d0E8C",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xb9e11c3ed6872653a7e203fc45bf33f4cda348e87613185f67e06794dcdef335",
    name: "USDC / LCAP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0x186C4ffdDff98718eb95702F7c80Ad6e097c7659",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4dA9A0f397dB1397902070f93a4D6ddBC0E0E6e8",
      symbol: "LCAP",
    },
  },
  {
    id: "0xb9b2a859187c63c3714bf7d90a9bae6d06e3a8ea2240e1e2cbeeead90d1d2c41",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x65Fc64253fc58Aaed22c9AcB95bb1238ac4a3A47",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xb95ebaa065081e3051bb4eac487df84f44f7976fc61913bbd8ca64c5d6f25f2a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xe856E6E43ed48717BC4371B4e5689b6797e96146",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xb88640276c241665e5b009ef239f6386abdb44974b77535c5f672b948948642b",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5Bf13d8675074c6F338F93177cA1985179e7b5F6",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xb7f5c45a249a5309d53cacbb1c10b6bd634fdaaa6a7f7d004091a041ed656381",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xb98E16F950191087f457066f96fAdECa9e9B3244",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xb77c262383cfe001c6682818c1f654ae05e697faad7b49057c6310aff72a4e1a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xB200Bb7652BaF9CCfE3e41709918d82389C0dFC5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xb77a158134b3fca7a72f449dc0de9bf025d2fc42d018060b61468e059108d0a2",
    name: "WETH / yETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x754D0fa17554d56550a1a7CB68032FfEff3d89DD",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x1F52Edf2815BfA625890B61d6bf43dDC24671Fe8",
      symbol: "yETH",
    },
  },
  {
    id: "0xb7031bfa5925af52ae0134ed47feab7caad62bc689be77cba25504bed2051257",
    name: "USDC / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x764e2866c4D41A29EdFb53c431D76e2ACd44df31",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x764e2866c4D41A29EdFb53c431D76e2ACd44df31",
      symbol: "MDLP",
    },
  },
  {
    id: "0xb68a4e5ec66d41135a87575f9f611557bddac5a96d3aafa4069afd497e99f351",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xa800A4010E0d5a6eF41591ABAb5f825610A967d3",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xb677f12d7dd28059dbddce508acb0e467e1f3abc9f12f6f28de09a275d6c876f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x880b09B2ee0fBaeBe1C47529FCfE61Da0D4e4340",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xb66f340e144d1cdd552186d96a33926783d7f954c535b9c0938e9ddee805ddfd",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xBC49e189f5b6574013D5e75177779199d84CE0D4",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xb63f67892449a12b4d5af19c7c9490bc128bfea08098f9ab4365167ce1210c12",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xD638d98AaA1E3476c54F5d480C843c009A194Bf3",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xb63256b02a975e00ff390fb8a280f8b332c0111a668917aaa4b07e8fbcf1bc9d",
    name: "verUSDC / LTF",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x0a7e34C6888953CDE70F4E6bC415B8bfd4cdC7F9",
    loanToken: {
      address: "0x59aaF835D34b1E3dF2170e4872B785f11E2a964b",
      symbol: "verUSDC",
    },
    collateralToken: {
      address: "0x6D2B49608a716E30bC7aBcFE00181bF261Bf6FC5",
      symbol: "LTF",
    },
  },
  {
    id: "0xb609f1d824d70a2127092333f591080be01555535c61d93252dd778e1fa88920",
    name: "USDC / yUSD",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x2766C711ec32c8ea1F141ECEE718c0c7C39f5370",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4772D2e014F9fC3a820C444e3313968e9a5C8121",
      symbol: "yUSD",
    },
  },
  {
    id: "0xb5d424e4af49244b074790f1f2dc9c20df948ce291fc6bcc6b59149ecf91196d",
    name: "eUSD / cbETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xc3Fa71D77d80f671F366DAA6812C8bD6C7749cEc",
    loanToken: {
      address: "0xCfA3Ef56d303AE4fAabA0592388F19d7C3399FB4",
      symbol: "eUSD",
    },
    collateralToken: {
      address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
      symbol: "cbETH",
    },
  },
  {
    id: "0xb5bcbdd26ce71c1a6255226f3a3682bd9cbcd4134942e20d5df1ab1f62ce730a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x0df79B8C070869488eD34eD1C5D8bf85CF2d6DB7",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xb5b3fc38249c9a0aadf7ff0fcc48ef2eec49ef746b9b74a95597132c7a614116",
    name: "USDC / hyUSD",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x17db99DC3E6c0F69D0360eBE3834bFFEB2f709e1",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xCc7FF230365bD730eE4B352cC2492CEdAC49383e",
      symbol: "hyUSD",
    },
  },
  {
    id: "0xb5af5eff0eb3757fb91584a839f900148d5e77cdebd6fb918472a18535131850",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x26A2b1C59E0eF5aA96Dde47FE6f23A24bD55cdf0",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xb5abf53545b883823cd5f5e6905fc2ee0dcb2b1a47d74cc78fd549489e473f1c",
    name: "WETH / ezETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xC4300B7CF0646F0Fe4C5B2ACFCCC4dCA1346f5d8",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x2416092f143378750bb29b79eD961ab195CcEea5",
      symbol: "ezETH",
    },
  },
  {
    id: "0xb541d0f2e8823a068836fdb58dd6752a076d017f28ed0dd48c96c8a102b1b482",
    name: "USDC / OSAK",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0xBeF47A6F7c3d72293d015e3edC3D6b9F2bb49c05",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xbFd5206962267c7b4b4A8B3D76AC2E1b2A5c4d5e",
      symbol: "OSAK",
    },
  },
  {
    id: "0xb4a7c6d7c93e265a4f5b19282eca695815673b5e0b394b825f4208d3cd91a581",
    name: "jEUR / USDC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x74A5a7F2B5AAbCa17b7B13e1491bC8940E8F04a6",
    loanToken: {
      address: "0x4154550f4Db74Dc38d1FE98e1F3F28ed6daD627d",
      symbol: "jEUR",
    },
    collateralToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0xb4a08db3b6a3acd884c853a4dabbc71659c9af1065afd2a9a8f201f29a4ad31c",
    name: "XSGD / cbETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xb9812592279b8D354Ec48DB39C58d7E778590E5A",
    loanToken: {
      address: "0x0A4C9cb2778aB3302996A34BeFCF9a8Bc288C33b",
      symbol: "XSGD",
    },
    collateralToken: {
      address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
      symbol: "cbETH",
    },
  },
  {
    id: "0xb4476dd70a7b1a6cb5ec8d7da57ff9061288fd3004a33598b18eb71789c8d3fa",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x1Df1307C93D9b285f1cbA6EEB7B36f16CAF1a3B6",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xb42cc41fe029334153e4f581b2fb2fa371c8d26308ba29ecb3be0b03bd5a6308",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xA1d8a089E6F6997a89284fe016f775b92a8F4c4C",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xb3920b96dec75b6a1144b71f963f30236fb200f3e33e93c2e9c0d222c1fa53c2",
    name: "USDC / stkWELL",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0xc842d95b9C35bf97842110408A8C501645Fb1722",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xe66E3A37C3274Ac24FE8590f7D84A2427194DC17",
      symbol: "stkWELL",
    },
  },
  {
    id: "0xb366829d8798c5392091f78f2b75b753d5686422ee1c8ac19b711fe799a03c64",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xC3063fBe64b9F6233a16C4F19c90dce41Ea41e23",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xb3665b80a24920646f15f0ceedef399ebd882005e18c17b00e0c8d5d22b3b248",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x0f00CD7F7F212655ab6bd0AB97766e37FB5cAd34",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xb313cac377d844010c812fa2272874cb8416115ab61bfe685c91b994f6450db9",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x2F5Bbd6fe8440eA43dF0fE19d2B8c1Ab36D4C97D",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xb2436aa547ec267e77e7564261003d3ff06079cc94834ed1a3dc9c81610a829e",
    name: "X / RXX",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x5Ed5CF926C427218Ef13B5a682d9CFf3113AC853",
    loanToken: {
      address: "0xeEFab2B43dE9C88c17904201B66d79A9880c3eFB",
      symbol: "X",
    },
    collateralToken: {
      address: "0xE2cB1A81A25285972b0eB34988124eDf4705F2a2",
      symbol: "RXX",
    },
  },
  {
    id: "0xb1fbca3b5eb98c6992236d79163e62127b0d66cf5a1a4adbbc0f5fc79cdcecd6",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x0F7730e6baCbaa2066A32115d92df45004453fbf",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xb1ca3e42a695dcf6a2ffda98de17be83af89821cf00be91d8275415776931907",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x8301231D970a8fB2D2CaB2b341980F7493a09047",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xb1c74e62cbe3721a37040c248e481d175cffb45c686b5b423cd446a063261431",
    name: "USDC / sUSDe",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x5aB4519eAca04451f7646db9c89b7c88dcc48842",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2",
      symbol: "sUSDe",
    },
  },
  {
    id: "0xb18ffe303ca4aede99a1a4bb8f43f115e023a7ecf488481b996c5859f81c9872",
    name: "USDC / wcgUSD",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xa5f2Fd530e82A131899DF95bbD6432Ce7EcB0D2A",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5AE84075F0E34946821A8015dAB5299A00992721",
      symbol: "wcgUSD",
    },
  },
  {
    id: "0xb0b0023b775b9f25e728ef54bca7db7b02f1c304d05f34be2cb1d29490895f41",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xD72F3e4C7F69517c0AeF1268D903d22085254D82",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xb0808784cdd089ed86625148a73b326545b34ddd4b1f31e467da355f8f1a27bb",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xa5572b04D1A422FabB806E9E785D9564ec067DFd",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xb02108c05ee0d047b2851a55156c7d0c4245fb6eedd7ab8a142bcdd1e152e6f2",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x1653B8d901Fb03b0ECEF7F6a81BD740BB02F8dB5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xb003f1eddcaece702f8b34d684840ef913e00d6c9b0e209f67f8524bfc095733",
    name: "sUSDS / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x7Bd7990A47b0DDF52d6eE2B89603a228910C2836",
    loanToken: {
      address: "0x5875eEE11Cf8398102FdAd704C9E96607675467a",
      symbol: "sUSDS",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0xafc52268d5bb76447b7e69098ff7eca26fa74228c66854781fa3db589f9ff614",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x9536D995224Dc5036EC47980effd1Eb705c63fD5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xafa2d80fcc3aa58419dd8c62b57087384bc35de27d70de9c91525276f2b2fd6e",
    name: "USDC / PT-USDe-11DEC2025",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x15af6e452Fe5C4B78c45f9DE02842a52E600A1cA",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x194b8FeD256C02eF1036Ed812Cae0c659ee6F7FD",
      symbol: "PT-USDe-11DEC2025",
    },
  },
  {
    id: "0xaf8d50710a79eaac2a9060741310928615f93cde47c04cf6f3e0aef65ec49538",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x99Bd895AA54C4D0F94F4539D82cf99F446C197d1",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xaf732803e7ee0796b689e7bf7e3797ba7b3379b665e8501899c43a674aa4cccc",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x6A92F90A86cfa2f32411e8d5f413Ca69C50EcC6b",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xaede5925e592b60d75aa359800d812cf1e297e0e0d254ee37e40607d8e3fc91c",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x028f52FE37D5FcA645660f7AC53628E6F8b6f322",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xaed7a3e5924f330fc634513b1d0dcb682f2016ffdad18f850de83be73770a850",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xf221f8893d18c5a4e60C6c03b4F26c6D4f8D4816",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xae7fbf765813bf7979098dd2b942c90ccc1f529caf13c888082dd97a0bd0901c",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x76561e1b71c6C9dCdE2b83ffA99bB9728B8Fbf0C",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xae48dfd38da2d3451e7a7993f66e1561a34d023646125554b53ffcd6e371df15",
    name: "XSGD / cbBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x5ECf0063aD1870F2ee4e010A415629E5881F9dCb",
    loanToken: {
      address: "0x0A4C9cb2778aB3302996A34BeFCF9a8Bc288C33b",
      symbol: "XSGD",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xae38a176b41d760ef9efd682f5065023f18ed7d8fab92f39420f1a9996101641",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x4bFf9C629f19158F464773F69B6c1af1bc93c024",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xae34851a7fc83b198ddb2e5e95952b409e3b619d05c3ff30d502a73872fc489a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x72270b9d98648A58d8E8Ec9Ccc3998A18f7Cf387",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xade6749e981ae94420956cc22c299054e05ac3564cc196bf62f4c0924c03bfdf",
    name: "WETH / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "965000000000000000",
    oracle: "0x4A11590e5326138B514E08A9B52202D42077Ca65",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0xadcdc6b90c87aada3131402b9502715cb61600a752ffb9b15471ff448c7d05d4",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x0CB087918F8d8D8773f7697E3F0B1E4d9d5C9DF3",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xada0c15456c8697540d922ba545c06fbf480ed0b81b0010dcb7c5ab5a26579e8",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xB6394D93dBE5E375C80Ee45938A645EA609Ff1Da",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xad9a1896d6d8b07981f78601b2c91056658dc104c5f0b799dd52717704bd5221",
    name: "USR / PENDLE-LPT",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x02332FD1cCC5e172c4E90427Ec38116AE8D62b8d",
    loanToken: {
      address: "0x35E5dB674D8e93a03d814FA0ADa70731efe8a4b9",
      symbol: "USR",
    },
    collateralToken: {
      address: "0x715509Bde846104cF2cCeBF6fdF7eF1BB874Bc45",
      symbol: "PENDLE-LPT",
    },
  },
  {
    id: "0xad71d3060a5ca5102c03963d47f7d6d4a71bebf43ab895f5669caf08b2a24ac6",
    name: "sUSDS / cbBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x7Bd7990A47b0DDF52d6eE2B89603a228910C2836",
    loanToken: {
      address: "0x5875eEE11Cf8398102FdAd704C9E96607675467a",
      symbol: "sUSDS",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xad6a68ac5e242876df794e5b6592be3b471a20e5a6b6e5e113ccc3a561d1c25f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x75c7eB872C0776444b4F81086e2b40A8d2383B4d",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xad6965712cebc15965159723a310c78936cdfe2e2d8eabc0077cf10ee4e51a8b",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x6E769b18A2BC4924B63DB811b52cC5EacEabbe0F",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xad2f9c623eda791625053a20ed3eb3365bfffca9e37674c82825faa518735ba6",
    name: "jEUR / cbETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xA479f84993855b6cA54Ec1fDD65D5a82B75Ea48f",
    loanToken: {
      address: "0x4154550f4Db74Dc38d1FE98e1F3F28ed6daD627d",
      symbol: "jEUR",
    },
    collateralToken: {
      address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
      symbol: "cbETH",
    },
  },
  {
    id: "0xad0f8a5d31797ab403f95abba7d9702e0efd89a158924732aad005934b90256a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xFAcd18A0a54e77d310af73Dd768A42639B46b059",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xacfcd1f0dff929bb71739b4734afb585e09e67d612d4983d7ae3c7b6770a4dab",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x7DfAf5169aF104bA86DAE12BfB29AdD7d9FE9453",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xace299695115a608a59b3003a67a6f1c4adb740c6c034536aad1b6bb34e56e78",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xd52F754A4FEe588886cd984f2f0C67360243F465",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xace0ea2ff0a6c4b7edc51fbce422be4cdbba45471e395d974c46d619aa2a393d",
    name: "USDC / MAMO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "385000000000000000",
    oracle: "0x18d1325e8528E3ceafBf9a77F3bE3f76Fec42D5C",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x7300B37DfdfAb110d83290A29DfB31B1740219fE",
      symbol: "MAMO",
    },
  },
  {
    id: "0xacd976996284a9dc57bfd9b1d2dcd8964c25bfe866133fbb3f0f0b91fb9b15ae",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xA0372Cde031a0Aec5dBF74a72953E3CF56A1D95F",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xacc328238d63729a0923d5725261cf178ed30464606da0617eb7f25e5ede232c",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x804b5ffa565763f46FbB3F265E3e469dbf89c035",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xacab33c8f632a0405e1886a6dff5e055699a1af8db2f91c6ee06140b812c398f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xE2C2f42C6697fE59fA8FEc4fD02e0004bf536d47",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xabf8648b9cc1eea3eb4026c7a0edb9bdb5c4bcb346b0fe3dc7957e7bed33f44f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xCE5227acA6d1E5601790f02218ae4aa6c9B3Ab4b",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xabb2510939034f31c39a3d0e8d13b75f3ea7a0f0b39df4e7c2d5c84e3b70c20b",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x52A9Ae5a95B43d67C7ba09ef8a59cd15ad9f110B",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xab5413f40e7f089a5f6dae4d0207de95050487095da23a777b381b90ced26ae2",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xce0C6Aa25F0C3E23468769C0090A537DFf002880",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xab3f5662f8308f7f425a4b6f7c968556b6ca9adc3e64a8d3a30c02c93f33ef0b",
    name: "USDC / bsdETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x237a202192Ea0fDBC272198115ddf09cA33AebE2",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xCb327b99fF831bF8223cCEd12B1338FF3aA322Ff",
      symbol: "bsdETH",
    },
  },
  {
    id: "0xaadfda2409eefb3f7e483c984036f63e72b57cdd7c3fd2c87608556c4f83db08",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x675062A0aE4113b8F4E234247c11824043B3101C",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xaad26f1040e3164e6645ffe981f466ed74fb1d229f2d1f253581935e8f135fa6",
    name: "USDC / cbBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xCdEce7670a2Dc5986261c38a61f7e7Ccae8FFbA8",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xaaa3c5d249280c764463621427da741e193848f306829a7ba96f0b45f4b2dfe0",
    name: "USDC / VIRTUAL",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x559fCA3613a4029a8dDf2c1b06fc1904D8D8723F",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x0b3e328455c4059EEb9e3f84b5543F74E24e7E1b",
      symbol: "VIRTUAL",
    },
  },
  {
    id: "0xaa5b2464e10b40d9b9642337987eaee5e91ed4003da62c77d7ee2edfe910188e",
    name: "cbBTC / PT-LBTC-29MAY2025",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x2F8386B6ab372FaF846ac4FCbA5142375B7fee50",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0x5d746848005507DA0b1717C137A10C30AD9ee307",
      symbol: "PT-LBTC-29MAY2025",
    },
  },
  {
    id: "0xaa3f0b469d17d50bcd4489b028d390aa7bb42cbd313c822dee5becc8558353ab",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x9Fe2b9895E80c213D6d23fa408FF1b7FA908fbee",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xaa2d5c43d84b63b629681fd0b8833bab179a6e5ae96a9781eef3c8d1c645fe13",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xdcde5DEFc5565477ab44ce6C4b06a12ac61e4ECE",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xaa00a26a579aebaa4273686006228830a0acdc8287a56851f5300a3db6e72912",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x42E8ce31c6BeFC6caE20748AA1244e8B4e75E472",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa9b5142fa687a24c275faf731f13b52faa9873252bb4e1cb6077aa1f412edb0b",
    name: "EURC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xE1bb8E5b4930eC9FeC7f7943FCF6227649F14B37",
    loanToken: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xa98217b07919beb52ae78bffed535256028edeb60690f824fda53131ad0cc5a5",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x98d3d8a0B6DEe8f23d4157a2d62f488a289C10c9",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa981f51543fd58d6c74e283d33392da3f2bc9b8bd1f7c4aa571c7fecbe4acbe8",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x39b6D790AE0EEec4609a256bc1326BeB9bBfc1a7",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa8c651e64ba480de2f9b965f1fe81643bdfa98eb9ee207ea4f19402875407f61",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x51E7783985c55932B264D980E93AC306463eee11",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa871942e58c44eaec26a6a763eda0c4e4ffda0fde053c70d4ede8f554155d03b",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x864e79830FC4267E43b0591dEEbb7863A2D699bd",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa86321932ed4f432511fac77ea546ff65429fbfd87a2bc4458c7d514098a4294",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x89cC5cD64e2affb3e5b4eC02E8E3A6E7C2037f29",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa833ccee494f252520ee90859f91b8ef87dc152a1442f320bec133c0f7c7c8c0",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x34277F5c530c27B4990274BC582784ac49F21CFD",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa825bbf7721bdea3ac45ec94110344681f6b8a362544461a1a139e98b8f4d15f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x70C26F8CE48bCEAF00aCb43F14c872e7f2cD0844",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa822d3c45ebee04ddf98cce5058344ddcebae22ba9403c702eb413f5e4fafd15",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x30fdDF5347898Dc01d0d98D37AC6bBa6586B9074",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa7b5e330831cab6455d58dde1674aac7237b173e43f93354ace1fe16ca439e09",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x0bcC9fBC1181FB8Dab89F3750436FA29dEeB59BE",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa7813c754ddd6a24e1a1a29ff3ea877803ac63d09efc2f121b1cf3f0bf3af2f6",
    name: "cbBTC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x05D2618404668D725B66c0f32B39e4EC15B393dC",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xa764dc9f975c44dcc0558d19c71dd45ae28cf7cacacd4d5e7b9d2151876021cb",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x7F091D3DB65c4EFEA11070940094bbB514f890f5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa735675acd833ea2ed0f9ac6fad3b47d2a16a6505b1e7b06bed591f89d0a0581",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x74AE7e70d047272CA1A7f0FB38A66265c0f23a8D",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xa6be39105fb7f913e0e3c6eb6c95d5860df9296d10cd43d1b000b23b0b365e7d",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x24c1A332d06e234E14e57F399BE1224b6125eF90",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa67ea0f116451ea09fdfcb504cdc90a3525eba76f6d89d4ca6ab682b6387031c",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x3f7AD0ecc9C6110c59cC9A36aE722f6EeCCADcDB",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xa65f627e942715d199229b5ad0ddac91eed9b688382850e10e1bff6304885f94",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xfa278D3b605ab33B8D6E10F12031D5830A5FE730",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa65f3842e2340bf568af864b37fca8b6a1fc9ba32cb9220dbadfaff83d0f5f7d",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xBE5d5fAAc77a052E9Db02e98fE506769838b5d04",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa63473a7f3ad19645a516d7aada69713fc0e9244e6a60f75496217a37028b2c2",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x8999B80c4620D803C9cb520391a52C3A01bB67eF",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0xa63010b44fe3ad6993917fcc4f01203e1a951d0411777eebe3ce7c5a0a2fe49a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x338F7C5DA11844891c10e8Fa276b330A0D2cF0d7",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa62bfa48791a6ee29ac766cd73c117be2de7afedb378a32ab44dc91613b0e05d",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5C12a04a348B598a5EC982d0938A050c433eA3Ec",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa62bcf986b1b17081c4388347db3f7cd4545637c030a27cb594a6db583ba9ee8",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x8653798B40c3fDBD001da2306C9e366f0E80Ee10",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa60e9b888f343351dece4df8251abe5858fc5db96e8624d614a6500c3a3085ea",
    name: "USDC / uSOL",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0xcA73BdD1840A2Ccd8F3E8CDEa99ac3182e7fADbA",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9B8Df6E244526ab5F6e6400d331DB28C8fdDdb55",
      symbol: "uSOL",
    },
  },
  {
    id: "0xa59f9660deb7daff920574a47e88e249d710e245ec039a74c837ff60c260952e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x61D129af99B705Db926E17AD2748f494952D9464",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa595d3227d32fae1fc2171bf37b5a9f0ab29e7f15722bde34c5dcac4ba76ae80",
    name: "USDC / RXX",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0x5Ed5CF926C427218Ef13B5a682d9CFf3113AC853",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xE2cB1A81A25285972b0eB34988124eDf4705F2a2",
      symbol: "RXX",
    },
  },
  {
    id: "0xa58a88d2a599ce836114bc6160465c6c4d8a9c81dfea1e7175d7f94064038e7c",
    name: "ntUSDC / snTST",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xB21Ce6B3b7b1d7BA9E498c983528899EABCA5dC9",
    loanToken: {
      address: "0xEC7De4956A4569C2a1D171e4dD115a611c8e9eE5",
      symbol: "ntUSDC",
    },
    collateralToken: {
      address: "0xd73F8115Cac5B6817DcC143f3797a2Dc3650181b",
      symbol: "snTST",
    },
  },
  {
    id: "0xa5895716f7e3111f4f56388f474936180aba6aba131619a1ff75c0232a997d41",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x74BE1f72e897f1c4e86F84A9f9179B70563e8aB9",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa522481ac6d89f7281b2a2ab4730ffba97b5a96bc7b21dbd71ffba2c66ddcc3e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x1eBa6aDE0E078786c9406e100a255E22C4685f9E",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa4f99c29b75833cb51bf8fa040dfe8b25b9bf9858f62b18be53a09e3fc206661",
    name: "USDC / NVDA",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x61bb973373e58f29B97e1f9bb128c02a0CC6e1eA",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x3993Ab33E5aE1C081DF87913ab5c845EE2813B72",
      symbol: "NVDA",
    },
  },
  {
    id: "0xa4e2843486610e6851f4e0a8fcdee819958598c71c7e99b0315904ccf162ddc3",
    name: "USDC / weETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x9DBcd79e1f47D95DE6F211bFB610f082Fc584406",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x04C0599Ae5A44757c0af6F9eC3b93da8976c150A",
      symbol: "weETH",
    },
  },
  {
    id: "0xa4bb01e0207f9e6b444b344fc9270dd5b469404bda8841d3cc085843a7dee8f5",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x728A411ED91BA078EA3Cb71B39b2b11c13121fe8",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa4a1178cf9c01d92742615eac81af7e4e44115fcdec8781ef6d9e22f52c42545",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x3E151b2fD05D9134C41b988C7B24EA8CD65805c9",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa45227c759b4fed31d309583c5e561f1feee2baa2421f65bd1013ebd0bb2b7e5",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x187040369e1Bb08ea26D1F4F40B93d808b72dC45",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa43f9db3bd9aa95754cb6395bf3816629daf341e107b13e4ddcf69b40d30bf7b",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x36aE978AF2dE42a11Fe46f39B4F6C3035a1e87D3",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa426ca680bd5a7dc0f95942ba876a7df399cdf8149f798bcc4e94f03e35d08fa",
    name: "USDC / uXRP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x81C730EB0FcC1a7270D0F634026DA24bCD358181",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2615a94df961278DcbC41Fb0a54fEc5f10a693aE",
      symbol: "uXRP",
    },
  },
  {
    id: "0xa3ed1f608c22e44eff9fa886d097920b2546e5f93baffa018b8580606c2ae25b",
    name: "USDC / RLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xD140512AfF28054b0369679f6Fe134C11d34443d",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xC31389794Ffac23331E0D9F611b7953f90AA5fDC",
      symbol: "RLP",
    },
  },
  {
    id: "0xa3ce7ba8c6fe8de025efecb455391bd327da6a1a0ea4800e450c829c467ef8ee",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x636C347026318013Bd97F8814d87FD65862D659b",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa3cc4f06eb11c5ef411b99cbc868f1be68d51a766a17c66c99b2444e0c098210",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x8759d624d2fA57F2e5896F74121c9b00a03cc876",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa31216251a043210e476f2fac2333b9c198e22b6674d8181bae62df30e085e4c",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xb4C281DE1cDAa60f004bcdb936a3Dff2cdA6E8c3",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa290bc018aafbcb4a20c7e2cb8065581fc0efd81778ed5f4ecb73bcc5e91f37b",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xB8a83fC536D164a01cA4730DA19E36c0bbF90523",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa2749ac1e8129fbc2db2fcf2a4619a0d7e7ab71e3588215d15cabb80c95d368b",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x8410FE4C43265501D7e1575E40Cd6BBA323a1133",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa20abfae5109b4af5d2602257b921fd2642861381d527034443b7f4e7a0b863c",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x8D0E0489646AE8f184558e61A4A78a5E7caf0B5A",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa1b737f6077429f21fc60ed57aec00a4940d4cc0bdccdf0aeb94d6c959e509cd",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xef3eadf25d8Cf26642b9882243B8CfA81bdFD2c5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa19b28616578e881726705ec1b328f79ac8ec4525956ddb85978d0a48d44aa20",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x26cef1034EA1540263F82755b37274BB4C83CB2a",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa15c6f1884276e208199ea5392bf8cce7ed02dceaef21a9bad35fbecc4de99e9",
    name: "DEGEN / cbETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0x51f673AEe27BeD2d02eEeDda0F59f4813D1cB008",
    loanToken: {
      address: "0x4ed4E862860beD51a9570b96d89aF5E1B0Efefed",
      symbol: "DEGEN",
    },
    collateralToken: {
      address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
      symbol: "cbETH",
    },
  },
  {
    id: "0xa116d7bc8c3556a63534a0dfeb32dbc031fc162deb516fddba86d8b2ebfc51ab",
    name: "USDC / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x295206568Bd64D54eE3BC0880E6a91055c0Ca46c",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x295206568Bd64D54eE3BC0880E6a91055c0Ca46c",
      symbol: "MDLP",
    },
  },
  {
    id: "0xa10e6aa830d12018c2d402a9c5fbf19177af9747ab39430c2f230d3ed3635a1d",
    name: "jEUR / sjEUR",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "965000000000000000",
    oracle: "0x1552D9E069c4f9875563aC25eCa4E9ef0Bd9d34f",
    loanToken: {
      address: "0x4154550f4Db74Dc38d1FE98e1F3F28ed6daD627d",
      symbol: "jEUR",
    },
    collateralToken: {
      address: "0x89Cc2A57223fa803852b6B4E65c6E376D49909f9",
      symbol: "sjEUR",
    },
  },
  {
    id: "0xa0f84bd5a858602ddb5f031663cc0a119e369560857d0a168c6c3db9c994addf",
    name: "USDC / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x49A48d40Ce05e2f23F2b4a17eCC751b872618446",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0xa0f12bd6f494a9f4853c663250d49f1d0664e9f9721f536822d2e435053b4e7a",
    name: "WETH / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xECa2C68d29fC93370bA20d435f2EF05804C93b66",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xECa2C68d29fC93370bA20d435f2EF05804C93b66",
      symbol: "MDLP",
    },
  },
  {
    id: "0xa0ec718fe590b6d1ebfd0a91547235a5e363a29442b312307e3bf32820063015",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x2967729529AC1DEcf1Fd1005cC9f9aECeA6CF848",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa0a568af6562f6308a7cf73c8b46a8221090b55b9a06a52675f5d9b186b21397",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xceF75B20840AD406bAb3e5ADe44bD7891886e4c6",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa06f3734f264946f0ca310581b6f4f2e803a2449757332a33928361ac687a315",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x95b9cDf04DBC3aa382A3Cc64F26e95815a7d8333",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa06daab6e4d1be24cb61b1aa4a80fb99134bcaa6d04b14cfd0e2707135694008",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x6aA97E89570776d3334B794FdA26e92dED644e9D",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa06be893bf7336d43950e4bf9438ff868fa0aef699f0ad78ef280132144ad77e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x63Af7CD1149F574D86A4991E25428ff23ab5D1E7",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0xa066f3893b780833699043f824e5bb88b8df039886f524f62b9a1ac83cb7f1f0",
    name: "USDC / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x957e76d8f2D3ab0B4f342cd5f4b03A6f6eF2ce5F",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0x9ef608bb3f27eb50ace2847594d71ccc82c52c8eb1e90609fbdd7cf1b0d9e00f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xBbBc27abb46900C53dc003Dc4b46C950b1bCD3f5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x9dfcfa6839e599c91ec1af1f47bd5751dd616f0c727900793e51646a29c2bc53",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xd54543fD10656411B73e10d911d80D46f47FC410",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x9dbc1a60d02d5c3bd1c53bc923e66ecf9dfd9c98f3b59a9772bdd76696630c9b",
    name: "USR / PENDLE-LPT",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x363fcDB17fe6d8e26A1353e66A1E58eEa5B64f96",
    loanToken: {
      address: "0x35E5dB674D8e93a03d814FA0ADa70731efe8a4b9",
      symbol: "USR",
    },
    collateralToken: {
      address: "0xE15578523937ed7F08E8F7a1Fa8a021E07025a08",
      symbol: "PENDLE-LPT",
    },
  },
  {
    id: "0x9d83c7ad8ad204e6ef65275f8a29862c94de0f717ad5f5ef84e21557f0d004a3",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x036eFd34a6441eA3d47f068E6b60C0f94f2e649C",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x9d6092cede2e0e4dad409039c14f5fb01262ba7ce7c49867ff3bde89b740d352",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x2A5347fB285DFf452f8356e0Bc3EC7B9EFE2cf05",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x9d19d9d9c6401753f08c71a568b6ae30e04f7352217d816e3793013ed19aa06f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x006fDa1011EE02c9cd04DA3598165CDD8FAC5a0C",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x9cfcfc414d656d74392e6c1dea275f06abb71a987e495f0baaa067ccf111fa8c",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xebaa5a285E44E67BC3110889a8D534761fd95137",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x9ce535a62e1dea4a838eb889c5eb31719462384cd6fd05dea4cedc48632d080d",
    name: "USDC / WELL",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0x1AE3b05ea39e660c86066fDe5BE3EAa1fF155b40",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xA88594D404727625A9437C3f886C7643872296AE",
      symbol: "WELL",
    },
  },
  {
    id: "0x9cc8439780168e725db427fa130606f2c8ad0b78c7dbda316a80ad1f32685062",
    name: "verUSDC / USYC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "965000000000000000",
    oracle: "0xF19A661db65bF623206e8341a6Eb5F8960AdFb48",
    loanToken: {
      address: "0x59aaF835D34b1E3dF2170e4872B785f11E2a964b",
      symbol: "verUSDC",
    },
    collateralToken: {
      address: "0xeeE7aF832440884d2b693B4193FA2ec26A48C7d3",
      symbol: "USYC",
    },
  },
  {
    id: "0x9c6a42ab610da400ac5d641931e8e1c96e1230bbc5b99ead5d9b21347d758ae6",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x80A814d83DEC07454b2331441bD23c65daAe2320",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x9c57f77115fdfc52a7230cd08ae5a87be89d251deda76bb6e34ea6b86a34ce80",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xaBFBdF99B5b60545786F3ac4B8dFd7072F7898d6",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x9c442841f0321515fbbcb2e0f7b51bcfe2e2f623872efc4bc1c12c369f7a18c6",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x7e430c1f366AD2382e24A8b526A449aA9f38c646",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x9c3d69bfacd13ceea94fa1d4cdfd3319662a4bb5ed2c2a0185d2fe2e09cb1848",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x60C486D0241e721097D01735bd6bc1985f933AFA",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x9bc554d50a4c43c5cda10dd6794808565e450841af828e9a460b36565c4de81c",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xCa14CF82038BfE8d0546Adf9fD664c7D7d3949B5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x9bb280cd267552f444348b8ba55c6175e0b4acd121edf2d534127b0097a3db6f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x7cAD991Ce781c32491eaC43E830d0db90280d0d2",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x9b367446036ef5a649095eb3579f253b4506fb1b46e535e3d08044c2adfdc434",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x3D29D604aB862483974752BDA60A76f33baBA50B",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x9b1946de21f8908e6410ea3fb51cbac45043af51877db37ebe7320bd86e47bce",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x3342AA698ba53fd9Ba78947Da3Ca28B2df682927",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x9ac54a2a4e04d411982f100a4363af80545b3e5a59a7244589928085e600195c",
    name: "USDC / cbETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xC04fE103aEd6487e8C9fd404Cc5D9F0D7C14F8f3",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
      symbol: "cbETH",
    },
  },
  {
    id: "0x9a697eb760dd12aaea23699c96ea2ebbfe48b7af64138d92c4d232b9ed380024",
    name: "cbBTC / PT-LBTC-29MAY2025",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x421722ca925A03E7896084fAF8B397E95ff7A199",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0x5d746848005507DA0b1717C137A10C30AD9ee307",
      symbol: "PT-LBTC-29MAY2025",
    },
  },
  {
    id: "0x9a6703389df0f8e9106c9f9c840bd0812a083bd9689f5e1cfe985780b54fac17",
    name: "USDC / satUSD",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x74Ba0b0F5D36c3Ca9B4e5E35c91EE329292398D5",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x70654AaD8B7734dc319d0C3608ec7B32e03FA162",
      symbol: "satUSD",
    },
  },
  {
    id: "0x9a37f4e01c9f897bb64b6ae4d0404a7bced28644afcc37a11af2facb74e9b6ac",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x294194f3feD29d6781aC91cEd89b152BAD683A4E",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x9a3172b7f548380488dbf3470ac2f8f40459573ae8574ae711e904b00c01e256",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x9EFc5F492CB6af4a8a2E8cc74c5c116a61A85d19",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x9a2e9d35f88b5c419bb5ce7abdb93c12274d737d7223602d6fbaad1b8656ad0d",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xb933b3fA5e7251F48C353366B4871af2CCb75E0a",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x99f661d87af12b62589cdb82333baf68a0faa6f5c811045b0b592fcea64a519e",
    name: "TEST / stTEST",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x7D703869036ad080663bAc01cDC59A36869F51a1",
    loanToken: {
      address: "0xFE6cf90Bebfb5578ED415a09028241bc93CA31c3",
      symbol: "TEST",
    },
    collateralToken: {
      address: "0xD1738949E693C498978Ebb7807a78873edc13381",
      symbol: "stTEST",
    },
  },
  {
    id: "0x99f294c452edc091c988688d501dca78a06ba559065c242b19653452e6affc7a",
    name: "USDC / cUSDO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xa0C1316196189DfcD2fFa412936e1d07c18B8881",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x83dB73EF5192de4B6a4c92bD0141Ba1a0Dc87c65",
      symbol: "cUSDO",
    },
  },
  {
    id: "0x99c01eba8614d773d3b4dc3caf264e3694dc2c3dc04b2652ea492946c44939ab",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x448ae747ABa300552dcBAAD63373d2Ac049db15F",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x995caf6283977748ac3aebad52440a5561c8ade20cc63487c9fb38f0e053c9fe",
    name: "jEUR / stUSD",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x32B898e98033CA12859921618896764299661C10",
    loanToken: {
      address: "0x4154550f4Db74Dc38d1FE98e1F3F28ed6daD627d",
      symbol: "jEUR",
    },
    collateralToken: {
      address: "0x0022228a2cc5E7eF0274A7Baa600d44da5aB5776",
      symbol: "stUSD",
    },
  },
  {
    id: "0x987f96a587beb87f5d01ee3e7679812930eb247c0223e94f11f60c748d13e203",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xcc089a90F4733da31c3c9671e7e912885C5D9Ac1",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x987c86565e72639e60f753d835ef0492c9de13e3e803290df8bf333242174443",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xAfDe017494134884B8C02894e16D71c88ff4f8F6",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x985f76943ecca37bc057ed6434ce89c4f67babb437e4042ece088a7715b70900",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xbc2BBEC514adF957DB5be14724D50cB506011efa",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x98224b60b7a1256b68144e1c2aedf175d82dc93978571e9a6bca5124f9ab11ae",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x15b85f5DaDd8c165809394bAB93e547BfeBe418e",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x9811068a8dfa967e08e07b0595bb687a0c1b2c9a6e3196fa7170aab71d2cdf58",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x10edF597D0cfe6dCF471f6524B9e84Ebde0e2AcE",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x980590c1ec3c33bfce008cf1772f1f05c4220e0828602cd27e5313172fc0b664",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xBa9812eDE99f2Ace8c7a8B1b180D1C3Cc7c7e077",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x97b258fe749602806a619c36e2f0a19d99d4b1d776f1f2138cf83579e0db4f56",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xF570dBDEDb54aFB90331B6988D9D90caee8B4D7d",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x9742e9346adff02406d5c2cc75e70f09e3bb109ab2cf9bcdac34b594e42abf25",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x6bA409cCBA0E53A73199d97A8Ae26840D9b5e324",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x96f57babbed18dc80d3b1a6c2082a8dc08233063445c32b8176e0fa90a6e4a94",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xc66B6C71f51d45668eD14c7eC1693a19032B9D11",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x96d3ac6b4cf992e8bc3dd0855e0c84c18c34a6880f7e005e74c40096a82e0072",
    name: "WETH / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "945000000000000000",
    oracle: "0x6cB45d19700ee83558C06A29D3E57143b71c6C9A",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0x967d0123057f837bc3acfdc2541bc821d01a0b8634a615d39b2be5e53f63f630",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x01f950c24c650d6Eb9bC9b7c2f4016c09F3B8205",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x96166f13072e1045665ff88946abb93aa27a1c75dbb1a4d1643b362b84e74455",
    name: "USDC / VIRTUAL",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0xD46e42225e10216050a89D0421bDdd5Ae7c9FEd5",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x0b3e328455c4059EEb9e3f84b5543F74E24e7E1b",
      symbol: "VIRTUAL",
    },
  },
  {
    id: "0x95df8917729b54af41c2f7c983300900a3e3aa7044aafa179887f34dae801ab8",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x9c07111aaA2b6bea494b1554B5bc79f4b3573dB5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x95d69ed0e844e18ba1b50f5e072ad9f6507c560d7afaea053d16cb74407b4415",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xDad2d2eED8CBd81Ea4F8D0e24d05C027CE20c344",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x95cebc98dceb3d49da0d0e6250fa853b7b15c1c6eb902a186ae9812c2e072d9e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x71972Ada7d2D8bb205B52F7D1FFfb49Ed3f57741",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x95b1499ae79fa0aa3578f197ecfdadf0744c76828e12e431ae84798fbe865300",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x1A7D39E704f1F08550CA23c5820E841b2f8252B5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x95517efff04ba602cddb3c5fc65c53e90b7a8ed240fbc3f7ca4b9622ab3bfd76",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xCb31E36B4B247cd5020A1F2e336c42f35D18d5FA",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x952de154830db0df7f413021f983597e28f10347595ef58225da9f7119d25234",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x0c79ecA82B3F8C34B0C893dDe23d91B26008301B",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x94f344f8db8c950faa45206c269dd0c2787a86ae3a7b988423e1e6e8173ae269",
    name: "WETH / yoETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xBF991c8c88Be948881a4D2168f7b7f3E1ee71DBC",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x3A43AEC53490CB9Fa922847385D82fe25d0E9De7",
      symbol: "yoETH",
    },
  },
  {
    id: "0x93bc97804ec30b2cafad878e081b20b6e762470bd7f1423186cbc11847d35a95",
    name: "USDC / vyUSD",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xab311A5EE8aC3278475F84448bfa99a80030ddD6",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xF4F447E6AFa04c9D11Ef0e2fC0d7f19C24Ee55de",
      symbol: "vyUSD",
    },
  },
  {
    id: "0x92f831d4d42291a346739e11f46275b1a819e50a5570b40cfc110b32fd007634",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x89828Db125d2dcB63064faeA1eE1eBf83434c3E2",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x92d4bf4d6fd1b984f802796d92324fe6d3f6b7f8d69f7c45a5a1115b7c4cbb44",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xC90b71c043fce83B4e24c5666eB33Cf67B5341Fd",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x92abf3388deff304b33fbe9336ab1c07ff6a4197469a9087d5082b29b418e040",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x1D67188f9E5B04C4452e8D9dAC471657221D07eB",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x92a1b8fcfdd3c604b77332f3c3209657533ecbdb5963fbb761b376ba5e3f4672",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xa041b75d2a039b6ea3B10a56Fe4351dcE96Fd968",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x9291259d39468b6ae1eab99be6f8bb6ea2d7e83838fedfdd78c709ad9122bab2",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x64e4cafB10e4Fe715B8A2C25C6349693c01bB2b1",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x92909f67ec1c67d7a97a7e999469c1fccf257612060d521c7e81334e9ddda50e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x11bFD7Db1Ba17AA7D64b82B2067c938f7e7ED4c5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x9250dd854427ce677b52f1234122ab24aa12f0713be1c490faa3926329250ff8",
    name: "USDC / TOSHI",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x7f346Db03Db020d092a19AA8ece27c16c34D3Da0",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xAC1Bd2486aAf3B5C0fc3Fd868558b082a531B2B4",
      symbol: "TOSHI",
    },
  },
  {
    id: "0x923d1dbcd9343821ab1518286780f0b3a68286147479ffbd73de7e56820879bd",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xebfD7Dca82c9e9550ACD703DB0eeDE83a225D45e",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x91f4d612508e70379075a24b722e09385cf8f6bde225a5e618dd3d18a0d08472",
    name: "USDC / SPT-PT/IBT-f",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x577CA5680C57129036904569C4b5cb9bDB949f4b",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x865f8b843e942aacA4D058A8708B57651C0af356",
      symbol: "SPT-PT/IBT-f",
    },
  },
  {
    id: "0x91bbdbd452ed70006c267ddc2d3dbe435883dde887cdafe126ece358913ff852",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x559347A159dfAE9d3456eD6aBdE434281883F88e",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x9198d1bf6051ee0eb67b7e484caec09abb83926601161f1a75722fdd7a4aa860",
    name: "verUSDC / LTF",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xDf515ba34594b47dcFC809b82550B7Aff03A30d8",
    loanToken: {
      address: "0x59aaF835D34b1E3dF2170e4872B785f11E2a964b",
      symbol: "verUSDC",
    },
    collateralToken: {
      address: "0x8c213ee79581Ff4984583C6a801e5263418C4b86",
      symbol: "LTF",
    },
  },
  {
    id: "0x9162a1455ccc630d4ad10496190f4511e3e546ea10de298f6abc81073175f5cc",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x7f779eEC6f7eB838045285e1440b0dE973d2e535",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x91471c954502be74474cac62d1567138fd61d7a1e12aca4586a2c52e32be7b7a",
    name: "wUSDM / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x422AF18042fD658eBeD9686d5Af5c7f7f076D969",
    loanToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x9125d0fa03c3137166df68bcc72283477830de2a4a5536512374c573ad4583c3",
    name: "USDC / cbLTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0x47f961E6653423A77b1EF8Fb680eE53bf7d8a00d",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xcb17C9Db87B595717C857a08468793f5bAb6445F",
      symbol: "cbLTC",
    },
  },
  {
    id: "0x9121f46d8ec93bac38100b30e107a8617e53d8fd15b0ea77c6dca0903d6a50f8",
    name: "WETH / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x9c4EA07905716C4F20Cf2fbb5190169a84Cf12C9",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x9c4EA07905716C4F20Cf2fbb5190169a84Cf12C9",
      symbol: "MDLP",
    },
  },
  {
    id: "0x9103c3b4e834476c9a62ea009ba2c884ee42e94e6e314a26f04d312434191836",
    name: "USDC / cbBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x663BECd10daE6C4A3Dcd89F1d76c1174199639B9",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x90fa2bb09569699879ce04aa0ebb83fe645ccec8cd2f906bc1b8e7cecf8695ea",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xBd98Fb2ed36E4170a205389D29EA0bD2A5c30d14",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x9089a71e4db692629f35ba5e03c85ae03020ddfc9aeceb002670b273842e1459",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x92d6532C9377DAA70C5FafCFe5e61B9c71BbBBBC",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x90226d79fe288f59dc5af0e4094ad0fc8b28dc3ef44330ca05862eb6b6c41898",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5A5CE466F6b35BA28C3B36034708dC0B17022bDa",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x8fc9559e336e791f08cb9efb763af8a7cbf7a08fe6660a7789621e058f8f1e7f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x3fC430A8975fbab8000592577ad50fcd783ED742",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x8f0a67bc956732b2034235a979078fd8d16febd440a6be5b6ff2aa3a6c8b7652",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xc9feB91203a215681FfC34D8b0D9d28968579617",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x8ed36c2eb17ec23f7cf1cc820d6287016a31d379a1db29d9ef97dc4e0703f7a6",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x1613bB6fc314b1E4C722b95f660c6629eCf2B247",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x8e6712368d2f05b6fff7e0bd4e56c19ad22f9743251bbbe8f2f049d34c9e104d",
    name: "USDC / DEGEN",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x55D2b52Ab6D10298403cD499AEA5F34Ec42dB39F",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4ed4E862860beD51a9570b96d89aF5E1B0Efefed",
      symbol: "DEGEN",
    },
  },
  {
    id: "0x8e37be045ca8703abf3fa643f9b87ab4f5a265dc7098ffc26e94fa73c58e66d9",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xaEC824Ea64d2394048a8a0D940a2f9E12D361b43",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x8e2762de1ff3fd3aa3adef3f025622acef974975ce04d07a49ab02d815244272",
    name: "ntUSDC / snTST",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xd8c0ea09a88ecFe901cA242F7776664Fd7eb3f95",
    loanToken: {
      address: "0x7B20e626775EFead297550A80f6E7B5fE9795F38",
      symbol: "ntUSDC",
    },
    collateralToken: {
      address: "0xd73F8115Cac5B6817DcC143f3797a2Dc3650181b",
      symbol: "snTST",
    },
  },
  {
    id: "0x8e1d7258b2ff333403e7b998ddf617f8d21e4c4b745b664626f07824ff9c61d6",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x59596eA2D9F47c77219001f04e8dE12efce04Bf2",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x8e1a07763061c6b9fe883ec888833674819614f5cab86af7558660e49c1942d7",
    name: "USDC / DEGEN",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "385000000000000000",
    oracle: "0x53c8041b2eb7291f7C1B9729DA781C6f04baeeAd",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4ed4E862860beD51a9570b96d89aF5E1B0Efefed",
      symbol: "DEGEN",
    },
  },
  {
    id: "0x8de388b612be75250b019d345afb1cf333ad8d655dc0984c8e6ba708a1255a5b",
    name: "USDC / sAMM-USDC/cUSDO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xa0C1316196189DfcD2fFa412936e1d07c18B8881",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5feDe9d65714907381A76AA9bF949219dD1c5023",
      symbol: "sAMM-USDC/cUSDO",
    },
  },
  {
    id: "0x8d5ab941f6c9ffc3cfae40214d5d0d416cf2f1c65498750f369b45727e558fff",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x77E8806B5318f386B7300e30AD233385a5180F43",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x8cb2884d93d85d6b58bfa6d6ac6772448076a8e0325dad3060bf9ebf9c9ba388",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xd28242c34a448C0Ed864F1f1e8d1C291E90Ca1c2",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x8cb0d41e8de31e9bbad72e18f61b840677545d242a8ff871f7242ada651a70ed",
    name: "USDC / DEGEN",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0x53c8041b2eb7291f7C1B9729DA781C6f04baeeAd",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4ed4E862860beD51a9570b96d89aF5E1B0Efefed",
      symbol: "DEGEN",
    },
  },
  {
    id: "0x8c8abf8ebc48fa1f585f6d112dbef9803855655ad3f24436a95fe4bc0eae1938",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x0286071A4699481b5299C6c684F1c81F45a305D0",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x8c7a1dc4b7c283b633aacec2e6ce274d5ef2f5f00662920005f0c2afcc177c71",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xd175b103861e15d8b249E8f05B1163E16BCd1afA",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x8c227461a3c3805f127cfd99d9d0ff48299fdb111876cde4db4ece15b8814c67",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xbE6e723ff8ef13627642FE4cb3fAd49F21451BB1",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x8c14ffc32675bde7ed0f52ef6fa5c5fe75ce817976faeca1d467583a86945cb0",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xDCcb3266fb57fEd3BDD2a2430C1f852f7eD3D336",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x8b8d2275e4e9c9d20a673d4e9b370659f7c1893fc924b18b0245714772d7e29f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x9d226dFD86B716Aa07cc3a6Eb702F37D99381C97",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x8b81b478ecdb7b015313d0b74ab3de80a932db12d80fe103431855b6b5fc704f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x2a31Bcc83CE40af29398B80c59aEb7bB6c4b894e",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x8b7da63bb2bd9bb0ab61459d5e9a58b53c2d6e2953311bca737a5716cd47c29b",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x79D1Bf4054CB85779124eE8F7302405C75e06C74",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x8b2fbe2d2a3be0f171b43deb77bbed1b74b19678797141e3943c7a723d0745f3",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x6067ce20837c05Cc790CdB917Ac731F478f8a7aD",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x8ae1dc01d3f4fb1b49ebd5e41040a885c3f024ee3247c96ede8b32aec9a758bc",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xc7112FAe5c6Ced5A17973fd82D11E669d8eDaEF8",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x89d19af932c89a9e68fe1dceb9b002ccb72650acbec6f7c1c4313618161384c9",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x3757A1654F7a6D3cD4f921FdAC4c4af80ac3D511",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x89a38cbbd91e8454b30f63523668c6b54af9f0fe3dd44857b0aedf5bbae92eba",
    name: "USDC / USR",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x2F6299aef6e8CC7b41327D67BE0b655F353A8B08",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x35E5dB674D8e93a03d814FA0ADa70731efe8a4b9",
      symbol: "USR",
    },
  },
  {
    id: "0x88dbc52257e51b4979c3d94f3e88c6e9ad82d4d222ac2ff6401b00f893711691",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xd4aE4854E26fFa1d8C4bF6F46b815235c17181ef",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x88d916e23d8421d4cb8100c1a3b42fbf4f6c3140d45c1be5655a7d857d5245e7",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x81f8E1770f0AeE7A4543248a95E7d58764B41dB8",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x88cb824d7d359318c1f42a16b52550ee5067ae86cb9f51c22fc5d801500e6a62",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5c118086026c851F953DB13B19441Dd9178022CC",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x88cb1b77bb6ba7956eaf08925f312c4258a5e7318038882dcffe9ba7704ae0fd",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x970ef589cB210b45C73Dc2dA7A07EF0AE26A287E",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x88554dbfb2488a70c7be3e8ff971582290443aa5417dc40b531d0dd6cffbae58",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xCFfE473305ABB2C400d79117eda65f6e47636Ea2",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x882e78d84838ce5add18390608d31e10f751a155ea307cb516ba954e9b018154",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xFbA3A60792eF121581C8E6D3C4498de0e9D58233",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x87ff0aad672898c24411f98555f958e232c048f41e6d3f2059d26c13fad07563",
    name: "USDC / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xEdfd893bbc1230321Ab6d2a8e491a9f7E61Fc3c0",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0x8793cf302b8ffd655ab97bd1c695dbd967807e8367a65cb2f4edaf1380ba1bda",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xFEa2D58cEfCb9fcb597723c6bAE66fFE4193aFE4",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x86e26cc5dd51f331ecc567e6036ab072401062aeface0d62ce3a54a42506b12f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5136dd52C6eA52691F8bF4C1893eDF757c9A292A",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x86c6c2f819d4629a8c9b414fb755c87ecf70088907ff48d67f81510e790fdabd",
    name: "USDC / MORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x0a1d042B57608444fA8c215302C304457425b1C9",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xBAa5CC21fd487B8Fcc2F632f3F4E8D37262a0842",
      symbol: "MORPHO",
    },
  },
  {
    id: "0x86ab741922ca75d019de3e46c859334c94f8f91a0176eb7f58c607aaf0ec1898",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xC399E837BC9999A3E5CaBC1be5B3d4125562F88C",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x86a4c765359665415f5e62385391054d5e07487af149b1b2f9fb489ac7cb174a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xc0D8A232B282C37153A912b2a16B5dfB128632eF",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x868900691e867d3748beb2f2879bb3d1b92798951a0de1351087eb2ec25e7457",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x21311340bfe3Ee46D7Bd8148049b435E387D4864",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x866724c86877b4b5d778c6e76783b565cf4e8fe729e349aed6a872754e036804",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x30e62dE5858634f376D78542Fe30Af0bcfb1101d",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x86021ffe2f778ed8aacecdf3dae2cdef77dbfa5e133b018cca16c52ceab58996",
    name: "WETH / ezETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xcca88a97dE6700Bb5DAdf4082Cf35A55F383AF05",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x2416092f143378750bb29b79eD961ab195CcEea5",
      symbol: "ezETH",
    },
  },
  {
    id: "0x860105ca09486f1f2b90890b7b15eb53e872978964bd6643907c62ed6e85ddca",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xC9E0f77e87d76c366d22e164343cD79f07c596e8",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x85bafa417a3db994ec4204791e20fa31177b945304975f95e6d91dd58b2bacff",
    name: "USDC / WMTX",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x1c1E58D096DFff526B8ab1fEcA4FdF204b4d2012",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x3e31966d4f81C72D2a55310A6365A56A4393E98D",
      symbol: "WMTX",
    },
  },
  {
    id: "0x85b4ad6fb24933a3edcb73d0e6aa60f0a0304b3ba5b009e154486fcc829e5573",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x1B44cDF35862d5B94ad36E68864E240651F5a427",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x84d9b932e5a505bf6b7cac63183b0d2ba7dad7833b716077d115e7e8a4934078",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5d2c93d29a60127Af6c417a88Fe3fdA13F164259",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x847b2e4d752dbb1d23ca9d0c8c21ee21de390098d53b9c480b9908ae25f2c90c",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xaF3C53D4E9b3121a9DB13Cd9e37292A6e53a0245",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x84662b4f95b85d6b082b68d32cf71bb565b3f22f216a65509cc2ede7dccdfe8c",
    name: "WETH / cbETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "945000000000000000",
    oracle: "0xB03855Ad5AFD6B8db8091DD5551CAC4ed621d9E6",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
      symbol: "cbETH",
    },
  },
  {
    id: "0x843b46a2190b7f18e3ba0068bd8076580eedf416f4ba1df38ca7a7b177b69e85",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x8a4c69344885e3a8dE6bB414EDae7Eca7B3320eF",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x8438ef82b75ba1fcb7aea5c56932148324a850bfee600621dd30b45132f40641",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xc5b060bC92d2A29dC678aBC5B617D489D773EDC4",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x842e13441248394cf66c5f67973d7feca59eca7458528f14690607c3a40f9b8c",
    name: "jEUR / cbBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x79C9A2Cb2D329e7F9d8C40620A3157022A875217",
    loanToken: {
      address: "0x4154550f4Db74Dc38d1FE98e1F3F28ed6daD627d",
      symbol: "jEUR",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x83fb41816a7107d60d38c6b7004976d47849187da1ddf5d1d0996d12cb8bb9d7",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5CEF2CDE6B76b9D7C61a2C855BCefb7dd0588328",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x83b96e9e96427cadd53d825b675c0562d7e8340ed36d0d94487081947f8500b1",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x94638F33372b14683b7B9356b80cB60B00406922",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x83b029bd1eba87cce1a7582e53bca9cfafbfb5e5a684c93a5368e273d98dc582",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x748A7073F04C32322ee2735cdd3556759389f4a6",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x838fd48ca0f8b405e8739d09a0739220f6b7d1a1429ab70db484639dd0ca611b",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x1fEdDe59e04c5101F8Cf02538cE69Cb30e45E61f",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x8379a16d2cf95552b0b2cdbd46477892cc1d001ce11e2a5b2fb78259173b6744",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x680AD9A58E05212094Db3bf8FD39406e5280afe0",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x83262d91702f90d9edf6c737ceb46e59a2bcfc7ba856e1e8448b7824f83a07e3",
    name: "verUSDC / LTF",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x6175DD53A33593B49111466cCE4B4DBBfd565694",
    loanToken: {
      address: "0x59aaF835D34b1E3dF2170e4872B785f11E2a964b",
      symbol: "verUSDC",
    },
    collateralToken: {
      address: "0x8c213ee79581Ff4984583C6a801e5263418C4b86",
      symbol: "LTF",
    },
  },
  {
    id: "0x82e01c45f035bdb11920c4260de94f655b93feb25563cc5a7e7937c6e3ffcb08",
    name: "USDC / MOCK",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0x4b5e24ba60B8a0510bd9B5716Fc98bd6FEc9b304",
    loanToken: {
      address: "0x5F5913aA5E21b1bE4F2F4855da708E3F8dEC1447",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4aD13c3d942D89a24b6028e8Bec9ea2d76202887",
      symbol: "MOCK",
    },
  },
  {
    id: "0x828a3f403906a85746367ae9b78ff40ed19983498fad1d18c781312419a38096",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x6d1dCD74eb13930d986f20d10948E75da94dC4d2",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x82864a432633ae1e88c20dd89435d480374959b9fc2333fd190f1af83a2d6b65",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xfFcA0ae2Bff4dAB39A7Dd36E1551618f8Ee27831",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x81de4c3c5547c35eeb224a4ff21c88419c093e84c6f043f23d88464ef9989859",
    name: "USDC / CLAWNCH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "385000000000000000",
    oracle: "0xCB2E29718B2fdcfA887b62Cc20CEE769816f986b",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xa1F72459dfA10BAD200Ac160eCd78C6b77a747be",
      symbol: "CLAWNCH",
    },
  },
  {
    id: "0x81dcf5304736462b2026db0663bfe198f731563ce9ed277b22b0fb8b0775cb2d",
    name: "ntUSDC / snTST",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x1b5542E0bDE231445FF24fE068Aee75907fA745b",
    loanToken: {
      address: "0x7B20e626775EFead297550A80f6E7B5fE9795F38",
      symbol: "ntUSDC",
    },
    collateralToken: {
      address: "0xd73F8115Cac5B6817DcC143f3797a2Dc3650181b",
      symbol: "snTST",
    },
  },
  {
    id: "0x81b51a1809ca106af13e5723e1eacd6426bf0aec6667b59f6a0cb0f54e9207aa",
    name: "xUSDz / sAMM-xUSDz/USDC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "945000000000000000",
    oracle: "0x523d465710326D13b803CF1cF30Ac34e08B65b9c",
    loanToken: {
      address: "0x0A27E060C0406f8Ab7B64e3BEE036a37e5a62853",
      symbol: "xUSDz",
    },
    collateralToken: {
      address: "0x72d509aFF75753aAaD6A10d3EB98f2DBC58C480D",
      symbol: "sAMM-xUSDz/USDC",
    },
  },
  {
    id: "0x81485fe51851fabbbe9263afe2c4e54cc9d2ae6e59c68e32cd959d9f405f5a9d",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x338806f34339A181204B58e7fC6a6dF52a1cE85b",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x80f8994353b57b0589b3101f37001c981c3b77e6d09cd84510b284082dda5795",
    name: "USDC / KTA",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0xCE03facc0fd74a226d34B0ac42D3d8d88648d8c2",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xc0634090F2Fe6c6d75e61Be2b949464aBB498973",
      symbol: "KTA",
    },
  },
  {
    id: "0x80dad995a6bbe9eecb2782195a118b3d95a363a7929e53e0370bd84064127682",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x0793947F4cd2b85483a306216c34a1D7452A0E30",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x80bb78c9cf8722178d126ecfa4942b5c0ced7825b4eb0a50e8b5ab6604330705",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x56015C1b43Bb332617c871FaD67D074D01743e85",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x800eff742099df6f566a10748c853940d085c79a90fd6b1bee8bb6d01ac520aa",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5f3454eE9f39769c7F49bcf7a81f11552a308b98",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x800c6177f89d6020f311940b2b2c651e45386007fb29c19ec7bfa66a837d1381",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5C11956003DFC94547915eAbB48FbA1368433b34",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x7fc498ddcb7707d6f85f6dc81f61edb6dc8d7f1b47a83b55808904790564929a",
    name: "EURC / cbETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x8C87DbD7A0c647A4291592Bc2994dbF95880fE2F",
    loanToken: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
    collateralToken: {
      address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
      symbol: "cbETH",
    },
  },
  {
    id: "0x7f991a1216271cc9fc00a0da0c62acaf8fb9f322b879795fdb86db2010740224",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x7B7F6803A81e34FDa79db45e05d070951E82eD76",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x7f90d72667171d72d10d62b5828d6a5ef7254b1e33718fe0c1f7dcf56dd1edc7",
    name: "WETH / bsdETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xD41310aCF5fA54CDd1970155ac32D708B376Dff6",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xCb327b99fF831bF8223cCEd12B1338FF3aA322Ff",
      symbol: "bsdETH",
    },
  },
  {
    id: "0x7f21a5b37c4ed7e9362279f5a7cd65e1dcc3d519363a3a27b1bbb81f8f81bd3f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xCeAF48f61a30A8D4650D5D07a1438b30ac447644",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x7f11abc758447a24da49a10579222110ca7857bd2af64310dcbf5e3a2ef66aa7",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x8cFee85e34551431978080C96134A66A889beD1C",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x7f0dba8e0b55856777c5dc8a47cbadb771f75dbd0746059274c8a892dd86349c",
    name: "WETH / UNI-V2",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x4c1B32CEC85861433c0CcF32371EaCFc503c2495",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x88A43bbDF9D098eEC7bCEda4e2494615dfD9bB9C",
      symbol: "UNI-V2",
    },
  },
  {
    id: "0x7eca9e8efeb92196caade588f1b5c93dd00d75476b19c60f99b5a97bba3b828b",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xD22De01861ef5906B8e8aa2F8376E4cB3f30A844",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x7e998f5f4d8e2d5f34301bea4c929df34ff0131e8526b9054d271cea894066bc",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xB9E958Fd7207F44E6bcF82de5C34566D5602Bd23",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x7e790903be9f6a51207405878f8bfa98948accd744f93fbcf120c449157d3a3f",
    name: "USDC / stkWELL",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "385000000000000000",
    oracle: "0xc842d95b9C35bf97842110408A8C501645Fb1722",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xe66E3A37C3274Ac24FE8590f7D84A2427194DC17",
      symbol: "stkWELL",
    },
  },
  {
    id: "0x7e62203e4b49896bf27f9659d1ac3efa1a0bb5818381941e909615cbd2f52d04",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x3060d5e246653461eEaBEE70274Bc11947bbE980",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x7e40cd240d2c5ce6b2580c801350b3fbca216b267909e9b133470dd3c6e06ffb",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xffa4fC20FbfE3dae98751d70DdAE4C790D049384",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x7e3bd8e80920d77db24cacd173cf560d1beaa4b6a1ecbb95185363dd2da9f78a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x4731441E24A1e008327114e35Dbb0eF12BFe8637",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x7e38769b3f0371c99670be75fb0449dc3e6cfb379fea3d60432d4b6deea0817e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xec4D950A682B623Ff62AfAb2D523A0799caB1789",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x7ddab69cfb95cf87da387f46eddb568e07a87ce1ff1854cb04dea8cae380c1e9",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x04eff05f6bb1f493e073D4C35A374374468Dc42F",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x7dbf2a1206e9c1a16edb080c03be81c115d6ebffb66fc39454af45e3c8ea1e7c",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xCe16F6C4e227B47D6aD941A97d4668706F7e6F6a",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x7d8d31b0cf668ae4200fa188cff7403b56625a575da97b88097a76b7e527c167",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x15448E259735157125cDEE0a98a08d4AC7956cA5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x7d7425b54cc221e9b0c4dcd6232045e0e8e479f49612df35d5919b626dc94497",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xC11ff6774E6F34EeD507D80298cd052DcF6C9d80",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x7d126d984fb99a1495355b304abac8211914eebdf77629302a71216240daa525",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x46f0A6a1Dd8979E3803Df1bbb2e65558bA7310E5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x7d117602e9207d7d031d7764508e37f7480fb7af43f1310d7205933ac795407f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xD2C82c56Aeb47DFB3fE4AD666c01183e54515789",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x7cfdb3a451e008b65ae901828345a42d48ae7c8498f38f2ead7273495c4d32f0",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x55D57e4b004A048891d18355996F866cdb90e6F7",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x7c91cb9ec3ca79c796f1e4701cb6ade8e0532afdbfbd6694dfe3b9d0a04e8b5d",
    name: "USDC / yoUSD",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "945000000000000000",
    oracle: "0x77f59C5C09e7ABEF6991B456170930324FE36222",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x0000000f2eB9f69274678c76222B35eEc7588a65",
      symbol: "yoUSD",
    },
  },
  {
    id: "0x7c6300736c5cf47ae7a32e2275f0aaf7d9e4409396939981a1442f4dea578a7d",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xdB6208c599Ed422054e806b6979216D7BCED94E5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x7c33c56222d58b2d5cd7f7b6c14132819e3c63810062bbc86e4642c3495462dc",
    name: "cbBTC / sUSDS",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x97197Ee777B26989B542E68b19cC8c5C51b669Ad",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0x5875eEE11Cf8398102FdAd704C9E96607675467a",
      symbol: "sUSDS",
    },
  },
  {
    id: "0x7bfc79b774acfb61c2516c3a1c0d0ff95233291afe394d3ab2407f4209538809",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xa87C58b1d7CC21A0520ee5f95d66F9bE6F20Ba49",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x7bd8522a3aac6eb27056a72b3d99796e19f5edfbeacdf17b099be591025272d3",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x68FB42F355BbD1106c8DaA19F32306b59c7f401D",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x7bb75133881e63287225e280c04930aafed05174ee24fc9ac704064b21fc1754",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x7d6DC3A01bC8B89CA77A15184c866D15b0Acc864",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x7b1450e0cf4603faf62535113c573c81857c0e1855755462ff5b770c365b3b67",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xbcD12D85BfD5514dD37f940d86C762dDDF2FAe35",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x7ad5f067dff669d6a2e2b46db419cb93e6b69d75a55eae88f069af20175fe01b",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xc7E25EBe08B6FD126E1A9210c2472018eb2F1778",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x7ad15370ca83f859a8dcbb9256196da901fce3a197cb7946d1276218db0178aa",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xFF35DDd3F987735e54ce64d624Abe3edEd497f97",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x7a961c7b262ecafcf99af8949f05ede6408d6af9a6f3a84569d7b12ff2dc18b0",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xef7844fC1F55A731fcAFfe9C5d144C970c258DaA",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x7a4c2b2a0fbc16826013d41f7ca7910e4f5dcdca918a6e120be9531fc90841a3",
    name: "USDC / hyUSD",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xD93F135Cbe98338bD8b7cA043AAD8FB1d86ACAEE",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xCc7FF230365bD730eE4B352cC2492CEdAC49383e",
      symbol: "hyUSD",
    },
  },
  {
    id: "0x78d6171db915f8f4a7ac0341b4806f3771cccfbd161f48e0bfe333cda8b6433d",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xCd3d4ff0068bD1392B4301f08e7292827bc75a80",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x78d11c03944e0dc298398f0545dc8195ad201a18b0388cb8058b1bcb89440971",
    name: "WETH / weETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xcE629400c6AEdb64f087CAC40Ae6a382AEEef490",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x04C0599Ae5A44757c0af6F9eC3b93da8976c150A",
      symbol: "weETH",
    },
  },
  {
    id: "0x78934185f54ce36b3378dc34d7ffec6f767690328f4095e52872228ab4a7eadc",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x29C1457032d7ecfc572951113666D207223cA469",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x78284411dedd18d6777c04222aa61a14d90c3b10ec9b93fcdae25803b20a912b",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xf3bae41910D8FccC10f0403D61f0B0566f40C1c1",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x780c7f15da07b8d623d62d5486f8dc4d703a5fe5686eb335b4a380c3f0fc08d4",
    name: "ntUSDC / snTST",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x068b414f91ad85ed640f3826a4101A4FD284fa6C",
    loanToken: {
      address: "0x7B20e626775EFead297550A80f6E7B5fE9795F38",
      symbol: "ntUSDC",
    },
    collateralToken: {
      address: "0xd73F8115Cac5B6817DcC143f3797a2Dc3650181b",
      symbol: "snTST",
    },
  },
  {
    id: "0x77dbeccdc5f6c7e55c1dcdbf42f205287def3c20207be0941695064d0acb57f6",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xDDa61EB4Ae743FDbfC6F37f32b59024833F3D9a5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x76e47fbd943cc5f8a73199fc5f3a9fe11d8735c5c79469a2ddd98502c677774f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xF8033697718437074B58045250569f28B2fCc8d1",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x76e0a493dc942911f4f451ef2b8a0c06cc3743b86838b9b50733d2f0df88cd43",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xF218267E943aB2aB3A450E829dB9b78918aE11B5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x76dd0757406325aaa4b5f18fe72f927527eb688dd80898c20162657d81231eb0",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x0508b8e53eDdFB120154ABA89d8A5905BfA5000c",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x76d92a90e57ab633898a32a571474213a3d3fdf0eabbea735f41f57f264ad23f",
    name: "ntUSDC / snTST",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xD9c1d436BF698E21138F369EbB4B75391840Ea06",
    loanToken: {
      address: "0xEC7De4956A4569C2a1D171e4dD115a611c8e9eE5",
      symbol: "ntUSDC",
    },
    collateralToken: {
      address: "0xd73F8115Cac5B6817DcC143f3797a2Dc3650181b",
      symbol: "snTST",
    },
  },
  {
    id: "0x764ae8bcd34ddb12024f91fea378d83127e6eba6c2130bd80d5d552f87758675",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x6c91A1D7e85a505d3E2084368fB753E54ca87750",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x762ab85daa002910fe4274b3d1eee926c087620f6d148464ea168fbb82317a65",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x20bA300a40fcd9b70A823D9757556B1a384587f6",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x75f24a832a5fb06d511c9197af0e5d347d85dc995fea6533a893615ad9c76841",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x520Aa501e704F4631C57bc04A6E83F119614154e",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x75eb530e8b5ed1d3e43c545d338d0bfbb47bc5a39d1b92dc33b49f226620d109",
    name: "EURA / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xb7F80AF0866cd3Ec26E43081FAF71C3583F6E390",
    loanToken: {
      address: "0xA61BeB4A3d02decb01039e378237032B351125B4",
      symbol: "EURA",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0x758ac82c95ef3ac936a812b5f4433f7eb14803dbe8d6d8534fd17215ede99bb1",
    name: "USDC / TOSHI",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x830aF61716777A735978e51Ee7393a37cb20587a",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xAC1Bd2486aAf3B5C0fc3Fd868558b082a531B2B4",
      symbol: "TOSHI",
    },
  },
  {
    id: "0x755167204a9827bc228e468b13e41f4a0141ce1158bfe464d7abdbefd7416748",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xa7fC849836DFf339004ff5eB85233b3F6D1462ED",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x754c962f1ceedf517e7a7b6dae0e34c28146de9f9c6869b5c503860e6722fa91",
    name: "USDC / cbETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0xEfbEac81b81F7518f3d572643DF2740ee87Ef6B7",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
      symbol: "cbETH",
    },
  },
  {
    id: "0x74f6f8aa6b3322d51c1c8b8985cd383d6d941da9f3cf0bf5b5d07a6fa585eabf",
    name: "WETH / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x556d8b15f58Af0F1a950C36c41c79EB6eaE24e37",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x556d8b15f58Af0F1a950C36c41c79EB6eaE24e37",
      symbol: "MDLP",
    },
  },
  {
    id: "0x74918a8744b4a48d233e66d0f6a318ef847cc4da2910357897f94a33c3481280",
    name: "USDC / sPINTO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x774c111F471FBa61B13D63C9B585882e3c6cf7A6",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x00b174d66adA7d63789087F50A9b9e0e48446dc1",
      symbol: "sPINTO",
    },
  },
  {
    id: "0x747308fdaab28edc1cd66deb74ecac04138146531a16b6af8f538b94f672bb7a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x9f2650C30655Ac499886d39e4175297d12e58fc1",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x73fa1e5668d69a7183db0c43bc4fd8d987f47b2a1dade1043ac1507d8e2b641b",
    name: "USDC / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x8C7b649050562674Aac7fE00c97C8CeA91EE60F6",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x8C7b649050562674Aac7fE00c97C8CeA91EE60F6",
      symbol: "MDLP",
    },
  },
  {
    id: "0x73e26b5b89fcf170ba0e448a0f75956a365780ab4a8264d3f95c30ba658a4756",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xeCE4EB9514FD2Dd9AEd85A3836F1d2a2feAE7444",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x738a72906ee7a6034458409dc185d4e40a5c64e93731eca818c386ba5e7d474d",
    name: "EURA / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x951095C09f524BC183408f0001fc91458f61b497",
    loanToken: {
      address: "0xA61BeB4A3d02decb01039e378237032B351125B4",
      symbol: "EURA",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x73527ddd796e6d4f48387adaae36f6f3d49d606d7f2a15eb0c931416a58875d8",
    name: "USDC / cbDOGE",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0xA9D36600Fb9eba7548857e61F836Ec951e3091B2",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xcbD06E5A2B0C65597161de254AA074E489dEb510",
      symbol: "cbDOGE",
    },
  },
  {
    id: "0x72ee1ca7bc603f40427a977672aadc87893d5b661898bf6674ea3c91c25a1e7e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xDE124a290107896d2281745041EA3e93A2D29f65",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x72defbe3b6b9f9799801c74b727bc614d81ede34761c967e2f32da7ddec8a1ce",
    name: "USDA / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x040ba460Ed355833a0693348421C7f1fd831D0c7",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0x729aca58df2b595fb8b4136ace0356098e6bb5c4ffe4c9deb6c7b1f9ba91ebfa",
    name: "USDC / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x813137F9Cc4bad9Be4ecF82D56BB2B8b81859e5F",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0x7210bba520d0da055146a74af5c452fc65e1a7674a7de3709c1217082f1f153a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x433df14581596947a943C32cbE285ebe211d32E6",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x71fa90a776156555f8c54f2d2109eacbf955ed6302c35725024d94a29699695f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x0daC2168A266E6b3B95828620fe8d9ACC114c464",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x71d8079512d630178c3e2e0e1adcdf36f7c638d243969cdf9fddb811aad88783",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x49d09b907363B8B00617f2bEB43502428430596D",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x71b8193c4f2ed2cb316933047ca7ca2ace55b68f9828425ca982fb27423bb693",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x78d13504b74d9F97428BbB1aF7FA32aDE815dFf6",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x71aac07602c6d0d8fed9db7403ac557a5ebe73dc83b91cddb675df27d2f4ab60",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x318baeE2aF9B9974Ef375c465143BA53945a4903",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x718ec58773d3d5841c0b7bd6492a982a8e602579b7818a7cb474976169ec95e2",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xd39c3f55c90d567451E76a41f6A234B4440AF86f",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x718930c5327b0bece97a293c1f8e91c1505bea97e483a7a9dbc9bca4d559a848",
    name: "DEGEN / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0xDA3f83C1Be11a03D3649bcdf550d4786c197F91D",
    loanToken: {
      address: "0x4ed4E862860beD51a9570b96d89aF5E1B0Efefed",
      symbol: "DEGEN",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x716300d6d76ab10f4d69992ad0ea0f72bd12c53f47db96cf319c754c8d528c22",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x8A3644BFe2abBc4B26FDc7E8e4d2Cc52f169D9ef",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x714c35fd09abf2dbfde90f4501260ca482769591a27e2887aecb1fd13d537f1f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xCa74A556BA829C467355aF48b56e28Ee0a869f64",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x70ce870977cfb1af3d6322b59b6b8f38fd48bdcb94deff4a5659ba631e928914",
    name: "ntUSDC / snTST",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x2199b4458ad4f30c08a9a91D4Ee4f5837ACa44A3",
    loanToken: {
      address: "0xEC7De4956A4569C2a1D171e4dD115a611c8e9eE5",
      symbol: "ntUSDC",
    },
    collateralToken: {
      address: "0xd73F8115Cac5B6817DcC143f3797a2Dc3650181b",
      symbol: "snTST",
    },
  },
  {
    id: "0x707b9825d33fa4352a5c75136444a2f6a7da955e4a9e340d9041820ca374132c",
    name: "USDC / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "945000000000000000",
    oracle: "0x8BAa10E0d41105ee108Bcae913862F070fdE21CE",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0x705acc985ef318a25e9b6bf004d34bf2c0eccbdbb3418b0e82a72568d225a9b5",
    name: "USDC / uniBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x847f962F47d647e662f7eDe82E73a7Bf3c282B8C",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x93919784C523f39CACaa98Ee0a9d96c3F32b593e",
      symbol: "uniBTC",
    },
  },
  {
    id: "0x70284ca4fa7df61319918dbdfda42c333f1a8406d9ad624e6ad794adbde3ad03",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x90f60c84717A4ee609BD411f30a2aa129779F9C1",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x701de4ace34e0b8a553e3ea95cb4a5614057009d034e066d04829638ed51f8b9",
    name: "USDC / uXRP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x7C5b804412E862a03C97831490150340Fa4d5ac5",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2615a94df961278DcbC41Fb0a54fEc5f10a693aE",
      symbol: "uXRP",
    },
  },
  {
    id: "0x6ff5bb0836bc95d513a55f3718f50a91f68a78e41430d10a3eef60a7abc27900",
    name: "wUSDM / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x34418C10c669a36588b841C89d0F2DC854C4F712",
    loanToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x6f32dfebd0406c75f8b40a52257abd4327b0316e1c88e5911569621b6c7f29f7",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x27feCc6E4201f5208FEB2d5ebE111f2b9dB599D2",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x6ea8a718b914ebff1e248695cd6261e6b44b8fc2fcf14aae35666194127adb54",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x01D440129ff8fAf78164d2f665980815d9d2679b",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x6e7d8dc3b65459cf7ea3cc571215b6bdff2a29ed6143e31eac5d04ef1d9f8107",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x58578a0287cc4d49917C7A046333fa10C1D8C045",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x6e36c5c73577eba0c6f3fd4c9da0fa1cf7366fe0a496482bcdfaff2b0214ba4d",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xcc05B52a52B43b237650C8C4ae5A7a670E35856a",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x6e0f34fc2f6de8c168f8f7abc875efb7b19aa97cb6a9288334d8285f9b62e6e5",
    name: "USDC / stUSD",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "965000000000000000",
    oracle: "0x2d3d5024E7Fd8b77E0Cc5539d25106942cDe346e",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x0022228a2cc5E7eF0274A7Baa600d44da5aB5776",
      symbol: "stUSD",
    },
  },
  {
    id: "0x6dd9b66e320253e37b0ca553373454b4ef94e0391843e23e80af8b78553b5ebb",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x364271c3d4E367F7e4c4c1C076f1b217Ff817977",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x6d6092daaabb0a31d2ddb409e4581ff1c481714a9eabe8db27d1fd8ef173d3fd",
    name: "USR / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xa79e9EC3458fEd729E7A0A1A1573e6a29E875d5E",
    loanToken: {
      address: "0x35E5dB674D8e93a03d814FA0ADa70731efe8a4b9",
      symbol: "USR",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0x6d547d1dab27fc86c9ca1c4e049eaa8995095cdebed6b9eeeb3ae9b159c6f73e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xaf2C86cd75a758be75423564F876cc6B12750B1c",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x6d1068bdce4204b3f8021b85620ebc3084ef358805fa64d5b6ee2acb82de6364",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x8694780DC874A537a5C9179cfbb8723Bb6804871",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x6d0af15228f6455f1aa619512710913277fd153d87e775a70ec17c7f0099fe81",
    name: "USDC / aprUSR",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xEE5800b2c736e1350382A8bb0A429558Af2a838f",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xC484D83F667b779cc9907248101214235642258B",
      symbol: "aprUSR",
    },
  },
  {
    id: "0x6cd5d26248bc36e4f1e8b5fd6b5591be3c1a554aaab7e3482ab5724f25e28100",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xa180beC75dA6Ba6B9ff6869a02FD12f707666CA5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x6cc7e3bd72000f090f489fc62c17240e3523742cd2fda469cd240bca34c874e9",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x9384E63DECa255F7eE2Ae506Ae3d9ED48d59ac1f",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x6c57249bb2c0ecd5e3e71df6e3e418dfc60bffdab62b67b378733e4b0d34c8fe",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x6E2D2aF8510C44B831c3E78dd72B9a9f495131dE",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x6c233a8c36f478ccad634932926e234dcc6eccddbeb7b3f3e2188deb2a96b822",
    name: "USDA / cbETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xc3Fa71D77d80f671F366DAA6812C8bD6C7749cEc",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
      symbol: "cbETH",
    },
  },
  {
    id: "0x6bdd8bcc24a5c36fd47a888980cd76a71cdbe724ac5e7773bbb0bb3e2c3fae49",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xC1D687293d24E74B984238B54999533E05D0fc91",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x6bb54b445584bb88e435aeff5bc5ee026f1dba1d42909d0baafd85818097087f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x41f9CC8C686f5fc9fec6339E997fA7d343484654",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x6bac0f6c8b598a04e839a3fc048212291909c40181ee7a0da942ca5c5203a4b1",
    name: "DEGEN / USDC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0x30f505E85c95ad83B019346122907e5B81AAE355",
    loanToken: {
      address: "0x4ed4E862860beD51a9570b96d89aF5E1B0Efefed",
      symbol: "DEGEN",
    },
    collateralToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x6b9ae1cffee7a4bea3db33e408ddb709655bbbbe6e08bab93065f6a777e65173",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x744FFE235f62A617FA02Ad334781de1646Aeb155",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x6b8ba5e82e2cd37ade17fe5ddc632012958a1fbb05f282fb8dccb4a77663eba3",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x242bED8d97688734d458BEC1268f9deA59ef855D",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x6b52694164c1c86d6e834b05b8d35eb5d178ca2587a059143ac8b159a4dcf225",
    name: "USDC / KTA",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x550eFC70B2d683FE8981224395B8989a452D1384",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xc0634090F2Fe6c6d75e61Be2b949464aBB498973",
      symbol: "KTA",
    },
  },
  {
    id: "0x6b47fedd2507f9f55c0f222daf5b2ce7f2bb28cc64fa42b26646f247e48e671c",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xb32e6d453dB8E89ae365445c48805507ffb75C4E",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x6b120f23813409e99dab96a7bbf0e0ac4ee6441f45aed0425f7a205ab8fe1c8d",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xfb4e331e11f753d8f7f90AC89D339a6a9Fa6C0D0",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x6ade8e4797a3e8fdf1faa832e8e524a3fbf4518465b96e08db0368ab95dfddb0",
    name: "VCHF / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0xcFAb06D788C9152D863406754c70812CDA24F5e1",
    loanToken: {
      address: "0x1fcA74D9ef54a6AC80ffE7D3b14e76c4330Fd5D8",
      symbol: "VCHF",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x6aa81f51dfc955df598e18006deae56ce907ac02b0b5358705f1a28fcea23cc0",
    name: "WETH / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "965000000000000000",
    oracle: "0xaE10cbdAa587646246c8253E4532A002EE4fa7A4",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0x6a331b22b56c9c0ee32a1a7d6f852d2c682ea8b27a1b0f99a9c484a37a951eb7",
    name: "USDC / weETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0xaacbD2BbCA7927F772145f99EC942024Ddd0FAB0",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x04C0599Ae5A44757c0af6F9eC3b93da8976c150A",
      symbol: "weETH",
    },
  },
  {
    id: "0x6a29ddd6882902c8d56aada3237a38add93e6f276657f75b583c0bb4d8629acd",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x07aFCFB8Ef6af2E3f3eefB2A20a044746319F121",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x6a1b17aa208cb8dc01c69d6c46de656c9b5542fac515d78764c48d412a108719",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xD2F8d87e0f94d704d7A231a783E6885F3dA3237c",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x6a0df2ea57d5eb19a8265ed43678a2fd9b66e3e0019a573ed82aa7ba748772f7",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "945000000000000000",
    oracle: "0xF1930F371aED07CeEBFA127a39811072f4Aa8BD4",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x69da267f98a85b9e59b5b0407982b69a5378c351b57110303909e00cfbcb87d4",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x9d8cCfDf1B126543E3903098a892D1F94A78534d",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x69d68cee8367e2ab63c262a5c58c856bf255fd5f9db397d9b3e32e0e212ae975",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x1498C1Ba2517c25df0D860A2977cfda58C8b9131",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x68fa047cf08a7ca95a6a3c4ec236a89c15b0060e0a28d6fc4405a414e629da33",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xcD0F423726829df255e66856dD3f732f00142d78",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x68c9aa4a34df7133b8a72e20e453195f28b0bddb2f55d4b24008951033a20793",
    name: "cbBTC / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x885dA8F13821369A3616a561dc62E245f3935aa5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0x688e1cf87832c09438a92051aece05ce030aaa04543dc95f6918ee5e4b12d9b8",
    name: "USDC / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x9C005A17721C1Be0b63ed18C3a29BEe4Dca9f74B",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9C005A17721C1Be0b63ed18C3a29BEe4Dca9f74B",
      symbol: "MDLP",
    },
  },
  {
    id: "0x68553c0add890e310d43839a9dded5d7db05cc94bdec30c90c9def8c5c09d2d5",
    name: "USDT / USDC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x87F81eCD75a8b22D61A80C7FC41aBA285Bb38faF",
    loanToken: {
      address: "0xfB9BD0Cde61c6aEDa32e8f4fA866dF87b2583d98",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xb48bcF35acD74E69BBDeF17cdBEa9DE9983e786b",
      symbol: "USDC",
    },
  },
  {
    id: "0x680f4dfd7af2baa95465a72773e1865612ee0222808a7f8acca6becd70d1be45",
    name: "sUSDS / cbBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x6999f231968B8ea5288633388dab00Db80299D7e",
    loanToken: {
      address: "0x5875eEE11Cf8398102FdAd704C9E96607675467a",
      symbol: "sUSDS",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x67feec8bfbef76d45730878fbbfc7fb45a771ee117ccbfbf32345bd87397af82",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x6914cEF56D2dA18F532F606076A3a13c58bFB609",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x67ebd84b2fb39e3bc5a13d97e4c07abe1ea617e40654826e9abce252e95f049e",
    name: "EURC / cbBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xA857411CB2231a6A87a3bEF987a4cED8A067d799",
    loanToken: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x67c8c0757b4ef0df1fecf01af1d5f7b5e9ca95bdfe3fb72f87848226ce480d1a",
    name: "USDC / ACS",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x2B44D170711F910Aae58bce6B01F7ae0d95Cdc26",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x838E6Dd186a7bf9F5C51207C5d6E4564f6B71056",
      symbol: "ACS",
    },
  },
  {
    id: "0x67b08f8a35cbdb51d482b88e309514878b9cef5525622d07450a0f02bb35013d",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xe09806b4DAB527e59F3982220FC9abC46453E556",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x67a66cbacb2fe48ec4326932d4528215ad11656a86135f2795f5b90e501eb538",
    name: "USDC / superOETHb",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0xFEa2D58cEfCb9fcb597723c6bAE66fFE4193aFE4",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xDBFeFD2e8460a6Ee4955A68582F85708BAEA60A3",
      symbol: "superOETHb",
    },
  },
  {
    id: "0x677b17c2a1339f1a42b46585bb0b124cab42082fac11baf8a457843d024273bd",
    name: "wUSDM / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x06C4BF9B68D527B42b32aCeB582F89ff9baBead6",
    loanToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x6779a046299b9e014344f2a7cf0c586e66db160aa24e5f9c9074c7727fb5b164",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x76A74D7B2EFa99cF1BDCfF7334DAaC6487A69C43",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x6775295fa2430842b2caefd9e866d1a23df3ce2ddbcd47c7e5ddcf87dc188bb4",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5382bB2332B1FEf47eDacfD2EE15F84e8b5f4450",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x676e19f4450003b1f4e19e271bf65fb3168ebb9f76c3824f933d472c5a6aa3ea",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x6367281526Eb2e6E8ED88Fa7E4BC13480E24f47E",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x671e766fd3855475c81e4e434b8f2fc5e1c875f56103b4aeb38e05a3c8345b3f",
    name: "WETH / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x0fE39ca5D6FFAF3c2F5b01c9EC7dc15800Dfec44",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x0fE39ca5D6FFAF3c2F5b01c9EC7dc15800Dfec44",
      symbol: "MDLP",
    },
  },
  {
    id: "0x671b120378e788d83d486595581053a74a368a12971df2e462c71e9fcbeced5c",
    name: "wUSDM / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x8eFF1889bf9A38fc6dEadeAbfa0e5fd05eDcB562",
    loanToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x66e9cbc84bca0e36a4013164cd59855dbf63bc3b66b136227dad134a60299581",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x66C0Cd2D1848af129E264cBAe096D9eEf302921D",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x669b68ae003954dde5b2be025fa373bfc6b6134fc3180ea746c31e892243ae81",
    name: "USDC / PT-USR-25SEP2025",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x6AdeD60f115bD6244ff4be46f84149bA758D9085",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xa6F0A4D18B6f6DdD408936e81b7b3A8BEFA18e77",
      symbol: "PT-USR-25SEP2025",
    },
  },
  {
    id: "0x666749402b7d3772fc105c3a43d6d56739313cdd24828c685f6f9f86098a4826",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x643f868523Dc71b9c69a15A963160220D90f813f",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x666190607a6eddcdfc6bd753a47fb5211e5498a46e80e8bb367c3f0e79c02629",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x62c60ceE2722AA862a0A57a96a23B0E6aaEF0A9B",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x663d1c574cc5ec256c4256c8ed12f3cd7696f180a8f142a86a698f5989caa5d5",
    name: "USDC / smcbBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x17e5A6D185b7C0e428cd2F3CF4592e8B16a982c4",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5a47C803488FE2BB0A0EAaf346b420e4dF22F3C7",
      symbol: "smcbBTC",
    },
  },
  {
    id: "0x661bbfc156e3aa2eb3f8f66034e5f5e2e8031c71b45664825c514d171a75fc6a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x4E3EC5e9D61A64Edd6ee8509B3f435Eb561e4225",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x6608b409e50a08e3f9f62f2447ba7a3e642c5775078cd00bb99b193ed29563de",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x3aD02A32081eDa17a2dcC06ABC25373100Dc6AC8",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x6600aae6c56d242fa6ba68bd527aff1a146e77813074413186828fd3f1cdca91",
    name: "WETH / cbETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "965000000000000000",
    oracle: "0xB03855Ad5AFD6B8db8091DD5551CAC4ed621d9E6",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
      symbol: "cbETH",
    },
  },
  {
    id: "0x65e7fc989c0c8136b0626c41ebda20ecdc80eacc5079b21e9b1a30efc2cc28e8",
    name: "USDC / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x854cAD406b9F687E3de87A49A0A08B451430F81B",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x854cAD406b9F687E3de87A49A0A08B451430F81B",
      symbol: "MDLP",
    },
  },
  {
    id: "0x65bca5c0c3b258ff3308b1b12c6b1b37327a91a461ad72c74d67e2dccf127e8b",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x2D6c43C405557EA921fD4Ba2989313Ca1093805A",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x65ba6324cb06c59eba88fad6211ad53d3c8725e35ba6f02ff75dbc071bc56baf",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x2cf7e725DED3Ee299E6B6d5B33CFB60cd00571b9",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x6555ab613b022aba3386e58891216fcfa57b9f063ad43db52e0e1d4ff6416d23",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x2935535D05a4Eb475bd0e20e1edB4EBF7f30cBd4",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x651c9a7bfa6710bf1d1024c112765de1c22defa846d5f0518dddef48db0ab7fc",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xEDA7eF30dB3538426BA6eF7ea0B2eB19023C2D26",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x6501fc138e726346f8cee243faee150495bdfbe384017e32112fef988f5624d8",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xB0e545B3a5BCd8c8a8D215b39E457215F7833e53",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x641bd86f229ffccd9a5eb97913458a0b7e66a3fafbfb49f2461c3a098d0b35fe",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xf8AfE58FEA0ab5558A7a98FAbE2a37452771A625",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x63eff0ec9fa4cc5b620db8c5dd99be911a7c3ad71136493b6eca5505dae9c044",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x0E89E08727bB840d17aC1626Eb0fb2BE32396A9C",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x638646c3baed6a7df0f3703fd06e297e405683fd868505b2689c3aa91e86ee65",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x535570901a7E1E1d8aa34A72BF139cdCF35e1291",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x62f749484c23634cb8e4a2c68b7f4449466c8f95a6760baf8f8c6373b2570431",
    name: "testUSDC / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x957e76d8f2D3ab0B4f342cd5f4b03A6f6eF2ce5F",
    loanToken: {
      address: "0xBC77067f829979812d795d516E523C4033b66409",
      symbol: "testUSDC",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0x62ca006a95a967995cbb203ce9d5df9c5ad7ecdfa396b5771ebd800488f981ca",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x9f0e8Cd1c317f57A170f43Ef3117C0765194D9E6",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x626fa3629da725ba586787e286c6e3f9ab86eeb0348000d037af0fb9341c2d13",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xEd8e992776204d213CFeE4A6C5A0335067028412",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x625c68440f034942f7b77d9a29ec408feee44939c899f4b121618843752ff3f4",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x95FF87CaBE8AB15559197A1491425f2508657AD8",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x61f0d31006c26197340686e13df544fd58672496e4e21b62bb9b822b64ec4dc4",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xF7B15A41E5e0401764e2C280c1Ee67Ede134ea47",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x60f2541ee524717b9b08377696fda4bdbbac3512b6f4d141f06cfa001c502a48",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x10dD2a90c7911FE57535a81C938eAe908AbC7f99",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x60a2c1d461ff6ae75874712a5512cd3f6208b8ba3f144d8bea46c25303656a85",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xa26843838463a3AC7Bb7Cc59fCDb170fe1E5a70B",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x609bc3e3105310ab3d929b149678ab0a5e125ec97d45fc0574a4675badbfaeb5",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xDfb50a194c4438eD809F3cF0D7DC4ebD0df75a56",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x6066f671e32763bf7bd463e426a71b45ee4a5c6fdf27486583a13040c77e423b",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x04B007cD21548B5BE5CC06678E9519f17Aa89D10",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x606173d7e7935a12f5cd0c247774669e6a9204a741f9261dc3f9d4cdf2d19a55",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xFEA6D020d6633138D58739F2d6eAFFD376c52d41",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x60102572993d773f2b7308178ee49fe422db48823204ad5b9217df4b0cd8f215",
    name: "USDA / stEUR",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x7d5e34DECD88c1Cb6d25A0c07990Aa7BF2e28b59",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0x004626A008B1aCdC4c74ab51644093b155e59A23",
      symbol: "stEUR",
    },
  },
  {
    id: "0x6007750eb94d1f5534cddde5de06e9fa83d86e7140fc9bd580011c8ba1a70a78",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x4Cfd94cA6689aB2C81104485E7A01CF6Ce220dC6",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x5fdd6bc85013ce68f8512f9cd833135e0d4698e43b48a2bd3f1cbd21b0a390ba",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xB1C8d4dA0C0959921E081ca18d8c4f5762aE7c05",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x5fda67e2274d50fb63955db09382daf24270ae32f2924d31039fec3c50cbfbe4",
    name: "msETH / wsuperOETHb",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "945000000000000000",
    oracle: "0x28C964c985fe84736fAdc7Cf0bBd58B54bc7CF93",
    loanToken: {
      address: "0x7Ba6F01772924a82D9626c126347A28299E98c98",
      symbol: "msETH",
    },
    collateralToken: {
      address: "0x7FcD174E80f264448ebeE8c88a7C4476AAF58Ea6",
      symbol: "wsuperOETHb",
    },
  },
  {
    id: "0x5f42e9a47335fc15507f0ab6ac362e9d0fcd2f6fd881852198824c5b01045cb7",
    name: "USDC / wsrUSD",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x1A2681baB91Dc48c56f858808f6A65C402e63b3F",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x62344be8CA1c339B46274a4017dd87AF436900B1",
      symbol: "wsrUSD",
    },
  },
  {
    id: "0x5f31c82184c4848e5d38f02803d9e5488c8821d951fd8e6df1e5d7bc43d242be",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x855FE22c3a8c982CF685453aE4691E1E18f18373",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x5f0d3dc00830b4fbbbb705beed9595aecbb1c68b8fe97a94da2917217228477a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x3D664C5Cd413ade29aEf6b28F692fC6De9E77280",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x5e5da1ad3921b325d933610674400f032dde3aa5ca5393ad727d9d11b15abf7f",
    name: "USDC / ACS",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "945000000000000000",
    oracle: "0x87D7BF2E5C93770c0b519C7390a4b65f26e9E9aA",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x838E6Dd186a7bf9F5C51207C5d6E4564f6B71056",
      symbol: "ACS",
    },
  },
  {
    id: "0x5dffffc7d75dc5abfa8dbe6fad9cbdadf6680cbe1428bafe661497520c84a94c",
    name: "WETH / cbBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x10b95702a0ce895972C91e432C4f7E19811D320E",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x5d96564285fc3830f51fe495f88c29cc1232fbca61ca8b6edc25bff921efdef2",
    name: "USDC / uSUI",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x6e49a6E8acE74629b02F54c15cb933535808f114",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xb0505e5a99abd03d94a1169e638B78EDfEd26ea4",
      symbol: "uSUI",
    },
  },
  {
    id: "0x5d1570a519392310ddb58b30539639e68b505cb18998dcf90bbe9af83c6ef1ad",
    name: "USDC / bwPT-USR-25SEP2025",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x6AdeD60f115bD6244ff4be46f84149bA758D9085",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x235581dE8D392Ef898eEA9C443D813fcb86CDeb4",
      symbol: "bwPT-USR-25SEP2025",
    },
  },
  {
    id: "0x5c65d73b86740d82acb00c221de4a3cf8057f084294075d7fd93f0bd3b514b3f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xf71185b74707f09a8aDbaA44baDBd744193bA6e5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x5c641c4568eb4f24731ae7537566b1221ae4551daecf2b778b7b67cbcf936e80",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xAF0408222247198f3f4cDA96495D7Fcb9210338f",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x5c4d072a23a8edce9534ccf1273eb560d2f34f3a666f38425ca4f6f8df10e4b7",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x7B1F3c40887987496E90AfCb8E56eAae667c9DE4",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x5c346dc359b073c7dc9302b47a48408f2ab57525b8e31b40df14eaffbe5e6091",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x355Ee0abfB2d007f96d5f95a6337881A57bBEc74",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x5c173ae969687036e411ca9fb9de3f7b25c862d6e02af8cb982d2fd111a2fcaa",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x9AF7416b119BbA5C88CE5F5dF1F7aA96f3114c75",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x5c13ae3f007c8334ab45c293d4b0cb06b4b8370e142435508cbb6da5b18d42bd",
    name: "USDC / cbBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xD0D14B4944A751e14f0061a18c62c76220ADAD8E",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x5c0168749af83f3751dc849475f88438f16046e208171142397f96c3c90d72c6",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x10861aBa97DEd71108D5B9D2F6c9177e5A53ef65",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x5bfab528618e5cb1e9f72d1747fc3847f32f3a0d281ed28b3de46ab73d615119",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x3A74448D44c2e5Baf3485186a2c9E1e5d41289f4",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x5ba0d8e6b5ff5f0811f6db9dd5cb9675777c12185ec116b9569e090db00da2a3",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xAE282E996e94e8fa6291d4f5c774fE2e17ADB737",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x5b347b3dcfed096f09040cd30a174ae354ecc0a35c996493b8fa490d6d3e79d7",
    name: "USDC / sAMM-USDC/cUSDO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x4e0175f63BcCdF4A2eEb22d4c98ebaD4438ff6f9",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5feDe9d65714907381A76AA9bF949219dD1c5023",
      symbol: "sAMM-USDC/cUSDO",
    },
  },
  {
    id: "0x5aeff57f244d10e7128ff7b35c7b394f07a3ff316b316918ac2fa14b9655575e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xa0ED4Dc95E7c8C5Ea210FC51175F586F45e92903",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x5ac4161b4d9070a64fcedb84dbbc7b7a022701f6f9c79abfa118da144649606c",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x4370B02B151D881C0ec3B40ac7840BD76e9e678F",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x5a8a707842bcc94d88e8a1647a264b63ab4bc2e7f56c19d31e9865ff10a61b1f",
    name: "USDC / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x2F4Ed4191ed7A9951C3d31Db99356805B15bE86E",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2F4Ed4191ed7A9951C3d31Db99356805B15bE86E",
      symbol: "MDLP",
    },
  },
  {
    id: "0x5a6010a786bd71460bfca49526cb70ee2360c7998081bd23765e2d234f46951e",
    name: "USDC / stBRZ",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xa549916ed7D34B1050437f92C91A064611BdFCB7",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xe2A82e35AdB51c9A5a49c0a516C48741868C5060",
      symbol: "stBRZ",
    },
  },
  {
    id: "0x5a24250884b607439e8eb2a5bf7e4f6647af665936f47d0a8509ff783b3916ec",
    name: "USDC / wstUSR",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x31fB76310E7AA59f4994af8cb6a420c39669604A",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xB67675158B412D53fe6B68946483ba920b135bA1",
      symbol: "wstUSR",
    },
  },
  {
    id: "0x5a182a7da17d8de86199e1c8061c3d3de557b0b52c8c4a2236c3dadf84a1430e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x6224049fC3ace3dDdd36BB5C7d4C20Fa1e3D5f70",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x5a0a64296ccc21df776bbad4c1bec772ccc1b7295d83ffda2797877c8e58c0ca",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x8E6397d40d5A3e9E2E325da3F7ddD3Fb0fe8e5a0",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x59ca51b95bd490db7994f5169060aa15f2a80441cfc569d81acae302da4f60f3",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xC5863Db6F44055ac2A7c8CEc06556245A414bEc0",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x59900e45817714eebae29c2bc1bf0f7d1aa6f25bf7648a71812433b1852b13ef",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x503A521C629b51f1EC6524eA3A920Ad8A7cf5cb9",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x5977192b07af6dcdc0f34100709a5609cb2e82b961bbf509e1cf192cdf6a9c00",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x4E5c2CB83e726aA8639C56ab2858251BD5E0342D",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x593bab50998753e3fce6bbeb2d5bed5f81c93e97c813283b619569a92dadf341",
    name: "USDC / PT-USR-24APR2025",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xB09B22adAc243eF74122DA77d819072b7b3f2c73",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xec443e7E0e745348E500084892C89218B3ba4683",
      symbol: "PT-USR-24APR2025",
    },
  },
  {
    id: "0x5933a48eee90959fb1996c4792a6a56034a8765d66a3ed4179e86b7432817eb4",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xb690997D796aA1A7318dBc2AEd88F530F3dd169C",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x592517a07d8bad6e0467661583d3c15a1fee06b7b7506ac14dba250568f67b4c",
    name: "USDA / stEUR",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x8Fd7D211f1d6870aF2a328e23a0E563B09e13B39",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0x004626A008B1aCdC4c74ab51644093b155e59A23",
      symbol: "stEUR",
    },
  },
  {
    id: "0x591f763e88715b271719262448f604b8db2975e6b6d53426e69ed059224335d6",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x56f72Fc69c02a840C1570775F89F1cbC073782D3",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x58bf7ed35b5d213336a68a5a42dff58f03ceaf417edaad0fc53e046f1742e20e",
    name: "USDC / USDz",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xF9022589b3a33ddb3e4F5d0A2FBf3e028625c654",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x04D5ddf5f3a8939889F11E97f8c4BB48317F1938",
      symbol: "USDz",
    },
  },
  {
    id: "0x58b28a79fc7f55a58ef1052dda671d4a5949300e558f5e490f76a3513023ea6d",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xf84537401F7b3b861e8361D1d5D19be15A675afe",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x58a9a58a3420421e803f8140a7adb42c69d821e16105bcbe94153735b351eeaa",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xD4f84955CdB2bf210BfFCd9bD5b11B1f47535CB8",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x58a6be791dce086eda51733bf11f528d1f198a2bac412befa92a2332744c4a87",
    name: "USDC / bwPT-USR-25SEP2025",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x6AdeD60f115bD6244ff4be46f84149bA758D9085",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xc65B0C6881D6eae988B6F3d8CE956426bff8437E",
      symbol: "bwPT-USR-25SEP2025",
    },
  },
  {
    id: "0x5892b4715dcd668f7a8276c5d28ddbc04860b9caf474d1806585321a99aaca2b",
    name: "USR / LBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x12367485cA2E2B6f1da9Ec637dDa024c3C802eeC",
    loanToken: {
      address: "0x35E5dB674D8e93a03d814FA0ADa70731efe8a4b9",
      symbol: "USR",
    },
    collateralToken: {
      address: "0xecAc9C5F704e954931349Da37F60E39f515c11c1",
      symbol: "LBTC",
    },
  },
  {
    id: "0x58796f1483fa7b7eb2eae0405aa49ecf806a37420879499720dc7c6c5923ab72",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5805d1E80D9EddCd8F738658894EEDC41D030d28",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x5840dd9a1624e8e84a975abdcad59b9f9168ef03bf9d0203b0bb5041948da62b",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xaF82E351FF16546a3b23c5c6667daC68D62a8CA5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x580b0cfee735c839af1d15f09c8885ee6305a8bbd4fe14ace0b01454e57f48da",
    name: "USR / PT-USR-25SEP2025",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x269e68ddA3dA98F328EB58B4E66EcaBc9aa30D94",
    loanToken: {
      address: "0x35E5dB674D8e93a03d814FA0ADa70731efe8a4b9",
      symbol: "USR",
    },
    collateralToken: {
      address: "0xa6F0A4D18B6f6DdD408936e81b7b3A8BEFA18e77",
      symbol: "PT-USR-25SEP2025",
    },
  },
  {
    id: "0x5797bac323103abb57457756785f69126abaa622707b3a379a172a0053b0baa5",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x0AAe1ACC69bfd1023FD309681047ff0b19e10392",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x5782c3e4595a593ecd3a75fdb64aa5edcab803df6d4ac154c22e5b2a8da56c0f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x1FD118570E703fDaf4cf25479533A80aD2B2dc13",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x5779c26b67acb6d8b14b7539f8fae8d98c6f4c59727b5bd90c560d83fb7c5680",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x0EE056fFadDCf2ecde96c0dD7f9D69992B2141Cf",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x576db1fa04a04b81eaeb36d14c16730bcfe34c8089abe1a204032e160b459157",
    name: "VCHF / cbETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x261E5E73bbaa644918d97366DCd2576E997f8053",
    loanToken: {
      address: "0x1fcA74D9ef54a6AC80ffE7D3b14e76c4330Fd5D8",
      symbol: "VCHF",
    },
    collateralToken: {
      address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
      symbol: "cbETH",
    },
  },
  {
    id: "0x563a3e1ad768c9963a1778f78919482cec60a1603aded3dc228b70e7abf424b0",
    name: "LCAP / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xBe3997Eb6CD335BBEc14036C0DDbD4Af6cB69eef",
    loanToken: {
      address: "0x4dA9A0f397dB1397902070f93a4D6ddBC0E0E6e8",
      symbol: "LCAP",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x555db45da8109b3140dd245f27f3299fafae200c3964b145d5c9194a347abb33",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x999beB4466cEEd478956D8Fa6F36742A599A3F32",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x553d961ab96a25a55f3614844e67b61164730caedac6c1dff88e8a6e0fbacaa7",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x2d7F5785a6a29f4c655fEd282D9d7b9C8e1bc1Dd",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x54d6a77297d8c5dce4efb07cab60b1014b117675a648673c0c9aa6e5cebc7f01",
    name: "LCAP / cbETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x45bf98Cfd89BaF738fe31159a761BbA8137266c4",
    loanToken: {
      address: "0x4dA9A0f397dB1397902070f93a4D6ddBC0E0E6e8",
      symbol: "LCAP",
    },
    collateralToken: {
      address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
      symbol: "cbETH",
    },
  },
  {
    id: "0x54c1fdc999361fdb4606824147ff56356afe19b641d1b6de6c4f4f8c41d9ee92",
    name: "USDC / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x2A591A447FbF8e7f8260557F4421833d97979fB1",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2A591A447FbF8e7f8260557F4421833d97979fB1",
      symbol: "MDLP",
    },
  },
  {
    id: "0x547c31fb5344961618b33387eb1b804c65642535e28ddbd9c7d85cd62e90785d",
    name: "XSGD / cbETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x04721727d669683783Cd012Aa61e96a76AB3F622",
    loanToken: {
      address: "0x0A4C9cb2778aB3302996A34BeFCF9a8Bc288C33b",
      symbol: "XSGD",
    },
    collateralToken: {
      address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
      symbol: "cbETH",
    },
  },
  {
    id: "0x5418f9dcd53549fc0cc8c276989ed94afbc9d1f84e4cb1e1bcbfca2d5cd85977",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5e4c1A40ecBA7511F44991cf6AECfEF01178F725",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x53ec33f8f3f1a96e0921dd5729633999dea5bb32a038c6d4a3af5274809ed794",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x55322Ef2606335DeB3276985fB77C9A43295DAEB",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x53e1c907254b18ec43a9b647c73783deee226137c65eac82ecd4235b1189c51d",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x29b97827D137Ed860623B57AE4634c671680D077",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x53c44a05ec3cb933739d1aa740f9c58463a3e9277a361864caedf681f455f3be",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xabF4fb71f76A3678A5D507Fbc323f0da3fb6C26c",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x53a50cbe35c77c5c82d33f65a727972de76adfd122da35b7231057f9af08a50f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xACa880Ac1E0A5d3859d74064FB69B31dFA5367f3",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x536e3e39fd6c07148b38555e5e312e3874e1d08027e007d12822375524ccaa8c",
    name: "EURC / cbBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x565aF16131010d0C2Dce3518bDF7ac0e4E791E0c",
    loanToken: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x53604dcf2aa937f6c4aae2c9092f8ffb4c71c31fbcfc10daac47efee5eb73e55",
    name: "WETH / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x7e78505D714cc801a0A51cfA0E7870538310934E",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x7e78505D714cc801a0A51cfA0E7870538310934E",
      symbol: "MDLP",
    },
  },
  {
    id: "0x5333b764b565ab0d5fb5d9b2db3227ce42b062a283477a7782b46a2fed17a62c",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x20E00EB52Dd4a74c233e8d7Fb9a41727Ec763cAA",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x530c7a79b1b926e7f87641343c874dc51aee199b209f27570493dd5266f7018e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x72FA2dc78769C916Cab5193AdF3ca1374B068D75",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x5301093aee39723022f4d3c5b69ccca16f18642d35f5c07dab3e061d79b9328e",
    name: "USDC / sjEUR",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xE60ca21a8095278cD0c1503C918EA4Bfa8507Bd4",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x89Cc2A57223fa803852b6B4E65c6E376D49909f9",
      symbol: "sjEUR",
    },
  },
  {
    id: "0x52f04b08a17a9d5ab3d9eaa183917b8124662eb9aea279e17bd62a59413648a5",
    name: "USDC / syrupUSDC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x8e5581119B7a6737dD829Dc2FC364F498c0da50C",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x660975730059246A68521a3e2FBD4740173100f5",
      symbol: "syrupUSDC",
    },
  },
  {
    id: "0x52ddba20007f78d2b3549ed19e7e52c2ae3bc66d101201bd0529862eb3d445f1",
    name: "USDC / RST0003DB",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0xF53903e7cc1d338e605410BE746293954D62e423",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x7e919a97B42aF70E66dc8947C27E1a974A1c8d60",
      symbol: "RST0003DB",
    },
  },
  {
    id: "0x52a2a376586d0775e3e80621facc464f6e96d81c8cb70fd461527dde195a079f",
    name: "USDC / LBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x6E877Ff82A5ED6cB4f4789c27D9F9B1d54388e4F",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xecAc9C5F704e954931349Da37F60E39f515c11c1",
      symbol: "LBTC",
    },
  },
  {
    id: "0x51fdf2a64bc5be1ba553564f27d14c953edcb4052a815567487a06afd333b6ba",
    name: "USDA / mwUSDC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "965000000000000000",
    oracle: "0x7aa5885978807ae6B11170682d8b21FB1868a458",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0xc1256Ae5FF1cf2719D4937adb3bbCCab2E00A2Ca",
      symbol: "mwUSDC",
    },
  },
  {
    id: "0x51fa84487e61967fcfc700225fbdeedd1b3e2ce50b67b56813a27a56f9f455c1",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x0D4E6CFEB7DFcE864975276A1cB7bC1a5C71C792",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x5189c48e1d333d250642a96b90dc926c53f897d8b8f9e8fea71a4b14e9053fde",
    name: "USDC / steakSUSDS",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "965000000000000000",
    oracle: "0xFC79cd46ff95eB2c27077285c67A87be760A4593",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xB17B070A56043e1a5a1AB7443AfAFDEbcc1168D7",
      symbol: "steakSUSDS",
    },
  },
  {
    id: "0x515f668097bad3094197170ae09c2593a6593edad45a14accebb26f93a700e6f",
    name: "USDC / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x501A3CCcAa9f11F27c9a62D24700bCbbF848E2d7",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x501A3CCcAa9f11F27c9a62D24700bCbbF848E2d7",
      symbol: "MDLP",
    },
  },
  {
    id: "0x507f3f37ce3399ac8c232b1ebce5b8fdd3aac4fd8b274b4a42dbe33dd4df7e9f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x591770AE0b7A8Cc75531dA83dDdCBfDFa155De58",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x501571228a5d21a1d6da6b7490dbb7737c016722383ebc252243e1995a854967",
    name: "USDC / vTAO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0x1852873479f24A5aEE99353B0A64C918dB35b988",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xe9f6D9898f9269B519E1435E6ebafF766c7f46BF",
      symbol: "vTAO",
    },
  },
  {
    id: "0x4fe1e7e642af5d0714beee57796356d77d3d0dc965bafa2d86c0d68e9bd21edf",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x9ed58F0b0978e1EB33B88d59ed2d397B1aaA977e",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x4fa9384abf4afc5fa3b1bb9bf813c83bc40127592c3643f251d792e177ed3966",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xea5939e19160BD6f5A588F1879dE3906AE74c191",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x4f55f2f1a4bcb77aa6c84da2fde5641ef0baf8dee41015efbc8e606139d34fd3",
    name: "jEUR / stEUR",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "945000000000000000",
    oracle: "0xEDd96B8553DaE7fF443e1aB829448d450adE5B68",
    loanToken: {
      address: "0x4154550f4Db74Dc38d1FE98e1F3F28ed6daD627d",
      symbol: "jEUR",
    },
    collateralToken: {
      address: "0x004626A008B1aCdC4c74ab51644093b155e59A23",
      symbol: "stEUR",
    },
  },
  {
    id: "0x4ef78b768698d176833bb61682e01a0752a8b0b8da6718dc4b7059e80ddab13d",
    name: "DEGEN / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0xEddd2837f964c06aC45bd22f0608990Bb95CB645",
    loanToken: {
      address: "0x4ed4E862860beD51a9570b96d89aF5E1B0Efefed",
      symbol: "DEGEN",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0x4eb614e90daf25930baf6711eedfc11c3455593f8e793ecf53154ccfe21021fd",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xab4F7C68687e1718fE74765D7312aAbbaAFFAc26",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x4e99c01c3167e042f757a9a487a0e3b2277377e10fa9252cbef92fc00c0f41e1",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x1AFbED795bf19F3CC4bF7D98D6eD13dBAFD47Dcd",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x4e82e74588d21b5e4795fdf1937679b2727117f864fff1f10a6be49a5275d7f2",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x85155eB9f0Cb1F1FDAd6eCD4bD019ff3866c72eE",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x4e6d4a0d5ba50e08edeaef29530da50d0112dcddd81f994873c4f1ad3ad710ca",
    name: "USDC / vTAO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0x6e71ACd28eF0050d2D42f70d77cBadbb05dA96a4",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xe9f6D9898f9269B519E1435E6ebafF766c7f46BF",
      symbol: "vTAO",
    },
  },
  {
    id: "0x4e45a3a23003bfb081c2359934491b136b13f4fed7ff9c35e97dd98db8473536",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x51685E670C9CfA4E21C981993a9B9e1B33fFC71B",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x4e32b5d1380806b725bf9dfc28fbd761cfddfbaa8c02d4c07fd190c0cfa74325",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xaD6a406e405b7017405F39823857dBA57A0EC774",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x4e0b2fd87ce0e662f3c39f520684074cc5c1e6122c65df247123e6066ad3e805",
    name: "XSGD / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x6fDEC2b9F6b6721d37538692a74B71775507e2A8",
    loanToken: {
      address: "0x0A4C9cb2778aB3302996A34BeFCF9a8Bc288C33b",
      symbol: "XSGD",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x4dea1ab7491496cf68ec38f7321d3dbadd4a5ba8fbd4db8a0c01f5b4ed447529",
    name: "WETH / weETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xcE629400c6AEdb64f087CAC40Ae6a382AEEef490",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x04C0599Ae5A44757c0af6F9eC3b93da8976c150A",
      symbol: "weETH",
    },
  },
  {
    id: "0x4ddb64c0b92e9330d5c1833520469911e23ed22782091eddda2615d4135e7f99",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xdc8D0518f67b3F053BE00BAD5F5129abA13d416c",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x4dda3d40225ff86207164809ecd336f9908da885470c0526794f2064795794f3",
    name: "WETH / LsETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xeC6FEc10687e3Aff49A10A434b390D066BC84788",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xB29749498954A3A821ec37BdE86e386dF3cE30B6",
      symbol: "LsETH",
    },
  },
  {
    id: "0x4db55d1fd605c92f492ed9b395b9e673e0fc9345f37706f7672d12f6520398bd",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xCaDC008691A02E932b727379995045C204403e4e",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x4da3e496eec367c2fe7ba92c9f12a2d62a5de93166b2739cef852cd766576654",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x65E4b98665d96D1D83B507977BAe4B897aED32Fb",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x4d999edc7205d8f628e892538349ca9749b73eaf715b2325c4e288a2c64cd291",
    name: "LCAP / LBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x1B5C4A99754bBc4c559381c6844a10583E220E72",
    loanToken: {
      address: "0x4dA9A0f397dB1397902070f93a4D6ddBC0E0E6e8",
      symbol: "LCAP",
    },
    collateralToken: {
      address: "0xecAc9C5F704e954931349Da37F60E39f515c11c1",
      symbol: "LBTC",
    },
  },
  {
    id: "0x4d7d10043991286be87fff5e26fe829270f7d56f17ea295d165d6d4d9f4eaf74",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x08F567e76517167298F31599a6E657Bd464ba8be",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x4cfc3cd58c4f41cecff921dbf2e8112a2930690f79c815eff7378892e4bcb58c",
    name: "unknown / bsdETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xc866447b4C254E2029f1bfB700F5AA43ce27b1BE",
    loanToken: {
      address: "0x2DC205F24BCb6B311E5cdf0745B0741648Aebd3d",
      symbol: "unknown",
    },
    collateralToken: {
      address: "0xCb327b99fF831bF8223cCEd12B1338FF3aA322Ff",
      symbol: "bsdETH",
    },
  },
  {
    id: "0x4c4ef5d164901847a01dfa8abbbdd4c77622574267728a0c174c558bf5fbc609",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x219c96b2dB1D652b25201D5A9a054847d4B816A5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x4b35fee21f629085621cf2f21db3b4da6abb87cb3b49adc5c67162b8845b3431",
    name: "USDC / WELL",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0x245951c8a17Dd700a35a3CB6E2007C3E8D133F0b",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xA88594D404727625A9437C3f886C7643872296AE",
      symbol: "WELL",
    },
  },
  {
    id: "0x4b0dc86a86d800dcb85c31f4bf6d3795657fdd7db6e595b776959774c47d0a2d",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x2E6C140eFf2746b917f382Fd06Bb2e837C1CbE3a",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x4af3d3063f967552966566e659adaf7c45d2e6489c5a9844f3b744e6ff06dfad",
    name: "USDC / msAAPL",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0xc300405C5a91C7C8c990e270E4887f1fFD6b73b2",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xefD39475A463D865eE92c3EA055206A208450CF6",
      symbol: "msAAPL",
    },
  },
  {
    id: "0x4ae1f9076f1d49757875e84e8c91adabd15f9d4eb7fa3b2c1796ce7614d05bd9",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xA4e2974ECF6237b18592bdAC4e34a04eACEAfAd8",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x4ad0e0fec3685bffc5fcc98c1ad68437d99def33c1fa06f2061d7d84e5d2eee1",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x300476Cb00B1Ed8a0146EcAc501cbbcA8B2c13c5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x4abd143b181a7d3ba6d789decc4135442be4bd9dfb1f670ff2b6edce60fd708c",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x408658e5900aF8889b1C1FD1724e73452A7ab9B9",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x4a5ad65e776646260c7f62c14a71972fc3fb10f47551e652684a45805c57a585",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x1771DCD4ce0D3078896D84811ea712f99D1c1b6b",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x499cdc5323e7cc5d9d73909c98501029d6ac66dd57796bcf099a4a3dd97e30a5",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x06A15d80cBDc628634C5a035F6faEEB3665A9cdB",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x49829c2e4aff7c51dd32049497cc2f90ba3ef086ee3bd963109795992e51e378",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xc1779c72623eAfc371EceAFA397717bB2Ac4d37C",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x4944a1169bc07b441473b830308ffe5bb535c10a9f824e33988b60738120c48e",
    name: "cbBTC / LBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xDddc41f683C26Dcb8fE5f71De1b348Ce32e1bEe2",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xecAc9C5F704e954931349Da37F60E39f515c11c1",
      symbol: "LBTC",
    },
  },
  {
    id: "0x48cc95756d26737943d139b909d668b47075d2aa59aa0438fa4710da2db4fca0",
    name: "BLC / BLO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x3E579f437c7103f760AF0Ce5e63A73a686fFFD71",
    loanToken: {
      address: "0x5d81E33bf04162c8fDe897F543b265F3c5B51712",
      symbol: "BLC",
    },
    collateralToken: {
      address: "0x62144946065E128Ba468233e99b2403f4e3dE268",
      symbol: "BLO",
    },
  },
  {
    id: "0x48a9064e6003352f580a609faf55b421726afb605db76ccda335a4d0039e10d0",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x06F1578327653f53EADa8818057284ca715A4113",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x486334747c6dbfec73d7c4a8d9948c00756afc02181790cf596fd82405a54eb3",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x9a855455D075E27E74Cd83AcC96D80d8A7a55358",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x47e8676ef6ceb35907a11dc79b266f8eebebed1c881fa5a5f4469d3e707849ef",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x338dAeCA90928D38c07e8A2F95446857d1b8908d",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x4778ed944a4ae73b1f73b1a49b198afea279a07e85221ac086f95799c1d3d431",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x7A0550fF48b5ECBaF036e187F40be0bab6acE870",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x477246a485b747e9339bce9889dec8240cd3c285e6cc3993be15cad789d9d4cc",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5F5A3BAf99e45adD8faB960415A3BDBB9fCCCF52",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x476153439f8dc5eb3fd5258d4c0beb6365b13740c89ee5af265f3c0942b7005e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xb0c24f7fDE410dCE15f5b86ed863f988144F0255",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x4704522fb739e784648c9dba029f24581d475cea00eb14b5cc43eb43348a94c0",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x2A425c950D4DeeA5F730EFdceeD6bA718e6604fe",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x45f3b5688e7ba25071f78d1ce51d1b893faa3c86897b12204cdff3af6b3611f8",
    name: "USDC / mBASIS",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xc8b785c7524E79cF876f18A9035Fc778A40d3bc9",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1C2757c1FeF1038428b5bEF062495ce94BBe92b2",
      symbol: "mBASIS",
    },
  },
  {
    id: "0x45caba0e8ae7101fac65759c74d55cec0831820b798283f8c5418cd42d128125",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x2C56a0dd3d8797710689eC3FE25AD126AA4EC54E",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x45adf01e38f33b06460bba2162165150ea720f6e138b16f320e7c603b2591d1c",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xb242e2040C9bbe39662a8A073b4e5fDd56862EcD",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x45aab5dd7f19e7d2956cd4b5729d1491e20460a031905b1fa6b0731808c1a070",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x2AD88094b53899602319b97099B9B37c880D8848",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x458094dbd431b14f3cbc6da4fc55d2b24c786d8322b3f4fc94359e78532c0231",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x57C8990AAAC59d35776BFD931CfEcDf09DA98e86",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x455a7e903176099507bd2ac59b29291edac39a1d5c0f193e74419bc1377176c7",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x8aB7fBcC968df0705bDDB194C356C5d69Ae8A43A",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x450f850d0afdd772660b11b03740edc344a3ac93df7f4e026759e9b10f818abe",
    name: "USDC / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x26b873b1DBC333FD741F1E60d6E304220636649b",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x26b873b1DBC333FD741F1E60d6E304220636649b",
      symbol: "MDLP",
    },
  },
  {
    id: "0x44dfd81b37adfad16cfee6286efa3a94497e8d8d7190615112f8bc22f1af57f4",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5A1A980D58b7B309726aAC745Ca3fA9d6DCcB035",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x44b7bb8690720d54e056e7c3429e317665914e7f208d0e01553bf739062fa9f9",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x182DfFA6bcfe41d8Cb5e016815aD2fc05cDf1Ab5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x44b752f44a60529ccf1cb2c597a5257c66864367bceaea8deff87337f2b53159",
    name: "mWETH / mUSDC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xD09048c8B568Dbf5f189302beA26c9edABFC4858",
    loanToken: {
      address: "0x2e19814787ee3eD74d4874D58849a4d1c139c4B9",
      symbol: "mWETH",
    },
    collateralToken: {
      address: "0x90164F717864f5b89a73586E897B443d759f30ff",
      symbol: "mUSDC",
    },
  },
  {
    id: "0x44aaf6167c6b50e5ca862c5e0ffcf68cddc66604305fb0ca73dc7136de7410ed",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xB451AC11A4d2da4a2a1393B2fB2296832bCbB1B8",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x44a541171bb9abe4114c240fd387b6f26a81cc9ded508375f7c5a64aa2ea5091",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x483A01B1AB3381B69906ae1472647e5507563Cdd",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x4470fd52a3bcaadd552cb9747f6613f0157e0ba9ce45ccb1b0e2381362aa8804",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x07a478EeE7993ADE3993925dd19C048a03CD7e3d",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x44314b70717c14cbc77f9210a7ad8ba12414faad84a6d1ee632679607d8f48e0",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x54098b48F41c279F6A002F2350096a845C3F9b44",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x4413c2cc9e9323f23016e1275f7d7af8c4f5afe4936847415a61febf84f24195",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xB94B9877E012243187dC951D53c75357FCd229A4",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x43f3375acc542704aeb9055d0ee609ea31a9150548b998953935857aa7c0e0e4",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x9888020973960360f54127Abd81D93Bdae46C5F8",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x43a1e112dd479fda95c3cfcc4be38e967fdc85a550c167f114e0b27a7188b0aa",
    name: "wUSDM / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x00b2183B2D55B736EFDE3c3a4Ee2A88D9952B369",
    loanToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x43997b7916e236d42e37e39ca514be0edbcf87f17a75f12f0521e01519004da0",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xBc47Fee3812386B6BBDF77FC30D8D4F854d6f460",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x4300e584df460ca0a45d265ffac287ab01b6b8ab34927dc1d1a3db11229e7dde",
    name: "cbBTC / PT-LBTC-29MAY2025",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xab17154e09d4D037D16489470A9A7ED3BC817C86",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0x5d746848005507DA0b1717C137A10C30AD9ee307",
      symbol: "PT-LBTC-29MAY2025",
    },
  },
  {
    id: "0x4196315ec563cdd6d1bcd628c43c92a610df3ee852b94f37af8fc953fd9ab62d",
    name: "WETH / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x5Bd4514367eB6E4823686C79C3a9133e320dF156",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x5Bd4514367eB6E4823686C79C3a9133e320dF156",
      symbol: "MDLP",
    },
  },
  {
    id: "0x41640803a24fb0ac8a3c6a5602f78ff8291a6c6ecd87f23c8bc08e46f52033f5",
    name: "XSGD / steakUSDC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xF150aF4d084dc419B9c115D6a095813CF0B4b5Fe",
    loanToken: {
      address: "0x0A4C9cb2778aB3302996A34BeFCF9a8Bc288C33b",
      symbol: "XSGD",
    },
    collateralToken: {
      address: "0xBEEFE94c8aD530842bfE7d8B397938fFc1cb83b2",
      symbol: "steakUSDC",
    },
  },
  {
    id: "0x411a4381879e15c12216869017e2a173033257519aa2bd7ad7a1be67e19bd211",
    name: "wUSDM / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x40368704f5f331f18505Ce62133bb66B458eFD4c",
    loanToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x40d63b90a7a7823998538749694fff01887fa1f763d85599b53c44dbabde68fd",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xBA3C1CF63EeaA6281F1e5C82d791FA1898f017Cb",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x40ccaa373f53b6a60d0b32c7331d35d59528e4b2fbddb354f3722224fbddf512",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x17b6054B0e49AfA1963B6f5882BcFDB786eF5194",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x4069d3bac3bd6af9cacd042f3b2fb2b966e490c49a40d98db6cc8c8135e16a55",
    name: "USDC / bwPT-USR-25SEP2025",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x6AdeD60f115bD6244ff4be46f84149bA758D9085",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xD90E1c671121ef8B601880d84d4D8F8860dDe42C",
      symbol: "bwPT-USR-25SEP2025",
    },
  },
  {
    id: "0x4021eef32a72cd1c2bbf9203526bf17d10785de636b00cb1aaa6ca22ce1d1575",
    name: "EURA / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x3bdc48CDf69e8ac734F8165F6F17B78d6F83fED2",
    loanToken: {
      address: "0xA61BeB4A3d02decb01039e378237032B351125B4",
      symbol: "EURA",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0x3fac8c7fc4a1ad0fd64e2eca241a34214be017713255015ad87270af23cda9c0",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xcFB23333AC5Adc8a1987afD255d25288C9dc013E",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3fa37d9cc9922c120972c89ae0da86843e7e51c0dd04668e6fac3e7cd1ada1d3",
    name: "WETH / weETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xfb3ba172665D5953516821d05F7Db8A9D1B65355",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x04C0599Ae5A44757c0af6F9eC3b93da8976c150A",
      symbol: "weETH",
    },
  },
  {
    id: "0x3f4e7ba18fc88115d484552eed60150fc0c9778117c436694438d561e06ed635",
    name: "sUSDS / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x02a0eA9F5000472D764293bC77622be6C6Cbc2f0",
    loanToken: {
      address: "0x5875eEE11Cf8398102FdAd704C9E96607675467a",
      symbol: "sUSDS",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0x3f0499ad220b6766d45583dec1b1fb5ddd7545c61652b61662c7a0f764a82139",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x499cbC1e4441010c0C59a8eEf4f1f82E3f6ff8F3",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3eefc474aafc46df8fa31d36cde4c59998e471395c4f741b3af75b5962a4b23e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xd881BFA08F76d5CA1b663B163e8E87C0bf05CB22",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3ed20d0951358a4c1cc9e0db82ccdea42c3771726d985209585cca2fceef96fb",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x62998fA0106b32f2fa03058dB9F6Fb0bA674D538",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3e89fd4ea158a01e369d759c19bc3905ad11e3db1071e6de192548051c2a3c04",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x0F1daB6508D4d0f3428cDBc719EAD4692cfb5352",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3e55b36875d4e60d659743124cd347765da73c795289c40ac5a08a17a8709178",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xbDdcE2D9aCC4A69A074c05863D46Cab66249DB33",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3e47181b13be488838b52d12c14a2dc93a985082ec43d61189fc76ce24123b25",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x159a88AC9eA913bdAAad485c3944E3a291265e0B",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3e005f1216e17f0d00106d350b8003ada84f7b6c5efaf31e6719619772661754",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x27964be18CfBd48F9A0260cDA482Bcb6730e3993",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3dff8caf5c1391a17993f95ecf04779e35850dda839746214a446edfe0ee192c",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5E62E257614532B57767608A6A86532A9Cd6C923",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3de2bf0e1f2b6b9717235ba86ff86e4b97e5399acbf877a7151250ca640f3fc7",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xe5e9Ab6E15ef0f17718DEdeBE55e77E930132FF0",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3dc8f7282c3259277f6c620aea03f4f16bf096f7fbc85e71ddbbe1bac727eef4",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xA63fc887CCe33a740eA36Cdb68f4f4A31Bf25A1E",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3db13f46f9f646f3fa4cc6717cb09833724e28eb498a583787059a81c0bba023",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x09280Aa2feb69B3abB4cfbAb88f8Fb6e47208039",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3daa1aa5e8e3a88c2f85fa3269df97e58ed56ddff3b94e8881623a57ff52eee1",
    name: "USDC / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x483bc2B90C3E7427C1473F47B23ca7697fdfa9B3",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x483bc2B90C3E7427C1473F47B23ca7697fdfa9B3",
      symbol: "MDLP",
    },
  },
  {
    id: "0x3d7bbc68e6656bc4c296aad1ce3200cfb1f68d543a94631d43229b73aa43528f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xA6e57F89D5f8e7d66B824f99b5F92B5255C5d922",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3d7802c5e44f7a17cee848fd1defd48a49dba548bd8454af6d01e0daff77da0f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x3D6b43317127e0137a117F62117cBC43Ad42500B",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3d16d284db21d88c3fa635bcb6bff9fbd75d671ea03268e1425af8d0ac517755",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x9D9BfB38657ef735F8fC0581351360286f21463A",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3cee37ca53d340ffc76016a4402d7212f14d5bb9a6a6ec694a5116ea2417a625",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x4dfD9c7Dd1c3ECe739c41b8D2D0C98FB4831108b",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3cc22f4b7d2c3f94a5b1008e5f07b02aac731b47b3a9ad1e3304a4687a1b3cc3",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xA62e365Cd50b7e68DC85b29239DAFaAd0cD6e296",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3c8e87a14aea8c2084407281db40e09b6139b727e3ef5ae52100a3ce7afc2666",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xDD6E6c2dB46a4e508670998953Cdd87eF3288572",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3c41bb7bcd549d7526f0b223f1f5821cb4db5583667f8fed5a59d5556a1e4a1c",
    name: "USDC / bwUSDC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x4B129DB6d65B4Df1ca7CA3Ac853a74D40ccE92F9",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x3c0F801D5DD237c9c3e183B2de7A7E18AA6bea18",
      symbol: "bwUSDC",
    },
  },
  {
    id: "0x3c3babb6bd5ad584abc85f312134eb062725152d8b035027b7402ca5736eee00",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xFcBA6E0c4Dc307AC4d28CcE9849BBc6DF5efa7D9",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3bdf6c24a68f9e21e5333f7fed9c256867bf943f4f076fb1bf492077416061d8",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x537D583a6FD6D776a2CB1dFa11135cEe978F3D31",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3bd90ba926f6869e12dc58a4999bd87abcba4bb4c4c19e2a62e4545cd844a6ec",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x769F31dF79737716F4bf2D3ee372c2cedCDA9999",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3bd61c48d7e6f9092ae0f752fbe59b7ee9b80393936bc87194bf8c153d83fa4e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xae400fD38f1533aa0F72B04FFF52f717176D6632",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3bc94fc1eae1e9ac0ae511edf1607eb32ad0af7b4baaf468d4d2e392ca3bfaad",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xCf12b14342b9FAf8dA4D419126cfa6dcc73643ab",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3b923447a1f35c0b26820603a6997d9a637a0b2e0de2cc09d4eebfc743f57524",
    name: "USDC / KTA",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x8ced2FB8455c49906948200f5f89Afc9214c051c",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xc0634090F2Fe6c6d75e61Be2b949464aBB498973",
      symbol: "KTA",
    },
  },
  {
    id: "0x3b4b19b38900229039d79e381de0cfcca52f882d780ce69b381c902dfc4e4654",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x8fBf9ECDe3cf81486C93E9CADaf8fe1813ccC994",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3b3769cfca57be2eaed03fcc5299c25691b77781a1e124e7a8d520eb9a7eabb5",
    name: "WETH / USDC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xD09048c8B568Dbf5f189302beA26c9edABFC4858",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x3b3280b9b4cf4b6d124bd19f9310fd08b5e66ca827302210bfc0b43fb078aaeb",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xAa899806Df454c98CEBAc3160Ac0dAe317cDEF91",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3b0521add44fb77149113b3cd6b8ea1590af55f932930a995df05badba3bf20a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x7F1493e8AA4a5b2E35478c7EB94Fc1EE78D72918",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3b0284f11f5d66524ebf305ed3e1dd1300864ddd95eec323a62f681808ae7027",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xCdD0F9dd1Ae1fc94eF05d71AcCe6d4Db3D530053",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3afea4767d94d0f519950793b0826f8152c899268d7512bba47a27bbf89772e2",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xCC17f9ffe52428E0C301ff1Acb9cE8B3e4453d58",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3af9b76d4d638ae4a6eb95bb36ac471850ae6a34e189a1b16fbeb1f51eeb508b",
    name: "wUSDM / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x7Ba0abfbc100a7f71570082c17F6F7a05AD5CDC3",
    loanToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x3ae22844af50d2b62cedef5b3bbb1dcf8d2016f0b0c9b7a2096b9dd55a2f6cea",
    name: "USDC / MAMO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0x18d1325e8528E3ceafBf9a77F3bE3f76Fec42D5C",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x7300B37DfdfAb110d83290A29DfB31B1740219fE",
      symbol: "MAMO",
    },
  },
  {
    id: "0x3ab85145b4781ddc44ed959b7cbc18d2c3fce2f071f627785cf2bd0f6306ca5f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xEc7cd23F6740Fe86847Df074B94a19f4B9aE4258",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3a9d9b62bc9abe8fe2ddfc21ac386521d55c77685a80eb5484fabc8776c0e5c4",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x54A3887efDc276955B0AEef480714BC29c833689",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3a5bdf0be8d820c1303654b078b14f8fc6d715efaeca56cec150b934bdcbff31",
    name: "eUSD / hyUSD",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xD93F135Cbe98338bD8b7cA043AAD8FB1d86ACAEE",
    loanToken: {
      address: "0xCfA3Ef56d303AE4fAabA0592388F19d7C3399FB4",
      symbol: "eUSD",
    },
    collateralToken: {
      address: "0xCc7FF230365bD730eE4B352cC2492CEdAC49383e",
      symbol: "hyUSD",
    },
  },
  {
    id: "0x3a4b5bc4c4a8b9b323fc59d7ee663b5bd51c158c81d495a233c28c12405bad00",
    name: "vWETH / vUSDC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xD09048c8B568Dbf5f189302beA26c9edABFC4858",
    loanToken: {
      address: "0x7e0F7E9D8E75BEaB54fd0EE00B566306a171a337",
      symbol: "vWETH",
    },
    collateralToken: {
      address: "0xFc7F5f0cABbFa417b4cd8F8af2d91E830d874Ad3",
      symbol: "vUSDC",
    },
  },
  {
    id: "0x3a4048c64ba1b375330d376b1ce40e4047d03b47ab4d48af484edec9fec801ba",
    name: "WETH / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "945000000000000000",
    oracle: "0x4A11590e5326138B514E08A9B52202D42077Ca65",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0x3a346c3c7c20c4ce26108757cdc53831b96d8bfb954f0c85f064fbaf275c03cd",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x34d21932d19fF0F33C887103e3051B114EaC34fd",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x39e6357f9a99256adde4615e0ad0ec9a918e41c70f27275a077aa9e6717018eb",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x759ce4Cd03B330700B52F03f97ead977c60c49eC",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x39cba562b9ac038e0b653cec02a2a148ee72c6bbb5d537c6064e2973501d8ef3",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xB94864641402226BE4F8028c0229f590c1955f5b",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3989a3c9aafeb5b838765f6caba6918bbc4369c4f5e377fb521051e9e9a61948",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x3495Ae1c4df1E144D5b4fFA96d2cd7ea18A4a51A",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x397a071dc81cc4d1fd55a169d5ff0e7dff065b55f81b8903adeb692fb0d3dbb1",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xe41571BaEF26c11eb32D36C4A693b3817c00A1aB",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x395ec7a4fbbc91bb94c313d50cc95ee7e572ba5b85065a7168022cd4de464e1b",
    name: "USDA / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xD63F387882A0134c300e56a3d53070DD5f2a4Cc1",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x395d75048ba350d8c31b63b57b59bc3c087016722eff72c62610b58fc00843ab",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xf3825Aebff120A924a799600aeDaD1d57B0a2B3F",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3906b98860b550dfd8e36b24c9295c16bedae91db676c80a33e029accea76f8c",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x6c15584eE868C3Ff284b034ca0ab3f0f602c84f1",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3897f782d60d491dfc4def9ce8ec4ec8be29df84a582e148c9b888a8dbbe11ac",
    name: "USDC / PERP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0xab3a4EA9CF5BAd4dF01BB53d50efBBE1ED75De7d",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xCD6dDDa305955AcD6b94b934f057E8b0daaD58dE",
      symbol: "PERP",
    },
  },
  {
    id: "0x3858f17282016df1e08c920da8f55a16dbe98bd86ebc6871fbb507d877fb56c3",
    name: "USR / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xD63F387882A0134c300e56a3d53070DD5f2a4Cc1",
    loanToken: {
      address: "0x35E5dB674D8e93a03d814FA0ADa70731efe8a4b9",
      symbol: "USR",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x380fda5891046f31827933f1d7ddf1a118c990a563bbff1f57acd46d4400dc38",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x461338726451970F6d86f6F2FA59D219377EDBFB",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x37743c394f17d90d27d9f0db223b432b29f332c58dacf91ce60ef8ced541cdc8",
    name: "USDC / USDT",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x87F81eCD75a8b22D61A80C7FC41aBA285Bb38faF",
    loanToken: {
      address: "0xb48bcF35acD74E69BBDeF17cdBEa9DE9983e786b",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xfB9BD0Cde61c6aEDa32e8f4fA866dF87b2583d98",
      symbol: "USDT",
    },
  },
  {
    id: "0x3773410fae49399e9aa060ef788e729528475315f88906354daba6eec1bb1d2a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x9a8Ba837273608F74375bFc26B05A390AaA26b17",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x376ae539266b9aa8c598e999e9b6897fd52ca9193768b4cf562f46881fc4e028",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xF6c911319e11c7C227e428759f3659d32c68A3b4",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3762eb3e830d66dfa044719c3ce4b339e138f642a36be9f3c4de3dc4cd7fd506",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x5542139F127B003a3e879D709a59947BfE1fa558",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x372fbc67e5413d540560c4fee952ab104b1f2b5199d02dd5f69b6dfb4ae0fcb4",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xa55a567bAf3dbe9DB41C09fF76187C4a84604804",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x36e5fd4054f453deab29169af2d500f12096ddf414e839745127db09f82e950a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xa059F93E00719a22e0417e0B279AB4E4360FaD03",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x36d7e685b00277c7954c5582cc4e9f35062c243088d729d1d40e57141063890e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x4D4b3d677939fbe7c14BF5d15c54dCd84F807f7A",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x365d87cc7937020a57ecb149aec7fc66c08c17d35a0854674f0e3523b6c787a7",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xB94a1ccac2ddcd17F64303474A3aeb42c6fF5A82",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x360bd1665eba4c57e38e359cf12cdb0e3c8b7a4797a7db353209759ee2856dcb",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x1D7D24D057601018851be35Ee8040669E392caA1",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x35ffd015fa998abd4b33fa42de214f141d150ab663bd5b0844a477a53ac7e78d",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x473B435395d34538Bb01e29241d8e92475E9AfBc",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x35f9ac51dbf3c810b8084ad7145506890ec57de79fcbb586a9d6523e2b9b35e8",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x7462a334fe9cEB872F99cd316E38Ed3c80355DA2",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3576e98fb6a407593fa336381b5aab13275b1ee48658d65f7206ef0ec3e1dc3f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x9bB75ec8A71aabC139F14990E553fFbb39eEDfA9",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x35732d960f398b2dfd19e5159d6ab242a7c4767b3a7756c648565d783c95381e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xB86aEc118f50258d40cD6F18f5046935E433b057",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3505c13ed63fa39573c2f1a94a4f9bdacf48a9a34dadd48567df1d31e65440da",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xfDB42456Df3FcdA5DAc81cE768b329Ce8a8e8bE8",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x34f676bd8db106d6cdc90d0fb44145cea2f393310a794812cb1c5a8726b60913",
    name: "USDC / wbCOIN",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x0a7084ccc72b6CD10C0C618372a80AA975267cc5",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xDEc933e2392AD908263e70A386fbF34e703Ffe8F",
      symbol: "wbCOIN",
    },
  },
  {
    id: "0x34c56f73e6a7ac073e1680faac0a20f0b405aa52c58c5b59bcc04fdf3130c3b0",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xCE3eF9702976AB95a4988B4C56Dec6ad40481B68",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x34a45f63fb2a7140d2e10d2464e2cefeb5543b49362b12e1f9a02fe77bbcddde",
    name: "unknown / bsdETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xc866447b4C254E2029f1bfB700F5AA43ce27b1BE",
    loanToken: {
      address: "0xAdCdd085AD2887758255090589f72237bdD33D8A",
      symbol: "unknown",
    },
    collateralToken: {
      address: "0xCb327b99fF831bF8223cCEd12B1338FF3aA322Ff",
      symbol: "bsdETH",
    },
  },
  {
    id: "0x342c92c1e854eeb7c45b8adaa71296c15914635650615f1534de56b8ab58734f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x7DeCc26369aC4F6D5B8d089D781Ad790c7BF5B35",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x3428e41e0f7afcbb72272b0b273c29d49262bd3ea4a803fda18e2c9cd9c4300a",
    name: "WETH / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xd723a1A6b7bb1861a5F7d13fF9bc6a0B5C238054",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xd723a1A6b7bb1861a5F7d13fF9bc6a0B5C238054",
      symbol: "MDLP",
    },
  },
  {
    id: "0x341a11200a5d5b711eecac60809b3024f7b5169daf4e6955ffba3099127fb431",
    name: "WETH / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x8E99aF653f45732318E8d713f8154E4433ED462F",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x8E99aF653f45732318E8d713f8154E4433ED462F",
      symbol: "MDLP",
    },
  },
  {
    id: "0x33f1ebdec0ffc41e67b8d858c9c66698179ef7550fc4d9a709d6c91fc828f896",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x56013D772b1662F6d548cEDfa7D2Be2D8642BE1E",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x33f1224062064a7d90d95212f6dfd4ec7aa8f51027a33c091389c4c24c7e79b4",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x39a0c487914Ee9062D1020548ec8CA8331B88FB6",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x33ca69644bf4a700dc312b2f79e795dbeaf5e3ada1ad71307d92935e42fa636a",
    name: "USDC / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x17f72d1AEdD145E37d057ceA6cd593313896E767",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0x33ca11224477246663629de666db337ed375a32a110ed3a4acda7f6916fc4f69",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x0d925E94d20Ac095cdDd5F67d4921361AB9790E5",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x33c9bfadeacd42acc18da559c62cb8805252fb10027bc63c3f4fb33d96b94ffe",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x359e602a80C3bc859A89675a80BFEf5E9f5EaF93",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x33bd6f61fa695b445c8a16b6aaadb16050f0e58b516c3d06891677f6c0cd2724",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x6DA1956DBa54b7ff2Ac6a990280d8869cd2a65Fd",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x33a1d227d4ee631d9e4f8d5adce2de4ddde9b2820c7157040203822382d526c9",
    name: "XSGD / steakUSDC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x541de718A34F6DB1daeFbFC9510692Ada2b8FF78",
    loanToken: {
      address: "0x0A4C9cb2778aB3302996A34BeFCF9a8Bc288C33b",
      symbol: "XSGD",
    },
    collateralToken: {
      address: "0xbeeF010f9cb27031ad51e3333f9aF9C6B1228183",
      symbol: "steakUSDC",
    },
  },
  {
    id: "0x32d604c8fa69bbfc81b303a9a6934b589d59eb350f99c54f82755450755467bf",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x361F7fD86b2B3be21C15e88cefe6334b13e53125",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x32ab655391459b885cee183e15edd2572064f01c8b8d62b0817bfe9c9fa371db",
    name: "USDC / SKI",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x87487892C97094e370A0d4331be99696408c4DD2",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x768BE13e1680b5ebE0024C42c896E3dB59ec0149",
      symbol: "SKI",
    },
  },
  {
    id: "0x31d6fe09d863504112cb154c972158ecc87446ba32ce159ef88d8202efb1ae04",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x244a8E9EdF2c53D695CF9079e5aC3B88D9CCc22f",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x31d65cadef8eb085dd3bead61b987b3f86a7ac7d3e1f4763f6d4ec6a477d345a",
    name: "USDC / efixDI",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0xF4e20ff5a1a3B6251b2c460c6b221a52bED85aA9",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xF5cA55f3ea5Bcd180aEa6dF9E05a0E63A66f5608",
      symbol: "efixDI",
    },
  },
  {
    id: "0x318d842c4d46b21b7e3f1663d98241c945a5041ecc379c1a5353c3a1f49ca48a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x76D5390Eb78750924954f0f0844f7E0B9421b358",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x30f656ca015d18407e6e373937efd5e85b2125004627189f0876e9fca6ca4b75",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x69FB26f75c38805749F76C733FaAe1A731E8F1D7",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x30df8445a8836bee47df8f8ef1166320e05a61fb287938f1ce0e804b471809be",
    name: "WETH / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xbCBD21c1f6Cd6bf6d21cCCED718DAD9514658273",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xbCBD21c1f6Cd6bf6d21cCCED718DAD9514658273",
      symbol: "MDLP",
    },
  },
  {
    id: "0x30cbb9cc87e9010d951a222c739f5ec06c4b07bf148653b4a1c2a7cebbd23020",
    name: "USDC / axlFIL",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "385000000000000000",
    oracle: "0x2DC205F24BCb6B311E5cdf0745B0741648Aebd3d",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5E2Cf56A562b1bDD32ec26315063074ADC420C73",
      symbol: "axlFIL",
    },
  },
  {
    id: "0x30767836635facec1282e6ef4a5981406ed4e72727b3a63a3a72c74e8279a8d7",
    name: "cbBTC / LBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "945000000000000000",
    oracle: "0x9Ae0E86e88AEE94B700240eBE0BD17D969BAD0EA",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xecAc9C5F704e954931349Da37F60E39f515c11c1",
      symbol: "LBTC",
    },
  },
  {
    id: "0x3059bb96456660b6aab9a53fa219197d3a2e3f693288e4bda2d304b1d2c5358b",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x18EC48F6cD401EA637De17e2e4e7C7B95EbaB393",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x2fccc8a5ef5f742df746f73719d237cdc4d81f7e20f4437fe0f1d39472a0c039",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x8b1b292ECb0C54821927CCb35FDa765A1CF9B8E8",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x2f8cd00a50bea24e7368dec9d73b44671b126eb8de9c098ed7aafb282664b837",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xb4b1949eEC02DecfedA1844C89b666b1218eBC05",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x2f8c770012018566ef3c594275049ee793f3e64194eb59e3a05b2c91271955f0",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x8D80da52BAf661cA91F337278eF83F68EF436Cb4",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x2f58e57f781e2e6f03d82d7f693b6ce06508203378d78a091e917064e9d84891",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x01a7c25B780Dd5FBbD6F6973803CFc3A3307A9a3",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x2f3c848cdb72a45a32e2dee508252581f1f5c85918cf9de1d0e21c2e37b26b35",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xD1f56353423050b1AB5Bd6374ed66CB39664ee1F",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x2f17acbe15f1f55c3dc469059b3a33d3e489c624fd9e8d6cc963be145ca4c563",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xED7D9969b35C9AB7B72FaC72a3FEd3fCaAC39435",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x2ed95c3c41c36db6e2d1fed59008ce33d28c2f39cb63131849d42e624303ab1d",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x56dF47EB456A9D98e4F4632A50404C1b22A1baB1",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x2e5fdd9bdefaed121fc5f53a2e4a91dd924b642f5c1d990a9a39b552f2bc84ca",
    name: "PT-wcgUSD-18DEC2025 / USDC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xDed001cAf296Abc25671D7ec5b4d03Ea4650936D",
    loanToken: {
      address: "0x6aB33A86B72E1d343730c6030FFdA992CD43035e",
      symbol: "PT-wcgUSD-18DEC2025",
    },
    collateralToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x2e5808917deb630ed3d270ba0c149f074e31b837164c021ad1247c86100e3bff",
    name: "ntUSDC / snTST",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x904B800E655526b71853304e72a12C72cfE5C91a",
    loanToken: {
      address: "0x7B20e626775EFead297550A80f6E7B5fE9795F38",
      symbol: "ntUSDC",
    },
    collateralToken: {
      address: "0x0B3EfaC0D59B65c5Cb17933E101bc0429E366590",
      symbol: "snTST",
    },
  },
  {
    id: "0x2e2548390b8894d2ffaaababebc2b5f2501920e03a4c611b63b46e19bfc6b75d",
    name: "USDC / uniBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x9932FAbEdf44F52081a98f0Cc254ED4B22fBE3a3",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x93919784C523f39CACaa98Ee0a9d96c3F32b593e",
      symbol: "uniBTC",
    },
  },
  {
    id: "0x2e211437b3f7efbd1c016b9d492899735e831b8dd16cc5d58c66f1252693dd0a",
    name: "USDA / ezETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x4B5086653F9db675df31a618971e0EC26f6f081F",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0x2416092f143378750bb29b79eD961ab195CcEea5",
      symbol: "ezETH",
    },
  },
  {
    id: "0x2e166e1859a85fb1b268fb09c96573096ea89f1b37ac89b525576d815add686d",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x78Dcc4EAA72ddF7909813Da87DD4cC75CCCB654F",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x2df73267538dc78616ebaa48e340027c0f4cf8000a8e9b230450983ac566fa6f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x04262424402A8709a31d794c42CA1100C4DA97E3",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x2d3d754ec7d7e4ccf480d4e70c6666b9e2a8201b2415f49314f72418ff9ed68e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x3AD93390C9Bb8691cc886292806F6ea3D33608b1",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x2d086a5a8f9347cc8c4eaa4f1403e876e666646c34718fafe8280278c571a8b7",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x96Df483E4D9eC02aB872D5825E341707f1F77C7E",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x2cfa254d857fa00ec4c4b45fb95bbedf522b2dcb1eb636ab2b702b4d2234e41b",
    name: "LOAN / COLLAT",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x54c13915694dcEBA28231D44b8B2c671Df7ad206",
    loanToken: {
      address: "0xBeab9ebf75B3b06603AD69154BF1B440EFFBa140",
      symbol: "LOAN",
    },
    collateralToken: {
      address: "0x6c7fa1c5bbd16BE5be1F3581F9fB5a415E67AF89",
      symbol: "COLLAT",
    },
  },
  {
    id: "0x2ce8b29989e1bd924128fa5976ae6f135b11f3448fe287c5c88de946e97650a2",
    name: "USDC / cbBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x4846d4370fe1Ab623bC79eF3f8005679f809f615",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x2cb121430c352b0d8f6ee89221b6ad4eb6923681810ce8a42a4a5cd258dad7e8",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x31D89e0CC81ab104064CA6DB8d6b1a7C6983deD8",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x2cae35dac87d6d37ac47bc0f19e58ba844696c09982201085817b2e3513ca425",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x784d4F70B86dA42dFFaA3D055fFEE690F1986a42",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x2c3185f9841791f72795b937cda4364de40b70c9505c63aa696d0dc9c103ebe8",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5839559C3AADC117Ac2a22962594069Ce4cC8F47",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x2c10e050eb191f3e6ab9475a442d8d8b6a13e82dad7a9110475f4d22392a1a0c",
    name: "USDC / PT-cUSDO-1752537609",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x478964dddB1880B125B8031522acE00Eb7a32652",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1155d1731B495BF22f016e13cAfb6aFA53BD8a28",
      symbol: "PT-cUSDO-1752537609",
    },
  },
  {
    id: "0x2c00edf9efb680fa24fccd4d5e03fb3b5d2baccfe1fabc22825768e5ecca44c7",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x4390F322571BeEc7734b2DF63574c0558E03e603",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x2b6ccfbe0e9826d95fd3de9f6177546907ab1286571564efeb7ed014102248ad",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x0F0aD7873E95953EbCC20f47F53377F6db15e289",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x2b4f54fadc70839c5bd44364e41d14de86bd21f3d920c3f050bffff5befb27c0",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x24e4fb396FF65ECfe40ad84Ff8b06be6CDCdb1f7",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x2ad478dd0a82a426c1679750d081043f0fbe92f17c0bfb14929c7d8015cc3024",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x6615965f1048Fc6A042Bee629E6567F39A3283C6",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x2a673be413bab63e89fa4851e35db45f5c0679e00a21175ab1a988db1f527e0e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5303941cAa425FF3De1e92296987192968F2920a",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x2a366fd267a5fd882c791781e3956e38b68108b4c17a9bb8090b90b37d47e0fb",
    name: "USDC / USR",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xD28F3a92E238E622981d99a87C8E8Bfdf3A286d1",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x35E5dB674D8e93a03d814FA0ADa70731efe8a4b9",
      symbol: "USR",
    },
  },
  {
    id: "0x2a0a2f956c294478f47a1849bb0c356887751262bea03ac319882dae6ff7dfc6",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x596394E62b56Fc62687bE69B4CF00F81b8406877",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x29f35067047d9956031d0d429bc845c78af2e3e92685dafa2626d8ff80f947f4",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x197dbFE18C15f45bA54e1AB8C16d6cb978416D09",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x29d26625e8fb39bfcf675ce40fa4d4511e7fdc430c53cfa0e07de08554a1f83d",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x5146B6B454eF7e71CA070628F82bD6020f74D64A",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x29612a130b52628e2b90b42428f91a2e0ef560af5ab79cac89d130f895f255de",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x267062F7b36Db59A3adC51F3647219330A1d3cE7",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x2951c3c993c6c9fb3dddf65ce41ba879c78feaf30c4bbece99e19e72c29cf6f5",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x8e55C3006fB642C992Ad30C803A7d916ef527c70",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x2950483000a5662c77e3fc727e243fd7eb32cf3c4e07325fe81613b66e5e1b45",
    name: "USDbC / wUSDR",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x18C55Ff99f27adE30d9706454D8821a7e699A6A2",
    loanToken: {
      address: "0xd9aAEc86B65D86f6A7B5B1b0c42FFA531710b6CA",
      symbol: "USDbC",
    },
    collateralToken: {
      address: "0x9483ab65847A447e36d21af1CaB8C87e9712ff93",
      symbol: "wUSDR",
    },
  },
  {
    id: "0x29349f3b7d0761254def57f5bb1abee15d0c65522ed8aec4c4329d57affcb497",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5E1c954ae013EC532D5EccD7648e06560913C6Ab",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x291ef5d95ede0aaf23f5c9f0cabd70fbe137042a67ac7d70c87f9576c094788e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x7D64f99a0E3Bf25a80C767f70FAE843d29e84D17",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x2906d3fd3ffc348ac8b78e5ca0e1e0b0eaa99a51af0b7a6558403b4ac2bc0d9a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xAEd0db999E73E370461CDe77f400731E67c43cc0",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x28f70cf0fc96c8fab89e542c52f821c7bf3a95ef51f7c71c07d81a07f6d55cba",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xa8B118313C1Dee9AEb783c81f448A8507605C95b",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x281e48b3eddde9bae4790e33d9af41d2bfc7425a116092935673aed2d1d044a8",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xdCB529Bc4d164D10C7e7AA829D32db87012c6b95",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x280820be3d7617fd9aae6924de1efc58f9220c402e41538f6556849da1a56fac",
    name: "USDC / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xd064A5FaFA3320D809765d38e88967351E65416f",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xd064A5FaFA3320D809765d38e88967351E65416f",
      symbol: "MDLP",
    },
  },
  {
    id: "0x27ca9182f3dbea239a5d58335bea3ed18cb0f7e1c9f9c4cf732ad9d535015d25",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x4f7ea379f1a9CB193B9c023aF7598980a25ED66F",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x27ca2b6f56eb1e1dff16d562255721195d5fa9822f8f6fdb4f38b66c7c61a150",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x2029B3EF60730AA195148C9Fb29742B699f53ac6",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x274c7b512f837a5188952f852950bd7e01ee9e72b60bc0fe6bf4c6076ff3591f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5304aD43937B8EAd4B8DFe5A523AdeA8B32195f7",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x26ea8b9d16c55c1f62aab304d40ea7b42a53478c907ea77a26157ea7f72ab736",
    name: "sUSDS / cbBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x97197Ee777B26989B542E68b19cC8c5C51b669Ad",
    loanToken: {
      address: "0x5875eEE11Cf8398102FdAd704C9E96607675467a",
      symbol: "sUSDS",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x261854c4c2c460f601d4a60208953af746b4d058980e19f54ab40396ff8a912f",
    name: "USDC / bsdETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x8999B80c4620D803C9cb520391a52C3A01bB67eF",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xCb327b99fF831bF8223cCEd12B1338FF3aA322Ff",
      symbol: "bsdETH",
    },
  },
  {
    id: "0x25abcfc7bdff02d81db1ad331f4e95ed6364c8e912cabb76764701109ec0aa8a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x18aB430A63E512E3176a094Ea19F71aa755F55d5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x2573f8e08334e0f5b7656f78c72ae6c69d6341c7aa0ef881f2104d5a5f7e6713",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x6f4572fB99217af55aFAb03c604feCCf7464210a",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x25322b6a819118e15fc50f5d2ef538641dd5a233cd7efb12729964bed79eb089",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xbC21C75C8A6F636017DFCE2F273C795d47209931",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x2524eb86c2ab0f4805e1d7d6198589bd7501e2a780a42ee5d6ae08f5476a3880",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x97b0396F730B35Faa2D9dF66EEb7E634F67D2e6B",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x24671820d07d04ec33698c12624be903bfc09e7c80f9e049d533d71cacf8798b",
    name: "jEUR / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x3bdc48CDf69e8ac734F8165F6F17B78d6F83fED2",
    loanToken: {
      address: "0x4154550f4Db74Dc38d1FE98e1F3F28ed6daD627d",
      symbol: "jEUR",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0x244a9e22664351dcad5994a8265d65b2624902f4783426f0b60ba9a844c6af8b",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x3B9B1ae449D8c1CDbc4f623C92E6Ec4B5F407a5c",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x23602f6b02b42474dae180391dc46ea8481ed7e7ad9085ea10210432acc75ac0",
    name: "wUSDM / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xC04C837a115731CfEbbF65DCebDbd08d8Ec7EfbD",
    loanToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x234d8e41a0e2afc346ffcf96f8eab5c9e6b46a03c89418dc8fba306eac00ffe9",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xD634Ce33303FD33F4C983C797aA7792C042822A3",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x2311a531ae648e03be60383489c45a209b408a5fdff479290ecf439782ae04ac",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x93Fc8FB2B4634fCA503E5543Ece229B6F5a88E8B",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x22badc3c7947d2da1648c50eb351d1ee9759159a3dd8ffb7c5a3cccd8dbca884",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x95c600c78A13A13ed0C2549FEe97CAC70947C88B",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x226c34b5aa9422c7c13d649d3127992c4fad3fef2fa6da4f443c6a226aa16b4d",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xe77AC2D708DE06F2A22B6ADdADE136cD5e7f39d5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x222d28423895f96ac62fe0c1ad3aebcf96d0d9cd53d87b8e3343d0db26109a2a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xCe30565E99F25B9e21F3048A3698d18d87B32B80",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x22245a2bb61cfea92465b17fc860891890c073b8749843b5027f7fe891e2acca",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x1Ff902090446F9991F15D6F72f16680EB3059Faa",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x21e8b2cf4469c3b25a64f07fadca23764aa6ed74b209df4f99e8c90c12bfad56",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x3Edbe9708A7fb85D1Fc131eAb916728716C88D23",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x21e74d5ad7652fc99062ff01a578c2481e02b4bb253dff1d560c63d35df9b587",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xeeCB642A416d06C4dcadc4f7BDa8842FC95d67bD",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x21e38ab5c2b70e0f772e290bca1e58e9fd7bbaf78ed10819933e8362576813f7",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x50418e67Ed65B90f6c95BCD8e5fDE2601D14AC61",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x21d748d8c37d51f4c1506d10a593477a6a7aecfd1d45244fec720f37c065d9d4",
    name: "USDC / msAAPL",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0x8A6589F6dcfE3A935CA29d5322B9A2ed334bE79B",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xefD39475A463D865eE92c3EA055206A208450CF6",
      symbol: "msAAPL",
    },
  },
  {
    id: "0x214c2bf3c899c913efda9c4a49adff23f77bbc2dc525af7c05be7ec93f32d561",
    name: "WETH / wrsETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "945000000000000000",
    oracle: "0x55E6DE626D8b937782F08C8D3d9e54e340a78D0e",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xEDfa23602D0EC14714057867A78d01e94176BEA0",
      symbol: "wrsETH",
    },
  },
  {
    id: "0x212c0cb23b4d7fafa6ed7e8f14ce8fb525545f9f97c33e533ecc19d47939f34b",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xEf9Fb90a6B4040F62C01b8Da25B36af6934D3312",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x2126ad2ce0354c7d338da7e216bee9580f7bf985315f2078de87c52733cbf152",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x1b4D2Ebaf58B733891b149140bCCF45f72A99Ac2",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x20cd987b0b92365b549e17b6c5200ecc24032e4423a1badd7cc99d45fbce3c05",
    name: "cbBTC / PT-LBTC-scaled18-25SEP2025",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x6d83e8C55FC15bFceC78484C4328bCa73112727F",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0x7C3039d2385000cf366E3AC6AB9d7642E8440dd2",
      symbol: "PT-LBTC-scaled18-25SEP2025",
    },
  },
  {
    id: "0x20c3335036bffe0d1535a9adead0435daf46e9e9cbaad0e16fd76edc9e7d92ed",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x0349B9048839DeA25b38acC0390Ab129d7F6Cdb8",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x207925ad57a682870e7aeec82daa840de3bb386cbad753a8337ae6b753ac5bcc",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xbF8bd83D12594AcC5397cDeB8f7Ee9b0F2f5163b",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x1fe8bb2e930ffbff70c2383cf86286bd5f320ffffc7ef2789236a5362956a20f",
    name: "wUSDM / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x05A66E91cc2e972EC5E7D3F223D13a9B859b1dd9",
    loanToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x1fad9c9aaa0f407b276a4566672aa8d5903f7566575969007cc2482d4ae8d7b3",
    name: "unknown / bsdETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xc866447b4C254E2029f1bfB700F5AA43ce27b1BE",
    loanToken: {
      address: "0x5e331E9aE6E1a5d375F699811736527222a9Db15",
      symbol: "unknown",
    },
    collateralToken: {
      address: "0xCb327b99fF831bF8223cCEd12B1338FF3aA322Ff",
      symbol: "bsdETH",
    },
  },
  {
    id: "0x1f90f652f5747e928ba828f24bcb7c57307744c0bc4eaeebc5cca25bab85cda7",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xE1DE7dA1cf95D5eBd81c79f554375d6cb9770E65",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x1f648b26a5c6ce847d3c79a0901e87fbfc026f691063e9cf4616b7f4f6cf04cf",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xE5953d01C25d7795d21ada4Fc75c759B17040Cc5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x1f53013092dfa32484dceda87433598d15323d016e5040cb5ac4967d9957a8ed",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xf855732D4Ab401E559e15b4aC2197963E6a04BD0",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x1f30454c33c5a39848b224a67720c3de06c2b017125c00782b73d8ae9f8a7eee",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x285799809073ec5418Af80777Ed95360db1C1048",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x1e359b92220c5c7e138d74b7a278ffa826d29543159017693110036377a8348a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x4e3311aE8471a6a21D7820dB0B8FB1Ce34b7835E",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x1e32258a5a5fc0049e9a45934849809226e02d38979a54e1b38da9088d0387eb",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xbf8687d12FA1fdB0BA4481112D9FdFc3D3422612",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x1db939468f2b86327eaee46a2389680e8a6e44034705ea716a4c1be643b541c0",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x63803b3F5639E9DCa61E8872DC5AB4A44A865299",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x1db4adc14e99906fc9a9b3f3cc2698970eb8cd8fe0d50dca9a436698f6ac96f2",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x36F782f6e2e0A514cE5b24F5a9A1139262b1AFEB",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x1d891f37b0c80e3fdd97f5eb8a1535b60b51885f2d4a66dfd7156ffdf7878e5e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x31BB51CCBD5682b94b27d7A6AD7061306D8ef723",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x1ce8e16b4fdd84dbfa9d2c054c63d4762137ed01e2070da444c03ab0f400c10e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x7efDe88676c3816B3aabf02c8371EF41E615b1eC",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x1c9b65e7d9af40cdb0e236b10538b84ebf7b3ea348075e0243afb604cb54dbbb",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x8EafB96e6DAc2C32d240aCc6bE5BCCa9151dFaA7",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x1c5fb3d3ca5f8172415ea08a185132494bdb28a905bdc3d00e5003efdc95cf53",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x27dE28b03d0C768d4D50051FDdeC867BAD7a213F",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x1c21c59df9db44bf6f645d854ee710a8ca17b479451447e9f56758aee10a2fad",
    name: "USDC / cbETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xb40d93F44411D8C09aD17d7F88195eF9b05cCD96",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
      symbol: "cbETH",
    },
  },
  {
    id: "0x1c1c0818a23c61bcd55bd234b1f8ceeed8d1d614874f054585701cb978c601bb",
    name: "USDC / VNXAU",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x714D6Dddc7ea6C047E96E6520b7ddbA6B180DaEA",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xAc3FE22294beaED9d1FD752323a6d06D12Ff3098",
      symbol: "VNXAU",
    },
  },
  {
    id: "0x1c0b7ef209fb81f0dc49e84de46b988aa23c083449f6abc932f712439cf1fe26",
    name: "cdxUSD / mBASIS",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x8c31E247E1E7f343D45C2047f170070029e511EA",
    loanToken: {
      address: "0xC0D3700000987C99b3C9009069E4f8413fD22330",
      symbol: "cdxUSD",
    },
    collateralToken: {
      address: "0x1C2757c1FeF1038428b5bEF062495ce94BBe92b2",
      symbol: "mBASIS",
    },
  },
  {
    id: "0x1bdfb3f060991e266717a7a021d3d1c5bb21b1bfa2e5c6503cc7a7e42b172f47",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x66941953970d1Ce1b011Fe378D589f90D913da75",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x1bd6167078eb1bdd611b09015f78e831f8b7b372b4f8f329e86e496bde23db7c",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x41825c244b2a55873e67dF53579146cb71E286aD",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x1bb54fec002cab564e7fbd25352a90b7fdc6bf36b1e4cb84981e233eca60b5b1",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x0742fC448BdF674CCEE48c925927f3bE9eBC513E",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x1badfdf9d271b885960d89aed86bbce9e537599c5281e5d940b9edc3d9a6d8a1",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x501f67E110b480fE90E47eD286E5F3a27D99bA10",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x1a3e69d0109bb1be42b80e11034bb6ee98fc466721f26845dc83b2aa8d979137",
    name: "USDC / yoUSD",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x77f59C5C09e7ABEF6991B456170930324FE36222",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x0000000f2eB9f69274678c76222B35eEc7588a65",
      symbol: "yoUSD",
    },
  },
  {
    id: "0x1a1bb445348f06a85bf819ecdd417ab527656f52be26b57b4957911a0702feec",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xe8d1beFC17003C54489bcaBe38367B0A5383c409",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x1a1916bca78090437b37d559d827071970287ffe0ae5d9e38918e76664af4df6",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xEA1c8b52FC2E6673BE9314219B1341f85736E35C",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x1984bc6a3ed9092609d38047f245684f62a2b483e6dd9f417c906da044ce3016",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x166aFAd22430a07D2801fac1f91fB047f2272052",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x197d79f84d229049a780af9b3d418dbe2a05c2dd541268ae576483f14bd6b41a",
    name: "LBTC / PT-LBTC-scaled18-25SEP2025",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "945000000000000000",
    oracle: "0x83Cc4300AB7b006BF0DD1Cd82E884A582f0C2587",
    loanToken: {
      address: "0xecAc9C5F704e954931349Da37F60E39f515c11c1",
      symbol: "LBTC",
    },
    collateralToken: {
      address: "0x7C3039d2385000cf366E3AC6AB9d7642E8440dd2",
      symbol: "PT-LBTC-scaled18-25SEP2025",
    },
  },
  {
    id: "0x19606aa681073ed49499eda5c1ee892fe0ad3f70d23ebad3847d7237281cc187",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x1f1241A3fFfe5D9A33b1d4c8cb101bc63443de08",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x1915000ab2357bec80f9cdeafbe6dd97e6116ec78c466948d40c1e68a3a10eb9",
    name: "WETH / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xc2cBffD3dB2925DE4904C49867E6299e1cd164f2",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xc2cBffD3dB2925DE4904C49867E6299e1cd164f2",
      symbol: "MDLP",
    },
  },
  {
    id: "0x1850e151d8ae107b16026d61d6ccf0844451061adcdb51f956533fdbf1ed1f16",
    name: "wUSDM / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x3bd01430eAb36BdAFB3891Fb8b2B6a12Fd326E7D",
    loanToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x17d73db3b1642c8821668bf564a7623f0d4a1acf9e8b1b536ecce53e6d19c920",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x07c8aAaCFA1E7A153Ce9bdBc6d44ca9e6aB41315",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x17d1ba7a761ae5dbabdff86b23916523fed6a09da3bd5f90601661027c570501",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x717A85299206A84E9b821Be5dcEe502f9D525f7C",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x17821ed83ffef19f6cbf9655478af7bb5cd9b8faf8fb695ae450d340de1bed81",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xf800D53bf26771F26ef6E302FC1B5f1E997CE9F1",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x17275c8dbd6786860cc2be45af98ba1d3af0e696970535860efe742d3f7cf802",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x1641b9d230599B1498028de379860Fc0F46079d2",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x16b6216733cf1ac8330c8a4049e75dac9141f75e27dec7e3f6695ba35ad44ae3",
    name: "USDC / mTBILL",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "965000000000000000",
    oracle: "0x3D536487F4742c2303731C46799FC103Ae9b03dd",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xDD629E5241CbC5919847783e6C96B2De4754e438",
      symbol: "mTBILL",
    },
  },
  {
    id: "0x168df050b543b559df6405673b839c6d3bd83686cac702d8ba6c7942320cb8e3",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xFfB6f76498e5fEb57480D82c1d5a9E9537bEe27B",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x168a44bc357715b217ebeef6681559ae90cdde4d2ad39eea2de1827f2b1a0b19",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xBdD4730DFE8b48d78eDAb8c94CC2F4eec2Feb67F",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x164d3d6d1c32200bc505c958cf3cfccd3e574445fff3cba546f433d80e601877",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xd2D37C813d7C23A079A3d37f503823f6636AD3c6",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x162f268e82288b07dbda7b9f34d5b16e8a2c460f86dd612561119193019ea54b",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xE08D4D7EEc48A19D4244e76a46C13C180Ba3C62e",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x1629070628636ab5d79ec5711e95e666c7dfb3005eff9626757fdf55d2319fac",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x530644C9FD13b91812bfE09077301Aa7D7160324",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x15c88f08636ee915e145059e51b16dd85efe6412017d2dd62c7475173514ce7c",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x406b969C5756eCaD0EeDcC737Ae19D00a0cBC975",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x159d9633da94c51648beba29c9159ba34ab0c470c9e457637a2e059b93a59f1e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x2c1BCe3CfeaeAA21f2E046b5933028eC1E96d73f",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x15364042a547ccbf02bfc2698ac23c8ed0ffd582a7e1f2c9a55ed71eadfaf6e0",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x0E1e145E3cB1A72F27b611ea3f6E1f4c6ff0785d",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x151f3d9deb49702cb6fac5f066674c5ed64e782b842d3c2b3c13bfd8db17d1f2",
    name: "LCAP / USDC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xD5EC24b8913d585502950317Ab078cFCc437dCbf",
    loanToken: {
      address: "0x4dA9A0f397dB1397902070f93a4D6ddBC0E0E6e8",
      symbol: "LCAP",
    },
    collateralToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x1502318be3e10350c4838852f0f7dd27882403cd872d655e7e67230c2f6a4705",
    name: "USDC / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xa9253b68d366d9079d6A8C255f16Ee60149727F6",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xa9253b68d366d9079d6A8C255f16Ee60149727F6",
      symbol: "MDLP",
    },
  },
  {
    id: "0x14d6c8bd86620dc250760b47567936ccc838430ce9e0bb93b69d26b56c2616e7",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x211aDB0E06609CB14E2dD85092fD99e6531aC26C",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x14b0f0d994e0b14c93226147488b916379348156eb013cff755cfed72819f45d",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x2A1302317f05FBf17A4d30d6246B7DaBA93a7845",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x1478d70d1fde3fd5b8eb5766e82b03aa56a1df72a54fc8cd33aad666b0bd5008",
    name: "USDC / RLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x3B55c5FCd8f9A5C108aE1c50A29732D101F26730",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xC31389794Ffac23331E0D9F611b7953f90AA5fDC",
      symbol: "RLP",
    },
  },
  {
    id: "0x144da00c4202f8eba04c7e5edf2e47a0618eac8094b5b90c4a0a6b553dd2657e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xC11DA254614b574DE2Ca82bD11172DedA0457864",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x144bf18d6bf4c59602548a825034f73bf1d20177fc5f975fc69d5a5eba929b45",
    name: "WETH / wsuperOETHb",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x28C964c985fe84736fAdc7Cf0bBd58B54bc7CF93",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x7FcD174E80f264448ebeE8c88a7C4476AAF58Ea6",
      symbol: "wsuperOETHb",
    },
  },
  {
    id: "0x14160cf662c5eba5c3d4f1bd3bfec7b676a1454fb08a9c081b3244041f2cc529",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xeDBE0bD304eaebc45e666dFC4D3b4B7BA5879B5f",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x13f318e8312907c5c7d14e74d9080ee282e05034eca84dd0a4f48cf46e7bcbe7",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xa9A717493A21d0a2e7B662af5749ceAfe4A7e3c1",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x13c42741a359ac4a8aa8287d2be109dcf28344484f91185f9a79bd5a805a55ae",
    name: "USDC / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xD7A1abA119a236Fea5BBC5cAC6836465cbe9289A",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0x139bf3c128512aeaf0c28d7e3dcdf6fbcb940f6e2062a58f4179b090a85bd46b",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xb7058A09ce45133C7bcDe22A6eFfd94E64C8ce46",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x1363f5087791bde4d149ca41cd88464d875bc4eebc7d182749611ab672cdda51",
    name: "unknown / bsdETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xc866447b4C254E2029f1bfB700F5AA43ce27b1BE",
    loanToken: {
      address: "0x46415998764C29aB2a25CbeA6254146D50D22687",
      symbol: "unknown",
    },
    collateralToken: {
      address: "0xCb327b99fF831bF8223cCEd12B1338FF3aA322Ff",
      symbol: "bsdETH",
    },
  },
  {
    id: "0x12c37bd01e0050e15e85e37b6bfd9a9bc357e7881a4589b6873f94512af1ce66",
    name: "LBTC / PT-LBTC-29MAY2025",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "945000000000000000",
    oracle: "0x421722ca925A03E7896084fAF8B397E95ff7A199",
    loanToken: {
      address: "0xecAc9C5F704e954931349Da37F60E39f515c11c1",
      symbol: "LBTC",
    },
    collateralToken: {
      address: "0x5d746848005507DA0b1717C137A10C30AD9ee307",
      symbol: "PT-LBTC-29MAY2025",
    },
  },
  {
    id: "0x1297ee154328850724d06b10cb786a351a743c17e712278de39b794d1c630c29",
    name: "WETH / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x99D538F55E0710e6a165A9bfB7E70a04A6bA45Dc",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x99D538F55E0710e6a165A9bfB7E70a04A6bA45Dc",
      symbol: "MDLP",
    },
  },
  {
    id: "0x1285fefe96a7ca41f0bba1bf1a65201c82285368aea90886e667529f701c2f09",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x86b72A15a085AC0e50f457fC2367648328D88365",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x1263a1bcff3a9bf92a2670f04f522b58f4b160f75a86602a8ea254da30538a67",
    name: "USDC / ",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xa549916ed7D34B1050437f92C91A064611BdFCB7",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xf7dE27Ac1d8E0d2732cA021b0a937e8E16f9B2a8",
      symbol: "",
    },
  },
  {
    id: "0x1237ba6d83018e4de5de391319b5281a8806cfda0b0decbc1eae38a25618f46b",
    name: "vWETH / vUSDC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xD09048c8B568Dbf5f189302beA26c9edABFC4858",
    loanToken: {
      address: "0xD05b21a25c02d6634073E86b543e518AD9256D94",
      symbol: "vWETH",
    },
    collateralToken: {
      address: "0x28F2d4752Ae1EBDf955704cfa135486574B97421",
      symbol: "vUSDC",
    },
  },
  {
    id: "0x120353115870308d551fe8739a12df0876fa89b01adfd43c3234557edcef23c6",
    name: "USDC / WELL",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0x621F0C801fab6C028a8487BCC3243FaC2589396C",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xA88594D404727625A9437C3f886C7643872296AE",
      symbol: "WELL",
    },
  },
  {
    id: "0x11c54b5d8ae907ede2e5fa9e1952c37a6524e2f512604785cf274db33b5dd862",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x664b8C8cF52c3F68Bde36fb6a148C239D48e024e",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x11b7389b2143ed6160c965df3ef11ba2c3819017c5553ab38e4bd73bef2f3042",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xB3f83B5e39Ea084211eAFE3310493208492C568F",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x1174c7e0b87dc7fdb29f2e322baa626216110d7de16894e0a8f23b299d4b57e8",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x0ECc65f70B14983ac430BCD798d18BbB78d8e9c3",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x114cb7eb7d080f429de3ec00aa6731e6fa19beca6f92e1f2c6bf35645cbc641c",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x83933CFeE7c66e74c22E777e25b7dF57e89f545a",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x113d187984e5f8bf6911a400df532bcfb38fb37d692179c9fe02eb629b07ed9c",
    name: "sUSDS / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x6999f231968B8ea5288633388dab00Db80299D7e",
    loanToken: {
      address: "0x5875eEE11Cf8398102FdAd704C9E96607675467a",
      symbol: "sUSDS",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0x113840a5d42e718dcf40b5f7df5811c44474f42a9d80c8986b73d4ba61432be0",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xDB65563ED1b0C60D4615f6101688091845EBf1a3",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x112cb9e1e0bc0d86472ca500b1788fe74e9ebc92abb9d929af82db09d02ccbcf",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xDBB0501e2BC8528973db60c69775070bea71Af8f",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x112a19c519b6db62b031ca7f6c110c6e2f748d9ac6ae1c2bd533b317eaf1de25",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xA40AE621A71B8a8706120205E50a68A3D32254f6",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x11158babbd87929ae32060ffb206017ed0141bd3a3d64727b5857854c4b5b8d5",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x7BD683d7c2199D50A5061BEfa85155Ec1b786Bef",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x1109b8f1bac553ff1eef1ad052a07e3c4c634d44ea4738931adbe7052528a669",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x43EacdA59cbc27e750384544235042ba16BFB380",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x10d131547f8ded12a7a5647aa6c608211fca8a25f0126155e1daac0ba65cae74",
    name: "USDC / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xA121e16FB1DEf975C2B53C778a67b81926622687",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xA121e16FB1DEf975C2B53C778a67b81926622687",
      symbol: "MDLP",
    },
  },
  {
    id: "0x10b0ce8c2db5e51338caa54effa56c4dd450527a31b12d60e8a33e8fdaa4ebb1",
    name: "USR / PT-USR-24APR2025",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x3595FE49898996c4bE47C015770Bc5D15b9fCA68",
    loanToken: {
      address: "0x35E5dB674D8e93a03d814FA0ADa70731efe8a4b9",
      symbol: "USR",
    },
    collateralToken: {
      address: "0xec443e7E0e745348E500084892C89218B3ba4683",
      symbol: "PT-USR-24APR2025",
    },
  },
  {
    id: "0x109be89fed3e02ed576926a2936c7634f3e4b45e92470adbb8db8f0ecd199a6e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5eB6077a163386B3f1F29f2bBDcC3554EF3eF25A",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x10951a9bbb1016b926005c8234da7b2469f6886efaf0576d8cf0688ab5d6826b",
    name: "XSGD / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xcBd6186D211e14f27B19b3518468A3d9798e401e",
    loanToken: {
      address: "0x0A4C9cb2778aB3302996A34BeFCF9a8Bc288C33b",
      symbol: "XSGD",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0x105c9ac31809afa87ff1b67fb28d53f6a9485322eab6f1131759786ddabe4ec8",
    name: "wUSDM / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x315E302F06532af93141e13351170bc4974b067F",
    loanToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x104ff0b7c0d67301cb24e3a10b928b0fb0026ee26338e28553b7064fa8b659a9",
    name: "USDC / wUSD+",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x510A4C82f7eBf030aE2bcBDaC2504E59dF03b3E8",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xd95ca61CE9aAF2143E81Ef5462C0c2325172E028",
      symbol: "wUSD+",
    },
  },
  {
    id: "0x104cf8b7c6b038fc1ed98e264ab8c8d1627e09db1e8335b4cfc75f9ee0379f18",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5b7092c9423eb3Fa46Fccb5CF2C3E5413c4cf4f8",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x102a18bd9ddc2183785f56826659f9f93cc99e8a51d0871eb0f141c6948b547f",
    name: "aUSDC / LTF",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x89FFc45B5CF9783c2679E4a12091a44f9861Deb8",
    loanToken: {
      address: "0xc982B228c7b1C49A7187216Ce885F396904024F0",
      symbol: "aUSDC",
    },
    collateralToken: {
      address: "0x6D2B49608a716E30bC7aBcFE00181bF261Bf6FC5",
      symbol: "LTF",
    },
  },
  {
    id: "0x101d873eed77f20f9f4aa94379aa29a465ec4205a95395bd28359fef66881eb3",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x10739aD29990A3B05Ef01FCe681C5107823dDA53",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x0ff9c1630f782657b8ce09d20e3580b1de289160058fab2e7dc5fc0c5f8ec96e",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x6987315d24e9f5af7B1aa1F08034F7525e737103",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x0fee9aa0d28de8d4649d0cf92da0df6cf13f9a1bca2437758fc6b1b929c29163",
    name: "wUSDM / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xf93425861154C80Bc32cC9821d46cb0d9c335CB2",
    loanToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x0f377bc1bce0fcf9d00d91d12fcaef3f9ac903f476d7890953ca2c3aa3f7efdf",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x21EfEec57C1C191cC5931a9D3ce72A4a209E0cd4",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x0eff8d33fd5ce5d7028825b4e75bc6a3971d8802188f841c138342eab51152be",
    name: "LCAP / cbBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xf047736713D640974D66B64c5e1Ce663E1D16D18",
    loanToken: {
      address: "0x4dA9A0f397dB1397902070f93a4D6ddBC0E0E6e8",
      symbol: "LCAP",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x0ea98271ad28119782eac0cff2466a0db75755f6823f95b97fc9594671ff9227",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x1950C3d607f2Da3e2E3B14f86C257C9dc934fFEb",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x0e907d9d5df701118a0c6ce7c82376b8eb82b40d2336f8ed45dd6cc365324e64",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xbe9185Ef5cE6281b466e67ed5851d49E3B2319aD",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x0e45f5df2d9d17f034ff039bb3b4b173cfa24d9a9a3cf75b059fe96df2945514",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x849e9b87A3425CFD56fbB8Adc8031624931275b9",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x0df62ca6888a531729ba9d428a5989baf158305d6a8f46e65e92086f6b0d8794",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xABc0723BDf41a840bF2B8035A5eCD475926F198B",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x0df50b7250d2dc004d95605ba77ec42b78214bc93feeda34b2eebd4d4315e319",
    name: "EURC / cbBTC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x811deC228f06aAf9B743D1517298BB682f6D617D",
    loanToken: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x0df0f6ca33322cff4111c2b7ff9b267a71f9b63701c3cbdbbc61d054662b1d3f",
    name: "USR / PENDLE-LPT",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x79b1531b25Ad9E6F45A83DE0202E0ca9A713411F",
    loanToken: {
      address: "0x35E5dB674D8e93a03d814FA0ADa70731efe8a4b9",
      symbol: "USR",
    },
    collateralToken: {
      address: "0xE15578523937ed7F08E8F7a1Fa8a021E07025a08",
      symbol: "PENDLE-LPT",
    },
  },
  {
    id: "0x0d61907a9d789233d2bd69b59e01ec533cdbea7475c21cac972fbb839f15b8ac",
    name: "WETH / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x276935E0bBE1fd27F53e86E8C000B9f7A965a7c4",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x276935E0bBE1fd27F53e86E8C000B9f7A965a7c4",
      symbol: "MDLP",
    },
  },
  {
    id: "0x0d090f3c9534d606691234900733fa18fbc1cd55036d615d2b49e038b7bab45c",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x97c859762d67A9977a8930763a1D6EAcd9a9d725",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x0cbf2190e9ab1976f860a05e37f917ff436400780352d949478746af44d27449",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x6eECB4257334ccbe943172BCF3f7228885b20594",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x0ca10126f6c94cbd9cf0a48cc9516ae5e3dec5aa68303e6d988ee37c5149bf0d",
    name: "USDC / cbETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x97FF9CbD7E77348b2B8FfBB883bF29452aD18295",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
      symbol: "cbETH",
    },
  },
  {
    id: "0x0c1b4c8670f03a87548d6f7fa79118c98d24f3ea0d56e21934ef0f1b64f2170d",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x6E0b0f4E0Db956C1fBD40a517e73317104656a29",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x0c19c89cf654b541efbfa4d5bf03c7e7b3ae42eccc21cb53762cd68cc94f08dd",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xAa8E9144ACD323475Dcf6513640C4f3b88d63ab6",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x0c00055e045a00c4f1e55b25e0e524ada2a12aaae07d5faf18bdcb13be362c1b",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xA53cf78303A6885BF7c6E881F918a25b71c22601",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x0bddfcfe17bd5618cfe884e4a99439335956c5e4355444438c8750eb0fd4cc6f",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xd9C6bAE1eE41f3A9bE7D5843CE85416130688C3F",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x0bcd8b9ef55daa316fef799f0ab1522d20e55fd78cb182928b56a7bdaa902b3f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xD1ec42A0e0B5624Bc362F5A49964BAc714D80760",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x0ba88a4b93ba0844edb2a9d70efc4b2c29d29328f5d2d593f11ba26df8ef5641",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x34A3aAd20aC76E19C97F3328280036cdd38b5207",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x0b3bdf8627442f43607716b9e20475500fd62cb91bbb2c16c711e7c31038beb8",
    name: "MAI / wstETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x040ba460Ed355833a0693348421C7f1fd831D0c7",
    loanToken: {
      address: "0xbf1aeA8670D2528E08334083616dD9C5F3B087aE",
      symbol: "MAI",
    },
    collateralToken: {
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
      symbol: "wstETH",
    },
  },
  {
    id: "0x0b2df036bb06b49d893a8f5578cb5a31619f46d7a79cbf11783838204cfdf9e3",
    name: "USDC / YFI",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0x61c513038359b4bf3de4C6F07e3E559D2e083198",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9EaF8C1E34F05a589EDa6BAfdF391Cf6Ad3CB239",
      symbol: "YFI",
    },
  },
  {
    id: "0x0b1f58ee874a9842943817540c0d1f76420768066c4fd1b5cc1c4cc129e0192f",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x59342B1539600DAa8A987c7d9b355D7C9230D0E1",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x0af29fe95ebc9c17dc82df69953f2d1be0dd5c5353db755bf5e24195b33c68e2",
    name: "xUSDz / sAMM-xUSDz/USDC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "945000000000000000",
    oracle: "0xC200927E5265C94B55Ab9f39cAEEf7236E49403F",
    loanToken: {
      address: "0x0A27E060C0406f8Ab7B64e3BEE036a37e5a62853",
      symbol: "xUSDz",
    },
    collateralToken: {
      address: "0x72d509aFF75753aAaD6A10d3EB98f2DBC58C480D",
      symbol: "sAMM-xUSDz/USDC",
    },
  },
  {
    id: "0x0aedff711dc09437eb018574c142a50715c8d6d28d8fc6923fc151a37e96666d",
    name: "USDC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x663BECd10daE6C4A3Dcd89F1d76c1174199639B9",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x0a9424fdcacb9c5093de81f836f6a068f764ee02211282ffa1997c328eafbd49",
    name: "wUSDM / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x8B577d5D18eC5De0Cd9A1a811a2B339EC5cb1caF",
    loanToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x0a7a50f4349e6d39f1cbb79b41be8d23197eab9aee953b472548ebc0ab744adb",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x1Aad360B4F452858774fEb83b9cC771c7178f970",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x0a71a2937b43d08fc1c4f72e28fc46872c53c78470764340d467b6fed7c9c375",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x99bC23E52BbB455aE0EBD2C48838771587b7d877",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x0a2b68fcb9715a0a66bcab35338ff4daff6560157d672fbadb2c086abfc34606",
    name: "USDC / yoUSD",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x77f59C5C09e7ABEF6991B456170930324FE36222",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x0000000f2eB9f69274678c76222B35eEc7588a65",
      symbol: "yoUSD",
    },
  },
  {
    id: "0x09550f5332bd67448678931f9bc6b7c38a375e8f3d92e61a331a405f94604281",
    name: "USDC / PT-USR-24APR2025",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xc178b5a9e6DaB3c5af36f40E4178B555a30D7d92",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xec443e7E0e745348E500084892C89218B3ba4683",
      symbol: "PT-USR-24APR2025",
    },
  },
  {
    id: "0x093d3fd53c2fc0f98c322cef878e4c4c28210071a8870738e1c3babd9f054fd1",
    name: "USDC / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xE51AA4dc6Cc74933B6B2Ce84Edf5fcda748aF0bb",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x091e8908d5dc2916bc03c85ac72d6f9434c176b497532a94097101b0bec41cb7",
    name: "USR / RLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x690EfAE4B37e81d684F45117Bd8798ef5aaf0fba",
    loanToken: {
      address: "0x35E5dB674D8e93a03d814FA0ADa70731efe8a4b9",
      symbol: "USR",
    },
    collateralToken: {
      address: "0xC31389794Ffac23331E0D9F611b7953f90AA5fDC",
      symbol: "RLP",
    },
  },
  {
    id: "0x0918f1be3b13c3ca2f8a737496efc9fbcd5031b09145fe01851af74f850c4b60",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xe9a46E9819c0B9546FB27394B7742251d3B9f5DA",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x091677b866b775455c7360ced738c1b14f397560bd94e0633661675a952be75b",
    name: "WETH / MDLP",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xb463D28B8109c903Be29Cb005c11Aa7D667a2997",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xb463D28B8109c903Be29Cb005c11Aa7D667a2997",
      symbol: "MDLP",
    },
  },
  {
    id: "0x090bb600c50dd50358b2b513eba567070b4f6f874a1cac2d7af7ff4da17be5a9",
    name: "WETH / BondETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0xEBe83F314DD0a9940148cF3A7dF2e11A3520Fd6d",
    loanToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x091A5Abe6616e26268e5eEcFF256c2212fcE2707",
      symbol: "BondETH",
    },
  },
  {
    id: "0x089006e55711b39809d4247ec0aaa25e623a0a7cd25921c5cfa06e54506ce201",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xeB8Ea62231c95Af817b90f8769a7d2213Edca697",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x085eec55654482d48e0dea9e5dc98df3c01a52aaf28cfa2c0247f98933073967",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x33c27fBD858c08f59243e41d8e07f7dBcBdDff47",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x08400d01570535a9615cacfa0b5e61ae2cd4bfc1525404a1710ae24026925071",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x4ceA0bF3BB3E5482E6B84582Dc5103c1a69b12F2",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x06f8d1087cbefddda807fcf9160091c9929cf12470156c466daf2758c0a61ebf",
    name: "wUSDM / WETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x7D4691C2A11D7Aa099CC528c449e7A53c59e2c9E",
    loanToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
    collateralToken: {
      address: "0x4200000000000000000000000000000000000006",
      symbol: "WETH",
    },
  },
  {
    id: "0x06a69b7621d6930e061e0f7345f4a4d7c878fc1d22f2290e6e9850e1a82319b9",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xCcF46f3E0ADB813020710da4585453f86cd79A8E",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x05f58a0ce25f2f7ff543e9defd22c24ad2cd31783c925d4e7c2eeac9186492ab",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x5Ad53AEcb44a653f4979887c0282f2B4D643ACDe",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x05afdefc549f15b6bd08c59bb4c6d2230d75dc35c158ea97f1bc9c3e3517cf24",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x8715df9d74392d6A281a8458eF1b3118D6C689f0",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x058e4a2c1d742ac9c77785aaffa0fa81e2877d510ece3cedb3cce4ce6a8a6c83",
    name: "ntUSDC / snTST",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x06CAfBF8E435e7b6F732f2290e2A47F4e3f4E5e0",
    loanToken: {
      address: "0x7B20e626775EFead297550A80f6E7B5fE9795F38",
      symbol: "ntUSDC",
    },
    collateralToken: {
      address: "0xd73F8115Cac5B6817DcC143f3797a2Dc3650181b",
      symbol: "snTST",
    },
  },
  {
    id: "0x052afef1620a7d9f470a1ef764c5ad261a68914b90a58b91c592eb7da401b096",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x6A7d5232412A6e8988CDebac6c52EE0414D4e3AA",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x0515fbc5c7860ce6b4ba9fc4e7b73385c460807a893461fa76114c322f455807",
    name: "USDC / deJAAA",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0xdD514731d42EEf3BE273498247AC708EABd3D82a",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xAAA0008C8CF3A7Dca931adaF04336A5D808C82Cc",
      symbol: "deJAAA",
    },
  },
  {
    id: "0x04f7605a25699d0eff9f92908d25da8702ff59596d159e8bb66eca24b021d99f",
    name: "USDC / PT-USR-24APR2025",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x577CA5680C57129036904569C4b5cb9bDB949f4b",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xec443e7E0e745348E500084892C89218B3ba4683",
      symbol: "PT-USR-24APR2025",
    },
  },
  {
    id: "0x04ef6fa428b21a73e60bbf9ae58d8f830db453c0eaaab37434dc705223cc29fb",
    name: "USDC Test / wenTST",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x45cf875AC9bBDAeD33bF0eA8d1A3B8aEb45016fB",
    loanToken: {
      address: "0x06B9cd6E7fF41871F85E4777d26B805772d93e57",
      symbol: "USDC Test",
    },
    collateralToken: {
      address: "0x8139F7BE92b5Fd185c73f4eFe58eD6A43F6f5c37",
      symbol: "wenTST",
    },
  },
  {
    id: "0x049b72719882efe618ea2d2a33dbae57596d7ff989b21a00f48a0b72a6ec63ed",
    name: "BRZ / USDC",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x0b0E64c05083FdF9ED7C5D3d8262c4216eFc9394",
    loanToken: {
      address: "0xE9185Ee218cae427aF7B9764A011bb89FeA761B4",
      symbol: "BRZ",
    },
    collateralToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
  },
  {
    id: "0x044716380344f8165c1c7347784cbba0f85c62a9f77efff661d303549b68414a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x4A9056A317d6b8Bba9c9c80C0e3d810d3fcD926b",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x03de4dce15565ae821a90ee666468341cf6670c74d46fb5febd05a3d8e271273",
    name: "USDC / bwPT-USR-25SEP2025",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x6AdeD60f115bD6244ff4be46f84149bA758D9085",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xc3ac580967DeEfb5Dd3d6079032f2734e91CC59E",
      symbol: "bwPT-USR-25SEP2025",
    },
  },
  {
    id: "0x02be926e3e6ab6752365e5ff5b9835881c21b3b3c390ea1936021ef2ee248004",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xCc61e45AC8a2B92BB14A1629Cd04b48cfDcC050e",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x028ee235860942a33422640d2adf82d6df5f2e2796e98d3b38af87ae65afc3dd",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xb2697eCB951c52BD319e8d41Bc7dfCf9123C55D6",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x0273ce6613ec592b5078a2ed4e7e6ec77b2ba32c75ecbb1606097dc0d74fcb4a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xab640dEDD32B4983Cd645d50D761B323Da1cAEd9",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x026ecee9b3a8d0ce979837333349cfc2075a2af6cd9b41c1c1d9fa16c44e54c5",
    name: "USDC / ezETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "770000000000000000",
    oracle: "0xC9E90D1a6e769a846bcB332EA900d078E2F967B3",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2416092f143378750bb29b79eD961ab195CcEea5",
      symbol: "ezETH",
    },
  },
  {
    id: "0x026613102132845f930c4a87469cb7b713d001d963c9110fe0dc809947ee4b77",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x068B107586C142DF3506C2CB35C306377348e24c",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x02386ede2a39dc5f374cb6b22477838ffaa9a63075e8f7dd6a4bfd8b82083b28",
    name: "USDC / wBLT",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0xa2C18A3bF0ba86894717fc958F1Ee6484949b8A3",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4E74D4Db6c0726ccded4656d0BCE448876BB4C7A",
      symbol: "wBLT",
    },
  },
  {
    id: "0x021941339fae3291b789f3a4a545e887a4df6aaa9bf33b231ac5f0684c52e901",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xB2CeD7c027BeBE726550e041564a32A91cc8b4fD",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x018ac6ef4385a1b13886c9170a6f3e0e968268ff2bf988f66512f45607aa38f7",
    name: "USDC / WELL",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "625000000000000000",
    oracle: "0x71FBaD6c2200C8A5B89380f9B6bb8a35d411c852",
    loanToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xA88594D404727625A9437C3f886C7643872296AE",
      symbol: "WELL",
    },
  },
  {
    id: "0x017f24e318f06b555716a3852f33d01c6d04d52505936ccd7ac13322b137e596",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x908763b96ed9D1C2D6cd0e076649219d52A4FE6b",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x0178b9648627f41d0654de7faf5189f4bcbe0789764e33a6ef64a1452124483c",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xb3da66f97C1a293A67F8744235C871f272a4AF77",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x0150d51d33ea1637519e8310a132fd55d242d990626c415b4a2550eae14da6ab",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x2fd43c8DD8f7016AEc5fdfc919D5710Cd8463023",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x0138c47c8f7e0a785ec20a46edc6dc7747c8cd6e318d02f6506a5b6a5f5be7b0",
    name: "cbBTC / PT-LBTC-scaled18-25SEP2025",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "915000000000000000",
    oracle: "0x83Cc4300AB7b006BF0DD1Cd82E884A582f0C2587",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0x7C3039d2385000cf366E3AC6AB9d7642E8440dd2",
      symbol: "PT-LBTC-scaled18-25SEP2025",
    },
  },
  {
    id: "0x0106b8f9fac61d353238b38525afba066032842ce326b5296eab781389722574",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xBE0D6E5b3876e3C508Ad554C1B5CeFb054Ea97f5",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x0103cbcd14c690f68a91ec7c84607153311e9954c94ac6eac06c9462db3fabb6",
    name: "EURC / rETH",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x4ec7eD23F76A8F7C07a045745B501e7d903a903e",
    loanToken: {
      address: "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
      symbol: "EURC",
    },
    collateralToken: {
      address: "0xB6fe221Fe9EeF5aBa221c348bA20A1Bf5e73624c",
      symbol: "rETH",
    },
  },
  {
    id: "0x00f00245cf0061f5a75b0ed737dce5a90e67e69f7a4649e7c2badd4e641958e4",
    name: "EURA / stUSD",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "860000000000000000",
    oracle: "0x32B898e98033CA12859921618896764299661C10",
    loanToken: {
      address: "0xA61BeB4A3d02decb01039e378237032B351125B4",
      symbol: "EURA",
    },
    collateralToken: {
      address: "0x0022228a2cc5E7eF0274A7Baa600d44da5aB5776",
      symbol: "stUSD",
    },
  },
  {
    id: "0x00d45e1927eff2db027c2544d50dc8c8c96953f9524b50c5b90712efbb770ab4",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xC30134cA9F574126742974149065B20fD328be95",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x00adc6c0817624504109764d9b102a6e05b7e38f6a642d1692ea451d3929b34a",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xf9E4DBAF8f9328EF50d7A55a40DA8e19B1e269c8",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x002494a78a96b9a41e220425a6583dc6454e0429537e0491e5d1c3a11e350f43",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0xEe4B1208c3005Aa91c3173A6700069A1a2eE1037",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
  {
    id: "0x00219077aa239da531666a36ada5c92fda9a359750445635e85921624ca67fe5",
    name: "cbBTC / GMORPHO",
    irm: "0x46415998764C29aB2a25CbeA6254146D50D22687",
    lltv: "980000000000000000",
    oracle: "0x18c512f0F2c028E5ECE33E7585783EC9A85DA980",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xDa1C2c3C8FaD503662e41E324FC644Dc2c5e0CCD",
      symbol: "GMORPHO",
    },
  },
] as const
